// import { useEffect, useRef, useState } from "react";
// import Menubar from "../Menubar/Menubar";
// import { Outlet } from "react-router-dom";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
// import { FaChevronRight } from "react-icons/fa6";
// import { FaChevronLeft } from "react-icons/fa6";
// import { FcAddImage } from "react-icons/fc";
// import { BsCloudSun, BsFillSunFill } from "react-icons/bs";
// import { IoCalendarClearOutline, IoCalendarNumber } from "react-icons/io5";
// import { GiPalmTree, GiAirplaneDeparture } from "react-icons/gi";
// import { IoIosAirplane } from "react-icons/io";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { Check } from "lucide-react";

// const PropertyScraperElementor = () => {
//   const [loading, setLoading] = useState(false);
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   const navigate = useNavigate();

//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
//     const savedState = localStorage.getItem("menubarOpen");

//     if (savedState !== null) {
//       return JSON.parse(savedState);
//     }

//     return window.innerWidth >= 1024;
//   });
//   const [unmatchedAmenities, setUnmatchedAmenities] = useState([]);
//   const [fullScrapedDescription, setFullScrapedDescription] = useState("");
//   const [descriptionSource, setDescriptionSource] = useState(null); // "ai" | "fallback" | null

//   const [indiaStates, setIndiaStates] = useState([]);
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedCity, setSelectedCity] = useState("");
//   const [cities, setCities] = useState([]);
//   const [bedrooms, setBedrooms] = useState("");
//   const [bathrooms, setBathrooms] = useState("");
//   const [guests, setGuests] = useState("");
//   const [price, setPrice] = useState("");
//   const [amenities, setAmenities] = useState([]);
//   const [checkin, setcheckin] = useState("");
//   const [checkout, setcheckout] = useState("");
//   const [houseRules, setHouseRules] = useState([]);
//   const [location, setLocation] = useState("");
//   const [sourceUrl, setSourceUrl] = useState("");
//   const [rating, setRating] = useState("");
//   const [reviewCount, setReviewCount] = useState("");
//   const [hostName, setHostName] = useState("");
//   const [cancellationPolicy, setCancellationPolicy] = useState("");
//   const [maxbedrooms, setmaxbedrooms] = useState("");
//   const [maxbathrooms, setmaxbathrooms] = useState("");
//   // Add these two state vars near your other scrape state
//   const [scrapeDestination, setScrapeDestination] = useState("");
//   const [scrapeLocation, setScrapeLocation] = useState("");
//   useEffect(() => {
//     // Load world.json from public folder
//     fetch("/world.json")
//       .then((res) => res.json())
//       .then((data) => {
//         const india = data.find((country) => country.name === "India");
//         if (india) {
//           setIndiaStates(india.states);
//         }
//       })
//       .catch((err) => console.error("Error loading world.json:", err));
//   }, []);

//   // const handleStateChange = (e) => {
//   //   const stateName = e.target.value;
//   //   setSelectedState(stateName);

//   //   const stateObj = indiaStates.find((s) => s.name === stateName);
//   //   if (stateObj) {
//   //     setCities(stateObj.cities || []);
//   //   } else {
//   //     setCities([]);
//   //   }
//   // };

//   const loadCitiesForState = (stateName) => {
//     if (stateName.toLowerCase() === "goa") {
//       const goaCities = [
//         "Aldona",
//         "Arambol",
//         "Baga",
//         "Bambolim",
//         "Bandora",
//         "Benaulim",
//         "Calangute",
//         "Candolim",
//         "Carapur",
//         "Cavelossim",
//         "Chicalim",
//         "Chinchinim",
//         "Colovale",
//         "Colva",
//         "Cortalim",
//         "Cuncolim",
//         "Curchorem",
//         "Curti",
//         "Davorlim",
//         "Dicholi",
//         "Goa Velha",
//         "Guirim",
//         "Jua",
//         "Kankon",
//         "Madgaon",
//         "Мариса",
//         "Morjim",
//         "Mormugao",
//         "Navelim",
//         "North Goa",
//         "Palle",
//         "Panaji",
//         "Pernem",
//         "Ponda",
//         "Quepem",
//         "Queula",
//         "Raia",
//         "Saligao",
//         "Sancoale",
//         "Sanguem",
//         "Sanquelim",
//         "Sanvordem",
//         "Serula",
//         "Solim",
//         "South Goa",
//         "Taleigao",
//         "Vagator",
//         "Valpoy",
//         "Varca",
//         "Vasco da Gama",
//         // Extra villages
//         "Anjuna",
//         "Arpora",
//         "Assagao",
//         "Parra",
//         "Siolim",
//         "Reis Magos",
//         "Nerul",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(goaCities.map((city, idx) => ({ id: idx + 1, name: city })));
//     } else if (stateName.toLowerCase() === "karnataka") {
//       const karnatakaCities = [
//         // Extra villages

//         // Added cities
//         "Afzalpur",
//         "Ajjampur",
//         "Aland",
//         "Alnavar",
//         "lark",
//         "Alur",
//         "Anekal",
//         "Ankola",
//         "Annigeri",
//         "Arkalgud",
//         "Arsikere",
//         "Athni",
//         "Aurad",
//         "Badami",
//         "Bagalkot",
//         "Bagepalli",
//         "Bail-Hongal",
//         "Ballari",
//         "Banavar",
//         "Bangarapet",
//         "Bannur",
//         "Bantval",
//         "Basavakalyan",
//         "Basavana Bagevadi",
//         "Belagavi",
//         "Belluru",
//         "Beltangadi",
//         "Belur",
//         "Bengaluru",
//         "Bengaluru Rural",
//         "Bengaluru Urban",
//         "Bhadravati",
//         "Bhalki",
//         "Bhatkal",
//         "Bidar",
//         "Bilgi",
//         "Birur",
//         "Byadgi",
//         "Byndoor",
//         "Canacona",
//         "Challakere",
//         "Chamrajnagar",
//         "Channagiri",
//         "Channapatna",
//         "Channarayapatna",
//         "Chik Ballapur",
//         "Chikkaballapur",
//         "Chikkamagaluru",
//         "Chiknayakanhalli",
//         "Chikodi",
//         "Chincholi",
//         "Chintamani",
//         "Chitapur",
//         "Chitradurga",
//         "Closepet",
//         "Coondapoor",
//         "Coorg",
//         "Dakshina Kannada",
//         "Dandeli",
//         "Davanagere",
//         "Devanhalli",
//         "Dharwad",
//         "Dod Ballapur",
//         "French Rocks",
//         "Gadag",
//         "Gadag-Betageri",
//         "Gajendragarh",
//         "Gangawati",
//         "Gangolli",
//         "Gokak",
//         "Gokarna",
//         "Goribidnur",
//         "Gorur",
//         "Gubbi",
//         "Gudibanda",
//         "Guledagudda",
//         "Gundlupet",
//         "Gurmatkal",
//         "Hadagalli",
//         "Haliyal",
//         "Hampi",
//         "Hangal",
//         "Harihar",
//         "Harpanahalli",
//         "Hassan",
//         "Haveri",
//         "Heggadadevankote",
//         "Hirekerur",
//         "Hiriyur",
//         "Holalkere",
//         "Hole Narsipur",
//         "Homnabad",
//         "Honavar",
//         "Honnali",
//         "Hosanagara",
//         "Hosangadi",
//         "Hosdurga",
//         "Hoskote",
//         "Hospet",
//         "Hubballi",
//         "Hukeri",
//         "Hungund",
//         "Hunsur",
//         "Ilkal",
//         "Indi",
//         "Jagalur",
//         "Jamkhandi",
//         "Jevargi",
//         "Kabini",
//         "Kadur",
//         "Kalaburgi",
//         "Kalghatgi",
//         "Kampli",
//         "Kankanhalli",
//         "Karkala",
//         "Karwar",
//         "Kavalur",
//         "Kerur",
//         "Khanapur",
//         "Kodagu",
//         "Kodigenahalli",
//         "Kodlipet",
//         "Kolar",
//         "Kollegal",
//         "Konanur",
//         "Konnur",
//         "Koppa",
//         "Koppal",
//         "Koratagere",
//         "Kotturu",
//         "Krishnarajpet",
//         "Kudachi",
//         "Kudligi",
//         "Kumsi",
//         "Kumta",
//         "Kundgol",
//         "Kunigal",
//         "Kurgunta",
//         "Kushalnagar",
//         "Kushtagi",
//         "Lakshmeshwar",
//         "Lingsugur",
//         "Londa",
//         "Machare",
//         "Maddagiri",
//         "Maddur",
//         "Madikeri",
//         "Magadi",
//         "Mahalingpur",
//         "Malavalli",
//         "Malpe",
//         "Malur",
//         "Mandya",
//         "Mangaluru",
//         "Manipal",
//         "Manvi",
//         "Mayakonda",
//         "Melukote",
//         "Mudbidri",
//         "Muddebihal",
//         "Mudgal",
//         "Mudgere",
//         "Mudhol",
//         "Mulbagal",
//         "Mulgund",
//         "Mulki",
//         "Mundargi",
//         "Mundgod",
//         "Munirabad",
//         "Murudeshwara",
//         "Mysuru",
//         "Nagamangala",
//         "Nanjangud",
//         "Narasimharajapura",
//         "Naregal",
//         "Nargund",
//         "Navalgund",
//         "Nelamangala",
//         "Nyamti",
//         "Pangala",
//         "Pavugada",
//         "Piriyapatna",
//         "Ponnampet",
//         "Puttur",
//         "Rabkavi",
//         "Raichur",
//         "Ramanagara",
//         "Ranibennur",
//         "Raybag",
//         "Robertsonpet",
//         "Ron",
//         "Sadalgi",
//         "Sagar",
//         "Sakleshpur",
//         "Sandur",
//         "Sanivarsante",
//         "Sankeshwar",
//         "Sargur",
//         "Saundatti",
//         "Savanur",
//         "Seram",
//         "Shahabad",
//         "Shahpur",
//         "Shiggaon",
//         "Shikarpur",
//         "Shimoga",
//         "Shirhatti",
//         "Shorapur",
//         "Shrirangapattana",
//         "Siddapur",
//         "Sidlaghatta",
//         "Sindgi",
//         "Sindhnur",
//         "Sira",
//         "Sirsi",
//         "Siruguppa",
//         "Someshwar",
//         "Somvarpet",
//         "Sorab",
//         "Sravana Belgola",
//         "Sringeri",
//         "Srinivaspur",
//         "Sulya",
//         "Suntikoppa",
//         "Talikota",
//         "Tarikere",
//         "Tekkalakote",
//         "Terdal",
//         "Tiptur",
//         "Tirthahalli",
//         "Tirumakudal Narsipur",
//         "Tumakuru",
//         "Turuvekere",
//         "Udupi",
//         "Ullal",
//         "Uttar Kannada",
//         "Vadigenhalli",
//         "Vijayapura",
//         "Virarajendrapet",
//         "Wadi",
//         "Yadgir",
//         "Yelahanka",
//         "Yelandur",
//         "Yelbarga",
//         "Yellapur",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(
//         karnatakaCities.map((city, idx) => ({ id: idx + 1, name: city })),
//       );
//     } else if (stateName.toLowerCase() === "kerala") {
//       const keralaCities = [
//         "Adoor",
//         "Alappuzha",
//         "Alleppey",
//         "Aluva",
//         "Alwaye",
//         "Angamali",
//         "Aroor",
//         "Arukutti",
//         "Attingal",
//         "Avanoor",
//         "Azhikkal",
//         "Beypore",
//         "Changanacheri",
//         "Chelakara",
//         "Chengannur",
//         "Cherpulassery",
//         "Cherthala",
//         "Chetwayi",
//         "Chittur",
//         "Cochin",
//         "Dharmadom",
//         "Edakkulam",
//         "Elur",
//         "Erattupetta",
//         "Ernakulam",
//         "Ferokh",
//         "Guruvayur",
//         "Idukki",
//         "Iringal",
//         "Irinjalakuda",
//         "Kadakkavoor",
//         "Kalamassery",
//         "Kalavoor",
//         "Kalpetta",
//         "Kanhangad",
//         "Kannavam",
//         "Kannur",
//         "Kasaragod",
//         "Kattanam",
//         "Kayankulam",
//         "Kizhake Chalakudi",
//         "Kochi",
//         "Kodungallur",
//         "Kollam",
//         "Kotamangalam",
//         "Kottayam",
//         "Kovalam",
//         "Kozhikode",
//         "Kumbalam",
//         "Kunnamangalam",
//         "Kunnamkulam",
//         "Kunnumma",
//         "Kutiatodu",
//         "Kuttampuzha",
//         "Lalam",
//         "Mahe",
//         "Malappuram",
//         "Manjeri",
//         "Manjeshwaram",
//         "Mannarakkat",
//         "Marayur",
//         "Mattanur",
//         "Mavelikara",
//         "Mavoor",
//         "Muluppilagadu",
//         "Munnar",
//         "Muvattupula",
//         "Muvattupuzha",
//         "Nadapuram",
//         "Naduvannur",
//         "Nedumangad",
//         "Neyyattinkara",
//         "Nileshwar",
//         "Ottappalam",
//         "Palackattumala",
//         "Palakkad district",
//         "Palghat",
//         "Panamaram",
//         "Pappinissheri",
//         "Paravur Tekkumbhagam",
//         "Pariyapuram",
//         "Pathanamthitta",
//         "Pattanamtitta",
//         "Payyanur",
//         "Perinthalmanna",
//         "Perumbavoor",
//         "Perumpavur",
//         "Perya",
//         "Piravam",
//         "Ponnani",
//         "Ponmana",
//         "Punalur",
//         "Punnayur",
//         "Ramamangalam",
//         "Shertallai",
//         "Shoranur",
//         "Taliparamba",
//         "Thalassery",
//         "Thalikulam",
//         "Thanniyam",
//         "Thekkady",
//         "Thiruvananthapuram",
//         "Thrissur",
//         "Tirur",
//         "Tiruvalla",
//         "Vaikam",
//         "Varkala",
//         "Vatakara",
//         "Vayalar",
//         "Vettur",
//         "Wayanad",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(keralaCities.map((city, idx) => ({ id: idx + 1, name: city })));
//     } else if (stateName.toLowerCase() === "tamil nadu") {
//       const tamilnaduCities = [
//         // Tamil Nadu cities
//         "Aambur",
//         "Ariyalur",
//         "Arakkonam",
//         "Arani",
//         "Attur",
//         "Avadi",
//         "Batlagundu",
//         "Chengalpattu",
//         "Chennai",
//         "Chidambaram",
//         "Coimbatore",
//         "Courtallam",
//         "Cuddalore",
//         "Coonoor",
//         "Dharapuram",
//         "Dharmapuri",
//         "Dindigul",
//         "Erode",
//         "Gobichettipalayam",
//         "Gudalur",
//         "Gudiyatham",
//         "Hosur",
//         "Jayankondam",
//         "Kallakurichi",
//         "Kanchipuram",
//         "Kanyakumari",
//         "Karaikudi",
//         "Karur",
//         "Kodaikanal",
//         "Kovilpatti",
//         "Krishnagiri",
//         "Kumbakonam",
//         "Madurai",
//         "Manapparai",
//         "Mahabalipuram",
//         "Mayiladuthurai",
//         "Mettupalayam",
//         "Namakkal",
//         "Nagapattinam",
//         "Nagercoil",
//         "Ooty",
//         "Palani",
//         "Pallavaram",
//         "Pattukkottai",
//         "Perambalur",
//         "Pollachi",
//         "Poonamallee",
//         "Pudukkottai",
//         "Rajapalayam",
//         "Ramanathapuram",
//         "Ranipet",
//         "Salem",
//         "Sankagiri",
//         "Sivaganga",
//         "Sivakasi",
//         "Tambaram",
//         "Tenkasi",
//         "Thanjavur",
//         "Theni",
//         "Thiruvallur",
//         "Thiruvarur",
//         "Thoothukudi",
//         "Tindivanam",
//         "Tiruchendur",
//         "Tiruchengode",
//         "Tiruchirappalli",
//         "Tirunelveli",
//         "Tirupathur",
//         "Tiruppur",
//         "Tiruvannamalai",
//         "Udagamandalam",
//         "Udumalpet",
//         "Usilampatti",
//         "Vaniyambadi",
//         "Vellore",
//         "Villupuram",
//         "Virudhunagar",
//       ];

//       // Convert to {id, name} objects since your city dropdown expects that
//       setCities(
//         tamilnaduCities.map((city, idx) => ({ id: idx + 1, name: city })),
//       );
//     } else {
//       const stateObj = indiaStates.find((s) => s.name === stateName);
//       setCities(stateObj ? stateObj.cities : []);
//     }
//   };

//   const handleStateChange = (e) => {
//     const stateName = e.target.value;
//     setSelectedState(stateName);
//     setSelectedCity(""); // reset city when destination changes
//     loadCitiesForState(stateName);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);

//       if (mobile) {
//         setIsSidebarOpen(false);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const CustomLeftArrowBannerCarousel = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute left-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
//         name="previous_btn"
//       >
//         <FaChevronLeft />
//       </button>
//     );
//   };

//   const CustomRightArrowBannerCarousel = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute right-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
//         name="next_btn"
//       >
//         <FaChevronRight />
//       </button>
//     );
//   };

//   const MAX_CARDS = 5;

//   const [selectedImages, setSelectedImages] = useState(
//     Array(MAX_CARDS).fill(null),
//   );

//   const handleImageUpload = (event, index) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageurl = URL.createObjectURL(file);
//       const updatedImages = [...selectedImages];
//       updatedImages[index] = imageurl;
//       setSelectedImages(updatedImages);
//     }
//   };

//   const [imageCarouselOne, setImageCarouselOne] = useState(
//     Array(MAX_CARDS).fill(null),
//   );

//   const handleImageUploadCarouselOne = (event, index) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageurl = URL.createObjectURL(file);
//       const updatedImages = [...imageCarouselOne];
//       updatedImages[index] = imageurl;
//       setImageCarouselOne(updatedImages);
//     }
//   };

//   const [imageCarouselTwo, setImageCarouselTwo] = useState(
//     Array(MAX_CARDS).fill(null),
//   );

//   const handleImageUploadCarouselTwo = (event, index) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageurl = URL.createObjectURL(file);
//       const updatedImages = [...imageCarouselTwo];
//       updatedImages[index] = imageurl;
//       setImageCarouselTwo(updatedImages);
//     }
//   };

//   const [imageCarouselThree, setImageCarouselThree] = useState(
//     Array(MAX_CARDS).fill(null),
//   );

//   const handleImageUploadCarouselThree = (event, index) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageurl = URL.createObjectURL(file);
//       const updatedImages = [...imageCarouselThree];
//       updatedImages[index] = imageurl;
//       setImageCarouselThree(updatedImages);
//     }
//   };

//   const [imageCarouselFour, setImageCarouselFour] = useState(
//     Array(MAX_CARDS).fill(null),
//   );

//   const handleImageUploadCarouselFour = (event, index) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageurl = URL.createObjectURL(file);
//       const updatedImages = [...imageCarouselFour];
//       updatedImages[index] = imageurl;
//       setImageCarouselFour(updatedImages);
//     }
//   };

//   const [imageCarouselFive, setImageCarouselFive] = useState(
//     Array(MAX_CARDS).fill(null),
//   );

//   const handleImageUploadCarouselFive = (event, index) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageurl = URL.createObjectURL(file);
//       const updatedImages = [...imageCarouselFive];
//       updatedImages[index] = imageurl;
//       setImageCarouselFive(updatedImages);
//     }
//   };

//   // const [uploadedMap, setUploadedMap] = useState(null);

//   // const handleMapUpload = (event) => {
//   //   const file = event.target.files[0];
//   //   if (file) {
//   //     const mapUrl = URL.createObjectURL(file);
//   //     setUploadedMap(mapUrl);
//   //   }
//   // };

//   // const [experienceData, setExperienceData] = useState([
//   //   { icon: "", title: "", content: "" },
//   //   { icon: "", title: "", content: "" },
//   //   { icon: "", title: "", content: "" },
//   //   { icon: "", title: "", content: "" },
//   // ]);
//   const [experienceData, setExperienceData] = useState(
//     Array.from({ length: 8 }, () => ({ file: null, title: "", content: "" })),
//   );

//   const iconOptions = [
//     { label: "Sun", value: "BsCloudSun", icon: <BsCloudSun /> },
//     { label: "Full Sun", value: "BsFillSunFill", icon: <BsFillSunFill /> },
//     {
//       label: "Calendar",
//       value: "IoCalendarClearOutline",
//       icon: <IoCalendarClearOutline />,
//     },
//     {
//       label: "Numbered Calendar",
//       value: "IoCalendarNumber",
//       icon: <IoCalendarNumber />,
//     },
//     { label: "Palm Tree", value: "GiPalmTree", icon: <GiPalmTree /> },
//     { label: "Plane", value: "IoIosAirplane", icon: <IoIosAirplane /> },
//     {
//       label: "Airplane Departure",
//       value: "GiAirplaneDeparture",
//       icon: <GiAirplaneDeparture />,
//     },
//   ];

//   const [gridImg_fullWidth, setGridImg_fullWidth] = useState(null);
//   const [gridImg1, setGridImg1] = useState(null);
//   const [gridImg2, setGridImg2] = useState(null);

//   const handleMediaUpload_gridImages = (e, setter) => {
//     const file = e.target.files[0];
//     if (file) {
//       const imageurl = URL.createObjectURL(file);
//       setter(imageurl);
//     }
//   };

//   const TailoredExpCarousel = [
//     {
//       img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/77613/villa-barbados-caribbean-luxury-the-great-house-boat_FullL.jpg?v=302558110212",
//       title: "For Adventure Seekers",
//       content:
//         "Experience the thrill of Goa with our adventure package! Enjoy cozy stays, a hearty breakfast, and activities like water sports, trekking, and more.",
//     },
//     {
//       img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/66699/villa-barbados-caribbean-luxury-the-great-house-ext-9_FullL.jpg?v=302558110212",
//       title: "For Leisure Lovers",
//       content:
//         "Unwind with our leisure package in Goa. Relax in serene stays, savor a delicious breakfast, and enjoy peaceful beaches, spa sessions, and local attractions.",
//     },
//   ];

//   const responsive_TailoredExpCarousel = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 2,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 2,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 2,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   // const MAX_CARDS_Exp = TailoredExpCarousel.length;

//   // const [tailoredexpimages, setTailoredexpimages] = useState(
//   //   TailoredExpCarousel.map((item) => item.img)
//   // );

//   // const handleImageUploadTailoredExp = (event, index) => {
//   //   const file = event.target.files[0];
//   //   if (file) {
//   //     const imageurl = URL.createObjectURL(file);
//   //     const updatedImages = [...tailoredexpimages];
//   //     updatedImages[index] = imageurl;
//   //     setTailoredexpimages(updatedImages);
//   //   }
//   // };
//   // const handleImageUploadTailoredExp = (e, index) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     const newImages = [...tailoredexpimages];
//   //     newImages[index] = file; // ✅ store actual File instead of URL
//   //     setTailoredexpimages(newImages);
//   //   }
//   // };

//   const responsive_BannerCarousel = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 2,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 2,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 2,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1.5,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1.5,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const [showDots, setShowDots] = useState(false);

//   useEffect(() => {
//     const updateDotsVisibility = () => {
//       setShowDots(window.innerWidth < 768);
//     };

//     updateDotsVisibility();
//     window.addEventListener("resize", updateDotsVisibility);
//     return () => window.removeEventListener("resize", updateDotsVisibility);
//   }, []);

//   const responsive_ImageCarouselOne = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const responsive_ImageCarouselTwo = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const responsive_ImageCarouselThree = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const responsive_ImageCarouselFour = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const responsive_ImageCarouselFive = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 1,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 1,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const responsive_ExperienceCarousel = {
//     xl: {
//       breakpoint: { max: 4000, min: 1280 },
//       items: 4,
//       partialVisibilityGutter: 20,
//     },
//     lg: {
//       breakpoint: { max: 1280, min: 1024 },
//       items: 3,
//       partialVisibilityGutter: 20,
//     },
//     md: {
//       breakpoint: { max: 1024, min: 768 },
//       items: 3,
//       partialVisibilityGutter: 15,
//     },
//     sm: {
//       breakpoint: { max: 768, min: 640 },
//       items: 2,
//       partialVisibilityGutter: 15,
//     },
//     xs: {
//       breakpoint: { max: 640, min: 0 },
//       items: 1.5,
//       partialVisibilityGutter: 10,
//     },
//   };

//   const CustomLeftArrowTailoredExpCarousel = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute left-3 top-44 transform -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
//         name="previous_btn"
//       >
//         <FaChevronLeft />
//       </button>
//     );
//   };

//   const CustomRightArrowTailoredExpCarousel = ({ onClick }) => {
//     return (
//       <button
//         onClick={onClick}
//         className="hidden md:block absolute right-3 top-44 transform -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
//         name="next_btn"
//       >
//         <FaChevronRight />
//       </button>
//     );
//   };

//   const [activeCardIndex, setActiveCardIndex] = useState(0);
//   const carouselRef = useRef(null);

//   const handlePrevSlide = () => {
//     if (carouselRef.current) {
//       carouselRef.current.previous();
//     }
//   };

//   const handleNextSlide = () => {
//     if (carouselRef.current) {
//       carouselRef.current.next();
//     }
//   };

//   const [, setIsOpen_dropdownExp] = useState(false);
//   // const [, setSelectedOptions_dropdownExp] =
//   //   useState([]);
//   const dropdownRef_dropdownExp = useRef(null);

//   // const options_dropdownExp = ["Option1", "Option2", "Option3"];

//   // const toggleOption_dropdownExp = (option) => {
//   //   setSelectedOptions_dropdownExp((prev) =>
//   //     prev.includes(option)
//   //       ? prev.filter((item) => item !== option)
//   //       : [...prev, option]
//   //   );
//   // };

//   useEffect(() => {
//     const handleClickOutside_dropdownExp = (event) => {
//       if (
//         dropdownRef_dropdownExp.current &&
//         !dropdownRef_dropdownExp.current.contains(event.target)
//       ) {
//         setIsOpen_dropdownExp(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside_dropdownExp);
//     return () =>
//       document.removeEventListener("mousedown", handleClickOutside_dropdownExp);
//   }, []);
//   const [tailoredExpData, setTailoredExpData] = useState([
//     { img: null, title: "", content: "" },
//     { img: null, title: "", content: "" },
//     { img: null, title: "", content: "" },
//     { img: null, title: "", content: "" },
//   ]);
//   const MAX_CARDS_Exp = tailoredExpData.length;

//   const [propertyThumbnail, setPropertyThumbnail] = useState(null);

//   const [thumbnailFile, setThumbnailFile] = useState(null);

//   const handlepropertyThumbnail = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setThumbnailFile(file); // <-- important
//       const previewUrl = URL.createObjectURL(file);
//       setPropertyThumbnail(previewUrl);
//     }
//   };
//   const handleSave = async () => {
//     try {
//       setLoading(true); // show loader

//       //check if required data was sent or not
//       const propertycode = document
//         .querySelector('input[placeholder="Enter property code"]')
//         .value.trim();
//       const propertytype = document
//         .querySelector('select[name="propertytype"]')
//         .value.trim();
//       const destination = document
//         .querySelector('select[name="destination"]')
//         .value.trim();
//       const location = document
//         .querySelector('select[name="location"]')
//         .value.trim();

//       // check required fields
//       if (!propertycode || !propertytype || !destination || !location) {
//         toast.error(
//           "Property Code,Type,Destination and Location cannot be null!",
//         );
//         setLoading(false);
//         return; // ⛔ stop execution
//       }

//       //proper function of saving data
//       const formData = new FormData();

//       // Properties table data
//       formData.append(
//         "propertyname",
//         document.querySelector('input[name="propertyname"]').value,
//       );
//       formData.append(
//         "description",
//         document.querySelector('textarea[name="description"]').value,
//       );
//       formData.append(
//         "heading",
//         document.querySelector('input[placeholder="Heading"]').value,
//       );
//       formData.append(
//         "content",
//         document.querySelector('textarea[placeholder="Content..."]').value,
//       );
//       formData.append(
//         "catchquote",
//         document.querySelector('input[placeholder="Catchy Quote"]').value,
//       );
//       formData.append(
//         "aboutloc",
//         document.querySelector('input[placeholder="About the location"]').value,
//       );
//       formData.append(
//         "loctagline",
//         document.querySelector('input[placeholder="Location Tagline"]').value,
//       );
//       formData.append(
//         "loccontent",
//         document.querySelector('input[placeholder="Content..."]').value,
//       );

//       // Additional properties data
//       formData.append(
//         "propertycode",
//         document.querySelector('input[placeholder="Enter property code"]')
//           .value,
//       );
//       formData.append(
//         "propertyowner",
//         document.querySelector('input[name="propertyowner"]').value,
//       );
//       formData.append(
//         "propertyBrochure",
//         document.querySelector('input[name="propertyBrochure"]').value,
//       );

//       formData.append(
//         "currentprice",
//         document.querySelector('input[placeholder="Enter current price"]')
//           .value,
//       );
//       formData.append(
//         "defaultprice",
//         document.querySelector('input[placeholder="Enter default price"]')
//           .value,
//       );
//       formData.append(
//         "deposit",
//         document.querySelector('input[placeholder="Enter security deposit"]')
//           .value,
//       );
//       formData.append(
//         "maxadult",
//         document.querySelector('input[placeholder="Enter max adults"]').value,
//       );
//       formData.append(
//         "maxchild",
//         document.querySelector('input[placeholder="Enter max children"]').value,
//       );
//       formData.append(
//         "maxbed",
//         document.querySelector('input[placeholder="Enter max bedroom"]').value,
//       );
//       formData.append(
//         "maxbath",
//         document.querySelector('input[placeholder="Enter max bathroom"]').value,
//       );
//       formData.append(
//         "maplink",
//         document.querySelector('input[placeholder="Enter map location"]').value,
//       );
//       formData.append(
//         "youtubelink",
//         document.querySelector('input[placeholder="Enter youtube link"]').value,
//       );
//       formData.append("conserlink", conciergeService);
//       formData.append("fullDescription", fullScrapedDescription);
//       // Foreign key selects
//       // formData.append(
//       //   "location",
//       //   document.querySelector('select[name="location"]').value
//       // );
//       // formData.append(
//       //   "propertytype",
//       //   document.querySelectorAll("select")[1].value
//       // );
//       // formData.append(
//       //   "destination",
//       //   document.querySelectorAll('select[name="destination"]')[2].value
//       // );
//       // formData.append(
//       //   "seasonType",
//       //   document.querySelectorAll('select[name="seasonType"]')[3].value
//       // );
//       formData.append(
//         "destination",
//         document.querySelector('select[name="destination"]')?.value || "",
//       );
//       formData.append(
//         "location",
//         document.querySelector('select[name="location"]')?.value || "",
//       );
//       formData.append(
//         "propertytype",
//         document.querySelector('select[name="propertytype"]')?.value || "",
//       );
//       formData.append(
//         "seasonType",
//         document.querySelector('select[name="seasonType"]')?.value || "",
//       );

//       // Banner images
//       for (let i = 0; i < selectedImages.length; i++) {
//         if (selectedImages[i]) {
//           formData.append(
//             `banner${i + 1}`,
//             await urlToFile(selectedImages[i], `banner${i + 1}.jpg`),
//           );
//         }
//       }

//       // Carousel images
//       const carousels = [
//         imageCarouselOne,
//         imageCarouselTwo,
//         imageCarouselThree,
//         imageCarouselFour,
//         imageCarouselFive,
//       ];
//       for (let c = 0; c < carousels.length; c++) {
//         for (let i = 0; i < carousels[c].length; i++) {
//           if (carousels[c][i]) {
//             formData.append(
//               `img${i + 1}_C${c + 1}`,
//               await urlToFile(carousels[c][i], `img${i + 1}_C${c + 1}.jpg`),
//             );
//           }
//         }
//       }

//       // Text content for propertyImages
//       // formData.append(
//       //   "title1",
//       //   document.querySelector(
//       //     'input[placeholder="Title 1 (highlight property speciality)"]'
//       //   ).value
//       // );
//       // formData.append(
//       //   "rc1",
//       //   document.querySelector('textarea[placeholder="Relevant Content 1..."]')
//       //     .value
//       // );
//       // formData.append(
//       //   "title2",
//       //   document.querySelector(
//       //     'input[placeholder="Title 2 (highlight property speciality)"]'
//       //   ).value
//       // );
//       // formData.append(
//       //   "rc2",
//       //   document.querySelector('textarea[placeholder="Relevant Content 2..."]')
//       //     .value
//       // );

//       formData.append(
//         "title1",
//         document.querySelector('input[name="title1"]').value,
//       );
//       formData.append(
//         "rc1",
//         document.querySelector('textarea[name="rc1"]').value,
//       );
//       formData.append(
//         "title2",
//         document.querySelector('input[name="title2"]').value,
//       );
//       formData.append(
//         "rc2",
//         document.querySelector('textarea[name="rc2"]').value,
//       );
//       formData.append(
//         "title3",
//         document.querySelector(
//           'input[placeholder="Title 3 (highlight property speciality)"]',
//         ).value,
//       );
//       formData.append(
//         "rc3",
//         document.querySelector('textarea[placeholder="Relevant Content 3..."]')
//           .value,
//       );

//       // Map data
//       formData.append(
//         "maplang",
//         document.querySelector('input[name="maplang"]').value,
//       );
//       formData.append(
//         "maplong",
//         document.querySelector('input[name="maplong"]').value,
//       );

//       formData.append(
//         "maptitle",
//         document.querySelector('textarea[placeholder="Map Title"]').value,
//       );
//       formData.append(
//         "mapcontent",
//         document.querySelector('textarea[placeholder="Map Content..."]').value,
//       );
//       // if (uploadedMap) {
//       //   formData.append(
//       //     "mapimage",
//       //     await urlToFile(uploadedMap, "mapimage.jpg")
//       //   );
//       // }

//       // Grid images
//       if (gridImg_fullWidth) {
//         formData.append(
//           "imagegrid1",
//           await urlToFile(gridImg_fullWidth, "imagegrid1.jpg"),
//         );
//       }
//       if (gridImg1) {
//         formData.append(
//           "imagegrid2",
//           await urlToFile(gridImg1, "imagegrid2.jpg"),
//         );
//       }
//       if (gridImg2) {
//         formData.append(
//           "imagegrid3",
//           await urlToFile(gridImg2, "imagegrid3.jpg"),
//         );
//       }

//       // Experiences main fields
//       formData.append(
//         "expnamemain",
//         document.querySelector('input[placeholder="Experience"]').value,
//       );
//       formData.append(
//         "expcontentmain",
//         document.querySelector('textarea[placeholder="Content..."]').value,
//       );

//       // Experience items (expimage + title + content)
//       for (let i = 0; i < experienceData.length; i++) {
//         formData.append(
//           `exptitle${i === 0 ? "" : i + 1}`,
//           experienceData[i].title,
//         );
//         formData.append(
//           `expcon${i === 0 ? "" : i + 1}`,
//           experienceData[i].content,
//         );

//         if (experienceData[i].file) {
//           formData.append(
//             `expimage${i === 0 ? "" : i + 1}`,
//             experienceData[i].file,
//           );
//         }
//       }

//       // // ✅ Tailored experiences (images + title + content)
//       // for (let i = 0; i < tailoredExpData.length; i++) {
//       //   if (tailoredExpData[i].file) {
//       //     formData.append(`miniexpimg${i + 1}`, tailoredExpData[i].file);
//       //   }
//       //   formData.append(`miniexptitle${i + 1}`, tailoredExpData[i].title || "");
//       //   formData.append(`miniexpcon${i + 1}`, tailoredExpData[i].content || "");
//       // }
//       // Tailored experiences (miniexpimg + title + content)
//       for (let i = 0; i < tailoredExpData.length; i++) {
//         if (tailoredExpData[i]?.file) {
//           formData.append(`miniexpimg${i + 1}`, tailoredExpData[i].file);
//         }
//         if (tailoredExpData[i]?.title) {
//           formData.append(`miniexptitle${i + 1}`, tailoredExpData[i].title);
//         }
//         if (tailoredExpData[i]?.content) {
//           formData.append(`miniexpcon${i + 1}`, tailoredExpData[i].content);
//         }
//       }
//       if (thumbnailFile) {
//         formData.append("thumbnailimg", thumbnailFile);
//       }
//       formData.append("addons", selectedAmenities.join(","));
//       formData.append(
//         "airid",
//         document.querySelector('input[name="airid"]')?.value || "",
//       );
//       // Send request
//       const response = await fetch(
//         "https://demo.zorbastays.com/web-backend/createProperty",
//         {
//           method: "POST",
//           body: formData,
//         },
//       );

//       if (response.ok) {
//         // alert("Property saved successfully!");
//         toast.success("Property added successfully 🎉");

//         // navigate after short delay so toast is visible
//         setTimeout(() => {
//           navigate("/Properties");
//         }, 800);
//       } else {
//         // alert("Error saving property");
//         toast.error("Please enter required feilds");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       // alert("Error saving property");
//       toast.error("Please enter required feilds");
//     } finally {
//       setLoading(false); // hide loader
//     }
//   };

//   const urlToFile = async (url, filename) => {
//     const response = await fetch(url);
//     const blob = await response.blob();
//     return new File([blob], filename, { type: blob.type });
//   };

//   const [propertyname, setpropertyname] = useState("");
//   const [description, setDescription] = useState("");
//   const [heading, setHeading] = useState("");
//   const [content, setContent] = useState("");
//   const [catchyQuote, setCatchyQuote] = useState("");
//   const [title1, setTitle1] = useState("");
//   const [relevantContent1, setRelevantContent1] = useState("");
//   const [title2, setTitle2] = useState("");
//   const [content2, setContent2] = useState("");
//   const [title3, setTitle3] = useState("");
//   const [relevantContent3, setRelevantContent3] = useState("");
//   const [maptitle, setmaptitle] = useState("");
//   const [mapcontent, setmapcontent] = useState("");
//   const [aboutlocation, setaboutlocation] = useState("");
//   const [conciergeService, setConciergeService] = useState("");
//   const [locationTagline, setLocationTagline] = useState("");
//   const [locationContent, setLocationContent] = useState("");
//   const [tailoredExperience, setTailoredExperience] = useState("");
//   const [villaUrl, setVillaUrl] = useState("");
//   const [showScrapeModal, setShowScrapeModal] = useState(false);
//   const [scrapeAirbnbId, setScrapeAirbnbId] = useState("");
//   const [tailoredExperienceContent, setTailoredExperienceContent] =
//     useState("");

//   const [amenitiesList, setAmenitiesList] = useState([]);
//   const [selectedAmenities, setSelectedAmenities] = useState([]); // stores ids: [1, 4, 5]

//   const [searchTerm, setSearchTerm] = useState("");
//   const [isOpen_amenities, setIsOpen_amenities] = useState(false);

//   // const toggleAmenity = (amenityName) => {
//   //   if (selectedAmenities.includes(amenityName)) {
//   //     setSelectedAmenities(selectedAmenities.filter((a) => a !== amenityName));
//   //   } else {
//   //     setSelectedAmenities([...selectedAmenities, amenityName]);
//   //   }
//   // };
//   useEffect(() => {
//     fetch("https://demo.zorbastays.com/web-backend/getAmenities")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.success) setAmenitiesList(data.data);
//       })
//       .catch((err) => console.error("Failed to load amenities", err));
//   }, []);

//   // Toggle stores/removes the numeric id
//   const toggleAmenity = (id) => {
//     setSelectedAmenities((prev) =>
//       prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id],
//     );
//   };

//   const filteredAmenities = amenitiesList.filter((amenity) =>
//     amenity.name.toLowerCase().includes(searchTerm.toLowerCase()),
//   );

//   const containerRef_amenities = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         containerRef_amenities.current &&
//         !containerRef_amenities.current.contains(event.target)
//       ) {
//         setIsOpen_amenities(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Scraper function
//   // const handleScrapeData = async () => {
//   //   // Read select values
//   //   const propertytype = document
//   //     .querySelector('select[name="propertytype"]')
//   //     ?.value.trim();
//   //   const destination = document
//   //     .querySelector('select[name="destination"]')
//   //     ?.value.trim();
//   //   const location = document
//   //     .querySelector('select[name="location"]')
//   //     ?.value.trim();

//   //   // Validate — stop if any field is missing
//   //   if (!propertyname) {
//   //     toast.error("Property Name cannot be null while Scraping!");
//   //     return;
//   //   }
//   //   if (!propertytype) {
//   //     toast.error("Property Type cannot be null while Scraping!");
//   //     return;
//   //   }
//   //   if (!destination) {
//   //     toast.error("Destination cannot be null while Scraping!");
//   //     return;
//   //   }
//   //   if (!location) {
//   //     toast.error("Location cannot be null while Scraping!");
//   //     return;
//   //   }

//   //   try {
//   //     toast.info("Scraping in progress… this may take 30–60 seconds.");

//   //     const response = await fetch(
//   //       "https://demo.zorbastays.com/web-backend/scrape",
//   //       {
//   //         method: "POST",
//   //         headers: { "Content-Type": "application/json" },
//   //         body: JSON.stringify({
//   //           propertyname,
//   //           propertytype,
//   //           destination,
//   //           location,
//   //         }),
//   //       },
//   //     );

//   //     const result = await response.json();

//   //     if (!result.success) {
//   //       toast.error(
//   //         "Scraping failed: " + (result.errors?.join(", ") || result.error),
//   //       );
//   //       return;
//   //     }

//   //     const { lohono, airbnb } = result.data;

//   //     // ── Log to console (replace with autofill later) ──────────────────────
//   //     console.group("🔎 Scrape Results");

//   //     console.group("🏡 LOHONO");
//   //     console.log("Name        :", lohono.propertyname);
//   //     console.log("Location    :", lohono.location);
//   //     console.log("Description :", lohono.description);
//   //     console.log("Price       :", lohono.price);
//   //     console.log("Bedrooms    :", lohono.bedrooms);
//   //     console.log("Bathrooms   :", lohono.bathrooms);
//   //     console.log("Guests      :", lohono.guests);
//   //     console.log("Amenities   :", lohono.amenities);
//   //     console.log("Check-in    :", lohono.checkin);
//   //     console.log("Check-out   :", lohono.checkout);
//   //     console.log("House Rules :", lohono.houseRules);
//   //     console.log("URL         :", lohono.url);
//   //     console.groupEnd();

//   //     console.group("✈️ AIRBNB");
//   //     console.log("Name        :", airbnb.propertyname);
//   //     console.log("Location    :", airbnb.location);
//   //     console.log("Description :", airbnb.description);
//   //     console.log("Price       :", airbnb.price);
//   //     console.log("Bedrooms    :", airbnb.bedrooms);
//   //     console.log("Bathrooms   :", airbnb.bathrooms);
//   //     console.log("Guests      :", airbnb.guests);
//   //     console.log("Rating      :", airbnb.rating);
//   //     console.log("Reviews     :", airbnb.reviewCount);
//   //     console.log("Host        :", airbnb.hostName);
//   //     console.log("Amenities   :", airbnb.amenities);
//   //     console.log("Check-in    :", airbnb.checkin);
//   //     console.log("Check-out   :", airbnb.checkout);
//   //     console.log("Cancellation:", airbnb.cancellationPolicy);
//   //     console.log("House Rules :", airbnb.houseRules);
//   //     console.log("URL         :", airbnb.url);
//   //     console.groupEnd();

//   //     console.groupEnd();

//   //     toast.success("Scraping complete! Check the console for data.");

//   //     // ── TODO: swap console.logs above with autofill ───────────────────────
//   //     // Example:
//   //     // setVillaName(lohono.propertyname || airbnb.propertyname);
//   //     // setDescription(lohono.description || airbnb.description);
//   //     // setBedrooms(lohono.bedrooms || airbnb.bedrooms);
//   //   } catch (err) {
//   //     console.error("Scrape request failed:", err);
//   //     toast.error("Network error during scraping.");
//   //   }
//   // };
//   // Scraper function
//   const handleScrapeData = async () => {
//     // Read select values
//     const propertytype = document
//       .querySelector('select[name="propertytype"]')
//       ?.value.trim();
//     const destination = scrapeDestination;
//     const location = scrapeLocation;

//     // Validate — stop if any field is missing
//     if (!propertyname) {
//       toast.error("Property Name cannot be null while Scraping!");
//       return;
//     }
//     if (!propertytype) {
//       toast.error("Property Type cannot be null while Scraping!");
//       return;
//     }
//     if (!destination) {
//       toast.error("Destination cannot be null while Scraping!");
//       return;
//     }
//     if (!location) {
//       toast.error("Location cannot be null while Scraping!");
//       return;
//     }

//     try {
//       toast.info("Scraping in progress… this may take 30–60 seconds.");

//       const response = await fetch(
//         "https://demo.zorbastays.com/web-backend/scrape",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             propertyname,
//             propertytype,
//             destination,
//             location,
//             airbnbId: scrapeAirbnbId || null,
//             amenitiesList, // <-- send the full table so backend can match against it
//           }),
//         },
//       );

//       const result = await response.json();

//       if (!result.success) {
//         toast.error(
//           "Scraping failed: " + (result.errors?.join(", ") || result.error),
//         );
//         return;
//       }

//       const {
//         lohono,
//         airbnb,
//         amenityMatch,
//         descriptionFields,
//         fullDescription,
//         descriptionSource: descSource,
//       } = result.data;

//       // ── Autofill destination, location ────────────────────────────
//       if (scrapeDestination) {
//         setSelectedState(scrapeDestination);
//         loadCitiesForState(scrapeDestination);
//       }
//       if (scrapeLocation) {
//         setTimeout(() => setSelectedCity(scrapeLocation), 50);
//       }

//       // ── Autofill basic fields ───────────────────────────────────────
//       setpropertyname(
//         lohono.propertyname || airbnb.propertyname || propertyname,
//       );

//       // Description fields — now pre-split to fit each field's character
//       // limit, instead of one long string getting silently cut off.
//       if (descriptionFields) {
//         setDescription(descriptionFields.description || "");
//         setContent(descriptionFields.content || "");
//         setRelevantContent1(descriptionFields.rc1 || "");
//         setContent2(descriptionFields.rc2 || "");
//         setRelevantContent3(descriptionFields.rc3 || "");
//       }
//       // Full, untruncated text — kept so nothing scraped is ever lost,
//       // even though only the shorter fields are shown on the page itself.
//       setFullScrapedDescription(fullDescription || "");
//       setDescriptionSource(descSource || null);

//       // Numeric fields (unchanged)
//       if (lohono.bedrooms || airbnb.bedrooms) {
//         setBedrooms(lohono.bedrooms || airbnb.bedrooms);
//         setmaxbedrooms(lohono.bedrooms || airbnb.bedrooms);
//       }
//       if (lohono.bathrooms || airbnb.bathrooms) {
//         setBathrooms(lohono.bathrooms || airbnb.bathrooms);
//         setmaxbathrooms(lohono.bathrooms || airbnb.bathrooms);
//       }
//       if (lohono.guests || airbnb.guests) {
//         setGuests(lohono.guests || airbnb.guests);
//       }
//       if (lohono.price || airbnb.price) {
//         setPrice(lohono.price || airbnb.price);
//       }

//       // ── Amenities — now matched server-side against the real full list ──
//       // ── Amenities — now matched server-side against the real full list ──
//       console.log("🔍 amenityMatch from backend:", amenityMatch);

//       if (amenityMatch) {
//         setSelectedAmenities(amenityMatch.matchedIds || []);
//         setUnmatchedAmenities(amenityMatch.unmatched || []);

//         // Force the amenities grid open so matched/ticked amenities are
//         // actually visible without the user needing to click the search
//         // box first.
//         setIsOpen_amenities(true);

//         if (amenityMatch.totalScraped > 0) {
//           toast.success(
//             `${amenityMatch.matchedIds.length}/${amenityMatch.totalScraped} amenities matched` +
//               (amenityMatch.unmatched.length > 0
//                 ? ` — ${amenityMatch.unmatched.length} need manual review`
//                 : ""),
//           );
//         } else {
//           toast.info("No amenities were found on the scraped listing.");
//         }
//       } else {
//         // amenityMatch was missing entirely from the response — this means
//         // the backend is still running the OLD scrapeProperty (without the
//         // amenityMatch/descriptionFields patch applied), or amenitiesList
//         // wasn't sent/received correctly.
//         console.warn(
//           "⚠️ No amenityMatch in scrape response — backend scrapeProperty " +
//             "may not have the amenity-matching patch applied yet, or " +
//             "amenitiesList was empty when sent.",
//         );
//         toast.warning(
//           "Amenity matching unavailable — check backend is updated.",
//         );
//       }

//       // Check-in/out, house rules, location, URL, rating etc. — unchanged
//       if (lohono.checkin || airbnb.checkin)
//         setcheckin(lohono.checkin || airbnb.checkin);
//       if (lohono.checkout || airbnb.checkout)
//         setcheckout(lohono.checkout || airbnb.checkout);
//       if (lohono.houseRules?.length > 0 || airbnb.houseRules?.length > 0) {
//         setHouseRules(
//           lohono.houseRules?.length > 0 ? lohono.houseRules : airbnb.houseRules,
//         );
//       }
//       if (lohono.location || airbnb.location)
//         setLocation(lohono.location || airbnb.location);
//       if (lohono.url || airbnb.url) {
//         const url = lohono.url || airbnb.url;
//         setVillaUrl(url);
//         setSourceUrl(url);
//       }
//       if (airbnb.rating) setRating(airbnb.rating);
//       if (airbnb.reviewCount) setReviewCount(airbnb.reviewCount);
//       if (airbnb.hostName) setHostName(airbnb.hostName);
//       if (airbnb.cancellationPolicy)
//         setCancellationPolicy(airbnb.cancellationPolicy);

//       toast.success("Data autofilled successfully from scraped results!");
//     } catch (err) {
//       console.error("Scrape request failed:", err);
//       toast.error("Network error during scraping.");
//     }
//   };
//   const scrapeFilteredCities = (() => {
//     const name = scrapeDestination.toLowerCase();
//     if (!name) return [];

//     // Reuse the same logic from handleStateChange
//     if (name === "goa") {
//       return [
//         "Aldona",
//         "Arambol",
//         "Baga",
//         "Bambolim",
//         "Bandora",
//         "Benaulim",
//         "Calangute",
//         "Candolim",
//         "Carapur",
//         "Cavelossim",
//         "Chicalim",
//         "Chinchinim",
//         "Colovale",
//         "Colva",
//         "Cortalim",
//         "Cuncolim",
//         "Curchorem",
//         "Curti",
//         "Davorlim",
//         "Dicholi",
//         "Goa Velha",
//         "Guirim",
//         "Jua",
//         "Kankon",
//         "Madgaon",
//         "Morjim",
//         "Mormugao",
//         "Navelim",
//         "North Goa",
//         "Palle",
//         "Panaji",
//         "Pernem",
//         "Ponda",
//         "Quepem",
//         "Queula",
//         "Raia",
//         "Saligao",
//         "Sancoale",
//         "Sanguem",
//         "Sanquelim",
//         "Sanvordem",
//         "Serula",
//         "Solim",
//         "South Goa",
//         "Taleigao",
//         "Vagator",
//         "Valpoy",
//         "Varca",
//         "Vasco da Gama",
//         "Anjuna",
//         "Arpora",
//         "Assagao",
//         "Parra",
//         "Siolim",
//         "Reis Magos",
//         "Nerul",
//       ].map((city, idx) => ({ id: idx + 1, name: city }));
//     }

//     // For all other states, look up from indiaStates
//     const stateObj = indiaStates.find((s) => s.name === scrapeDestination);
//     return (
//       stateObj?.cities?.map?.((c, idx) =>
//         typeof c === "string" ? { id: idx + 1, name: c } : c,
//       ) ?? []
//     );
//   })();

//   return (
//     <div
//       className={`flex bg-[#F8F9FA] transition-all duration-500 ${
//         isMobile ? "ml-0" : isSidebarOpen ? "w-[82vw]" : "w-[95vw]"
//       }`}
//     >
//       <Menubar
//         isOpen={isSidebarOpen}
//         setIsOpen={setIsSidebarOpen}
//         isMobile={isMobile}
//       />

//       <main
//         className={`p-5 lg:p-6 transition-all duration-500 w-full ${
//           isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
//         }`}
//       >
//         <Outlet />

//         {/* Header */}
//         <div className="flex justify-between gap-5 items-start lg:items-center">
//           <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
//             <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
//               Add New Property
//             </p>
//           </div>
//           <div className="flex gap-4 items-center">
//             <div className="mt-2">
//               {villaUrl && (
//                 <a
//                   href={villaUrl}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-blue-600 hover:text-blue-800 text-sm uppercase font-medium inline-flex items-center gap-1"
//                 >
//                   Open Villa Url
//                   <svg
//                     viewBox="0 0 14 15"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="10"
//                     className="inline-block"
//                   >
//                     <path
//                       d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
//                       fill="currentColor"
//                     />
//                   </svg>
//                 </a>
//               )}
//             </div>

//             <div>
//               <button
//                 onClick={() => setShowScrapeModal(true)}
//                 className="border border-gray-300 bg-green-700 hover:bg-green-900 text-white py-2 px-4 rounded-lg"
//               >
//                 Scrape Data
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="my-10">
//           <div className="">
//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center justify-between">
//               <div>
//                 {/* goes to table "properties" as "propertyname" */}
//                 <input
//                   type="text"
//                   name="propertyname"
//                   required
//                   maxLength={50}
//                   value={propertyname}
//                   onChange={(e) => setpropertyname(e.target.value)}
//                   className="text-2xl sm:text-3xl font-bold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   placeholder="Enter Property Name"
//                 />{" "}
//                 <p className="text-xs mt-1">
//                   {propertyname.length.toString().padStart(2, "0")}/50
//                 </p>
//                 {/* goes to table "properties" as "description" */}
//                 <div className="my-4">
//                   <textarea
//                     rows="2"
//                     name="description"
//                     maxLength={250}
//                     value={description}
//                     onChange={(e) => setDescription(e.target.value)}
//                     className="w-full text-gray-700 text-lg  lg:w-[100%] border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     placeholder="Enter Property Description..."
//                   />
//                   <p className="text-xs">
//                     {description.length.toString().padStart(2, "0")}/250
//                   </p>
//                 </div>
//               </div>

//               <div>
//                 {/* Don't remove div - this is to replicate the layout and sizing of website */}
//               </div>

//               <div>
//                 <div className="mt-8 space-y-4 ">
//                   {propertyThumbnail ? (
//                     <>
//                       <img
//                         src={propertyThumbnail}
//                         alt="Uploaded Map"
//                         className="h-full max-h-[85vh] aspect-[5/4] w-full object-cover"
//                       />

//                       <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
//                         <div className="flex gap-1 items-center">
//                           Replace Img <FcAddImage size={20} />{" "}
//                         </div>
//                         {/* goes to table "hotelInfo" as portraitimg */}
//                         <input
//                           type="file"
//                           accept="image/*"
//                           name="thumbnailimg"
//                           onChange={handlepropertyThumbnail}
//                           className="hidden aspect-[5/4] w-full"
//                         />
//                       </label>
//                     </>
//                   ) : (
//                     <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
//                       <FcAddImage size={50} />
//                       <span className="text-sm mt-2">
//                         Click to upload Thumbnail image
//                       </span>
//                       {/* goes to table "hotelInfo" as portraitimg */}
//                       <input
//                         type="file"
//                         name="thumbnailimg"
//                         accept="image/*"
//                         onChange={handlepropertyThumbnail}
//                         className="hidden aspect-[5/4] w-full"
//                       />
//                     </label>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Banner carousel */}
//             <div className="mt-5 -mx-3">
//               {/* goes to table "propertyImages" as "banner1"....till ..."banner5" */}

//               <Carousel
//                 responsive={responsive_BannerCarousel}
//                 autoPlay={false}
//                 autoPlaySpeed={3000}
//                 infinite
//                 keyBoardControl
//                 showDots={false}
//                 customLeftArrow={<CustomLeftArrowBannerCarousel />}
//                 customRightArrow={<CustomRightArrowBannerCarousel />}
//               >
//                 {[...Array(MAX_CARDS)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[350px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
//                       {selectedImages[index] ? (
//                         <>
//                           <img
//                             src={selectedImages[index]}
//                             alt="Img"
//                             className="w-full h-full object-cover"
//                           />

//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/*"
//                               onChange={(e) => handleImageUpload(e, index)}
//                               className="hidden"
//                             />
//                           </label>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/*"
//                             onChange={(e) => handleImageUpload(e, index)}
//                             className="hidden"
//                           />
//                         </label>
//                       )}

//                       <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
//                         {index + 1}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>
//             </div>
//           </div>

//           <div className="grid grid-cols-1">
//             <div className="order-1 lg:order-2 mt-5 lg:mt-10 lg:text-center">
//               {/* goes to table "properties" as "heading" */}
//               <input
//                 type="text"
//                 maxLength={100}
//                 value={heading}
//                 onChange={(e) => setHeading(e.target.value)}
//                 className="fontPD flex mx-auto text-center text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                 style={{
//                   letterSpacing: "1px",
//                   wordSpacing: "2px",
//                   lineHeight: 1.3,
//                 }}
//                 placeholder="Heading"
//               />
//               <p className="text-xs text-center block mt-1">
//                 {heading.length.toString().padStart(2, "0")}/100
//               </p>

//               {/* goes to table "properties" as "content" */}
//               <div className="my-5 lg:my-10">
//                 <textarea
//                   type="text"
//                   rows="3"
//                   maxLength={400}
//                   value={content}
//                   onChange={(e) => setContent(e.target.value)}
//                   className="flex mx-auto w-full xl:w-[950px] text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   placeholder="Content..."
//                 />
//                 <span className="text-xs block mt-1">
//                   {content.length.toString().padStart(2, "0")}/400
//                 </span>
//               </div>
//             </div>
//             {/* goes to table "properties" as "catchquote" */}

//             <div className="mt-5 lg:mt-0 order-3">
//               <input
//                 type="text"
//                 maxLength={100}
//                 value={catchyQuote}
//                 onChange={(e) => setCatchyQuote(e.target.value)}
//                 className="flex mx-auto w-full md:text-xl text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                 placeholder="Catchy Quote"
//               />
//               <p className="text-xs text-center block mt-1">
//                 {catchyQuote.length.toString().padStart(2, "0")}/100
//               </p>

//               <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-5 justify-center">
//                 <div className="h-[1px] w-full bg-gray-300" />
//                 <img
//                   src="../assets/zorba_logo.webp"
//                   alt="Img"
//                   className="h-4 w-auto"
//                 />
//                 <div className="h-[1px] w-full bg-gray-300" />
//               </div>
//             </div>
//           </div>

//           {/* Carousel of Experience */}
//           <div className="mt-5 mb-10" ref={containerRef_amenities}>
//             <div className="text-center mb-4">
//               <h2 className="text-2xl font-semibold">Amenities</h2>
//               <p className="text-gray-500 mt-1">
//                 {selectedAmenities.length} selected
//               </p>
//             </div>

//             <input
//               type="text"
//               placeholder="Search amenities..."
//               className="w-full mb-4 px-4 py-3 border rounded-lg focus:outline-none focus:ring-0 focus:border-[1.5px] focus:border-black"
//               value={searchTerm}
//               onFocus={() => setIsOpen_amenities(true)}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />

//             {isOpen_amenities && (
//               <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 overflow-y-auto max-h-96">
//                 {filteredAmenities.map((amenity, index) => {
//                   const isSelected = selectedAmenities.includes(amenity.id);

//                   return (
//                     <div
//                       key={index}
//                       onClick={() => toggleAmenity(amenity.id)}
//                       className={`relative cursor-pointer rounded-xl border px-3 py-5 transition-all duration-200
//                         ${
//                           isSelected
//                             ? "border-black shadow-md"
//                             : "border-gray-200 hover:border-gray-400"
//                         }`}
//                     >
//                       {/* Tick */}
//                       {isSelected && (
//                         <div className="absolute top-3 right-3 bg-green-800 text-white rounded-full p-1">
//                           <Check size={16} />
//                         </div>
//                       )}

//                       {/* Icon */}
//                       <img
//                         src={amenity.url}
//                         alt={amenity.name}
//                         className="w-auto h-20 mb-3 object-contain"
//                       />

//                       {/* Text */}
//                       <p className="text-base font-medium">{amenity.name}</p>
//                     </div>
//                   );
//                 })}
//               </div>
//             )}

//             <Carousel
//               responsive={responsive_ExperienceCarousel}
//               autoPlay={false}
//               infinite
//               keyBoardControl
//               showDots={showDots}
//               customLeftArrow={<CustomLeftArrowBannerCarousel />}
//               customRightArrow={<CustomRightArrowBannerCarousel />}
//             >
//               {experienceData.map((item, index) => (
//                 <div
//                   key={index}
//                   className="mx-3 my-1 bg-white border rounded-xl shadow-md px-5 py-10"
//                 >
//                   <div>
//                     <div className="text-3xl text-[#99ABA0] mb-4">
//                       {
//                         iconOptions.find((icon) => icon.value === item.icon)
//                           ?.icon
//                       }
//                     </div>

//                     {/* goes to table "experiences" as "expimage,expimage2	,	expimage3	,	expimage4	,	expimage5"		 */}

//                     <div className="grid grid-cols-1 justify-between w-full">
//                       <div className="text-3xl text-[#99ABA0] mb-4">
//                         {item.file ? (
//                           <img
//                             src={URL.createObjectURL(item.file)}
//                             alt="preview"
//                             className="w-12 h-12 object-contain"
//                           />
//                         ) : (
//                           <span className="text-gray-400">No image</span>
//                         )}
//                       </div>

//                       <div>
//                         {/* goes to table "experiences" as expimage…expimage5 */}
//                         <label className="block text-left text-xs font-semibold mb-1">
//                           Upload Experience Icon
//                         </label>
//                         <input
//                           type="file"
//                           accept="image/*"
//                           onChange={(e) => {
//                             const newData = [...experienceData];
//                             newData[index].file = e.target.files[0];
//                             setExperienceData(newData);
//                           }}
//                           className="w-full border p-1 mb-4 text-sm focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   {/* goes to table "experiences" as "exptitle,exptitle2	,	exptitle3	,	exptitle4	,	exptitle5"		 */}
//                   <input
//                     type="text"
//                     maxLength={25}
//                     placeholder="Enter title"
//                     className="w-full mb-1 text-lg font-semibold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     value={item.title}
//                     onChange={(e) => {
//                       const newData = [...experienceData];
//                       newData[index].title = e.target.value;
//                       setExperienceData(newData);
//                     }}
//                   />
//                   <p className="text-xs text-left block mb-3">
//                     {item.title.length.toString().padStart(2, "0")}/25
//                   </p>
//                   {/* goes to table "experiences" as "expcon	,expcon2	,expcon3,	expcon4	,expcon5"		 */}
//                   {/* <textarea
//                       rows="3"
//                       placeholder="Enter content..."
//                       maxLength={100}
//                       className="w-full text-gray-500 border p-2 resize-none border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                       value={item.content}
//                       onChange={(e) => {
//                         const newData = [...experienceData];
//                         newData[index].content = e.target.value;
//                         setExperienceData(newData);
//                       }}
//                     ></textarea> */}
//                 </div>
//               ))}
//             </Carousel>
//           </div>

//           {/* Images carousel 1 & 2 */}
//           <div className="grid grid-cols-1 md:grid-cols-[40%_60%] items-center mt-5">
//             <div className="md:hidden flex flex-col mb-5">
//               {/* goes to table "propertyImages" as "title1" */}
//               <div className="my-5">
//                 <input
//                   type="text"
//                   maxLength={30}
//                   value={title1}
//                   onChange={(e) => setTitle1(e.target.value)}
//                   className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   placeholder="Title 1 (highlight property speciality)"
//                 />
//                 <p className="text-xs block mt-1">
//                   {title1.length.toString().padStart(2, "0")}/30
//                 </p>
//               </div>

//               {/* goes to table "propertyImages" as "rc1" */}
//               <textarea
//                 type="text"
//                 rows="2"
//                 maxLength={150}
//                 value={relevantContent1}
//                 onChange={(e) => setRelevantContent1(e.target.value)}
//                 className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                 placeholder="Relevant Content 1..."
//               />
//               <p className="text-xs block mt-1">
//                 {relevantContent1.length.toString().padStart(2, "0")}/150
//               </p>
//             </div>
//             {/* goes to table "propertyImages" as "img1_c1	img2_c1	img3_c1	img4_c1	img5_c1	" */}
//             <div className="-mx-3 md:mx-0">
//               <Carousel
//                 responsive={responsive_ImageCarouselOne}
//                 autoPlay={false}
//                 autoPlaySpeed={3000}
//                 infinite
//                 keyBoardControl
//                 showDots={showDots}
//                 customLeftArrow={<CustomLeftArrowBannerCarousel />}
//                 customRightArrow={<CustomRightArrowBannerCarousel />}
//               >
//                 {[...Array(MAX_CARDS)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[400px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
//                       {imageCarouselOne[index] ? (
//                         <>
//                           <img
//                             src={imageCarouselOne[index]}
//                             alt={`Uploaded ${index}`}
//                             className="w-full h-full object-cover"
//                           />

//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/*"
//                               onChange={(e) =>
//                                 handleImageUploadCarouselOne(e, index)
//                               }
//                               className="hidden"
//                             />
//                           </label>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/*"
//                             onChange={(e) =>
//                               handleImageUploadCarouselOne(e, index)
//                             }
//                             className="hidden"
//                           />
//                         </label>
//                       )}

//                       <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
//                         {index + 1}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>
//             </div>

//             {/* goes to table "propertyImages" as "img1_c2	img2_c2	img3_c2	img4_c2	img5_c2	" */}

//             <div className="hidden md:block">
//               <Carousel
//                 responsive={responsive_ImageCarouselTwo}
//                 autoPlay={false}
//                 autoPlaySpeed={5000}
//                 infinite
//                 keyBoardControl
//                 showDots={showDots}
//                 customLeftArrow={<CustomLeftArrowBannerCarousel />}
//                 customRightArrow={<CustomRightArrowBannerCarousel />}
//               >
//                 {[...Array(MAX_CARDS)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="flex flex-col items-center justify-between w-full h-[400px] md:h-[600px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
//                       {imageCarouselTwo[index] ? (
//                         <>
//                           <img
//                             src={imageCarouselTwo[index]}
//                             alt={`Uploaded ${index}`}
//                             className="w-full h-full object-cover"
//                           />

//                           {/* Replace Image Label */}
//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/*"
//                               onChange={(e) =>
//                                 handleImageUploadCarouselTwo(e, index)
//                               }
//                               className="hidden"
//                             />
//                           </label>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/*"
//                             onChange={(e) =>
//                               handleImageUploadCarouselTwo(e, index)
//                             }
//                             className="hidden"
//                           />
//                         </label>
//                       )}

//                       {/* Card Number */}
//                       <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
//                         {index + 1}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>

//               <div className="flex flex-col mx-3">
//                 {/* goes to table "propertyImages" as "title1" */}
//                 <div className="my-5">
//                   <input
//                     type="text"
//                     name="title1"
//                     value={title1}
//                     onChange={(e) => setTitle1(e.target.value)}
//                     maxLength={30}
//                     className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     placeholder="Title 1 (highlight property speciality)"
//                   />
//                   <p className="text-xs block mt-1">
//                     {title1.length.toString().padStart(2, "0")}/30
//                   </p>
//                 </div>

//                 {/* goes to table "propertyImages" as "rc1" */}
//                 <textarea
//                   type="text"
//                   rows="2"
//                   name="rc1"
//                   maxLength={150}
//                   value={relevantContent1}
//                   onChange={(e) => setRelevantContent1(e.target.value)}
//                   className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   placeholder="Relevant Content 1..."
//                 />
//                 <p className="text-xs block mt-1">
//                   {relevantContent1.length.toString().padStart(2, "0")}/150
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Images carousel 3 & 4 */}
//           <div className="grid grid-cols-1 md:grid-cols-[60%_40%] items-center mt-8">
//             {/* for small screen */}
//             <div className="md:hidden flex flex-col mb-5">
//               {/* goes to table "propertyImages" as "title2" */}
//               <div className="my-5">
//                 <input
//                   type="text"
//                   maxLength={30}
//                   value={title2}
//                   onChange={(e) => setTitle2(e.target.value)}
//                   className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   placeholder="Title 2 (highlight property speciality)"
//                 />
//                 <p className="text-xs block mt-1">
//                   {title2.length.toString().padStart(2, "0")}/30
//                 </p>
//               </div>
//               {/* goes to table "propertyImages" as "rc2" */}
//               <textarea
//                 type="text"
//                 rows="2"
//                 maxLength={150}
//                 value={content2}
//                 onChange={(e) => setContent2(e.target.value)}
//                 className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                 placeholder="Relevant Content 2..."
//               />
//               <p className="text-xs block mt-1">
//                 {content2.length.toString().padStart(3, "0")}/150
//               </p>
//             </div>

//             {/* goes to table "propertyImages" as "img1_c3	img2_c3	img3_c3	img4_c3	img5_c3	" */}
//             <div className="hidden md:block">
//               <Carousel
//                 responsive={responsive_ImageCarouselThree}
//                 autoPlay={false}
//                 autoPlaySpeed={5000}
//                 infinite
//                 keyBoardControl
//                 showDots={showDots}
//                 customLeftArrow={<CustomLeftArrowBannerCarousel />}
//                 customRightArrow={<CustomRightArrowBannerCarousel />}
//               >
//                 {[...Array(MAX_CARDS)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[600px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
//                       {imageCarouselThree[index] ? (
//                         <>
//                           <img
//                             src={imageCarouselThree[index]}
//                             alt={`Uploaded ${index}`}
//                             className="w-full h-full object-cover"
//                           />

//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/*"
//                               onChange={(e) =>
//                                 handleImageUploadCarouselThree(e, index)
//                               }
//                               className="hidden"
//                             />
//                           </label>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/*"
//                             onChange={(e) =>
//                               handleImageUploadCarouselThree(e, index)
//                             }
//                             className="hidden"
//                           />
//                         </label>
//                       )}

//                       <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
//                         {index + 1}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>

//               <div className="flex flex-col mx-3">
//                 {/* goes to table "propertyImages" as "title2" */}
//                 <div className="my-5">
//                   <input
//                     type="text"
//                     name="title2"
//                     maxLength={30}
//                     value={title2}
//                     onChange={(e) => setTitle2(e.target.value)}
//                     className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     placeholder="Title 2 (highlight property speciality)"
//                   />
//                   <p className="text-xs block mt-1">
//                     {title2.length.toString().padStart(2, "0")}/30
//                   </p>
//                 </div>

//                 {/* goes to table "propertyImages" as "rc2" */}
//                 <textarea
//                   type="text"
//                   rows="2"
//                   name="rc2"
//                   maxLength={150}
//                   value={content2}
//                   onChange={(e) => setContent2(e.target.value)}
//                   className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   placeholder="Relevant Content 2..."
//                 />
//                 <p className="text-xs block mt-1">
//                   {content2.length.toString().padStart(3, "0")}/150
//                 </p>
//               </div>
//             </div>

//             {/* goes to table "propertyImages" as "img1_c4	img2_c4	img3_c4	img4_c4	img5_c4	" */}
//             <div className="-mx-3 md:mx-0">
//               <Carousel
//                 responsive={responsive_ImageCarouselFour}
//                 autoPlay={false}
//                 autoPlaySpeed={3000}
//                 infinite
//                 keyBoardControl
//                 showDots={showDots}
//                 customLeftArrow={<CustomLeftArrowBannerCarousel />}
//                 customRightArrow={<CustomRightArrowBannerCarousel />}
//               >
//                 {[...Array(MAX_CARDS)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[400px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
//                       {imageCarouselFour[index] ? (
//                         <>
//                           <img
//                             src={imageCarouselFour[index]}
//                             alt={`Uploaded ${index}`}
//                             className="w-full h-full object-cover"
//                           />

//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/*"
//                               onChange={(e) =>
//                                 handleImageUploadCarouselFour(e, index)
//                               }
//                               className="hidden"
//                             />
//                           </label>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/*"
//                             onChange={(e) =>
//                               handleImageUploadCarouselFour(e, index)
//                             }
//                             className="hidden"
//                           />
//                         </label>
//                       )}

//                       <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
//                         {index + 1}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>
//             </div>
//           </div>

//           {/* Images carousel 5 */}
//           <div className="grid grid-cols-1 mt-8">
//             <div className="-mx-3 md:mx-0 order-2 md:order-1">
//               {/* goes to table "propertyImages" as "mg1_C5	img2_c5	img3_c5	img4_c5	img5_c5	" */}
//               <Carousel
//                 responsive={responsive_ImageCarouselFive}
//                 autoPlay={false}
//                 autoPlaySpeed={3000}
//                 infinite
//                 keyBoardControl
//                 showDots={showDots}
//                 customLeftArrow={<CustomLeftArrowBannerCarousel />}
//                 customRightArrow={<CustomRightArrowBannerCarousel />}
//               >
//                 {[...Array(MAX_CARDS)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[520px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
//                       {imageCarouselFive[index] ? (
//                         <>
//                           <img
//                             src={imageCarouselFive[index]}
//                             alt={`Uploaded ${index}`}
//                             className="w-full h-full object-cover"
//                           />

//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/*"
//                               onChange={(e) =>
//                                 handleImageUploadCarouselFive(e, index)
//                               }
//                               className="hidden"
//                             />
//                           </label>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/*"
//                             onChange={(e) =>
//                               handleImageUploadCarouselFive(e, index)
//                             }
//                             className="hidden"
//                           />
//                         </label>
//                       )}

//                       <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
//                         {index + 1}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>
//             </div>

//             {/* goes to table "propertyImages" as "title3" */}
//             <div className="flex flex-col mb-5 md:mb-0 md:mx-3 order-1 md:order-2 md:w-[55%]">
//               <div className="my-5">
//                 <input
//                   type="text"
//                   maxLength={30}
//                   value={title3}
//                   onChange={(e) => setTitle3(e.target.value)}
//                   className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   placeholder="Title 3 (highlight property speciality)"
//                 />
//                 <p className="text-xs block mt-1">
//                   {title3.length.toString().padStart(2, "0")}/30
//                 </p>
//               </div>

//               {/* goes to table "propertyImages" as "rc3" */}
//               <textarea
//                 type="text"
//                 rows="2"
//                 maxLength={150}
//                 value={relevantContent3}
//                 onChange={(e) => setRelevantContent3(e.target.value)}
//                 className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                 placeholder="Relevant Content 3..."
//               />
//               <p className="text-xs block mt-1">
//                 {relevantContent3.length.toString().padStart(2, "0")}/150
//               </p>
//             </div>
//           </div>

//           <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 justify-center">
//             <div className="h-[1px] w-full bg-gray-300" />
//             <img
//               src="../assets/zorba_logo.webp"
//               alt="Img"
//               className="h-4 w-auto"
//             />
//             <div className="h-[1px] w-full bg-gray-300" />
//           </div>

//           {/* Map */}
//           <div className="">
//             <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
//               <div>
//                 {/* goes to table "propertyImages" as maptitle */}
//                 <textarea
//                   type="text"
//                   maxLength={50}
//                   value={maptitle}
//                   onChange={(e) => setmaptitle(e.target.value)}
//                   rows={2}
//                   className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   style={{
//                     letterSpacing: "1px",
//                     wordSpacing: "2px",
//                     lineHeight: 1.3,
//                   }}
//                   placeholder="Map Title"
//                 />
//                 <p className="text-xs block">
//                   {maptitle.length.toString().padStart(2, "0")}/50
//                 </p>
//               </div>

//               <div>
//                 {/* goes to table "propertyImages" as mapcontent */}
//                 <textarea
//                   type="text"
//                   maxLength={150}
//                   value={mapcontent}
//                   onChange={(e) => setmapcontent(e.target.value)}
//                   rows={4}
//                   className="w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   placeholder="Map Content..."
//                 />
//                 <p className="text-xs block">
//                   {mapcontent.length.toString().padStart(2, "0")}/150
//                 </p>
//               </div>
//             </div>
//             {/* here i want two input feilds mapLan and maplong */}
//             <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Map Latitude (maplang)
//                 </label>
//                 <input
//                   type="number"
//                   step="0.00000001"
//                   name="maplang"
//                   placeholder="Enter Latitude"
//                   className="w-full text-2xl md:text-3xl lg:text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Map Longitude (maplong)
//                 </label>
//                 <input
//                   type="number"
//                   step="0.00000001"
//                   name="maplong"
//                   placeholder="Enter Longitude"
//                   className="w-full text-2xl md:text-3xl lg:text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                 />
//               </div>
//             </div>
//             {/* <div className="mt-5">
//               {uploadedMap ? (
//                 <>
//                   <img
//                     src={uploadedMap}
//                     alt="Uploaded Map"
//                     className="w-full object-contain"
//                   />

//                   <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
//                     <div className="flex gap-1 items-center">
//                       Replace Map <FcAddImage size={20} />{" "}
//                     </div>

//                     <input
//                       type="file"
//                       accept="image/*"
//                       onChange={handleMapUpload}
//                       className="hidden"
//                     />
//                   </label>
//                 </>
//               ) : (
//                 <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
//                   <FcAddImage size={50} />
//                   <span className="text-sm mt-2">
//                     Click to upload map image
//                   </span>

//                   <input
//                     type="file"
//                     accept="image/*"
//                     onChange={handleMapUpload}
//                     className="hidden"
//                   />
//                 </label>
//               )}

//             </div> */}
//           </div>

//           <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 md:my-12 justify-center">
//             <div className="h-[1px] w-full bg-gray-300" />
//             <img
//               src="../assets/zorba_logo.webp"
//               alt="Img"
//               className="h-4 w-auto"
//             />
//             <div className="h-[1px] w-full bg-gray-300" />
//           </div>

//           {/* Experience */}
//           <div className="text-center">
//             {/* goes to table "properties" as "aboutloc" */}
//             <input
//               type="text"
//               maxLength={20}
//               value={aboutlocation}
//               onChange={(e) => setaboutlocation(e.target.value)}
//               placeholder="About the location"
//               className="text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//             />
//             <p className="text-xs block mt-1">
//               {aboutlocation.length.toString().padStart(2, "0")}/20
//             </p>
//             <br />

//             {/* goes to table "properties" as "loctagline" */}
//             <input
//               type="text"
//               placeholder="Location Tagline"
//               maxLength={30}
//               value={locationTagline}
//               onChange={(e) => setLocationTagline(e.target.value)}
//               className="mt-3 text-2xl md:text-3xl lg:text-4xl text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//               style={{
//                 letterSpacing: "1px",
//                 wordSpacing: "2px",
//                 lineHeight: 1.3,
//               }}
//             />
//             <p className="text-xs block mt-1">
//               {locationTagline.length.toString().padStart(2, "0")}/30
//             </p>
//             <br />

//             {/* goes to table "properties" as "loccontent" */}
//             <div className="my-5">
//               <input
//                 type="text"
//                 placeholder="Content..."
//                 maxLength={100}
//                 value={locationContent}
//                 onChange={(e) => setLocationContent(e.target.value)}
//                 className="flex mx-auto w-full lg:w-[800px] font-thin text-center text-gray-500 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                 style={{ lineHeight: 2 }}
//               />
//               <p className="text-xs block mt-1 text-center">
//                 {locationContent.length.toString().padStart(2, "0")}/100
//               </p>
//             </div>
//             {/* Concierge Service */}
//             <div className="my-5">
//               <input
//                 type="text"
//                 // maxLength={20}
//                 value={conciergeService}
//                 onChange={(e) => setConciergeService(e.target.value)}
//                 placeholder=" Concierge Services PDF"
//                 className="text-center border-b lg:w-[400px] border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//               />

//               <p className="text-xs block mt-1">*paste PDF drive link here*</p>
//             </div>
//             {/* <button
//                 className="zorba_btn text-sm uppercase"
//                 style={{ "--clr": "#1B2826" }}
//               >
//                 Concierge Services
//                 <span className="zorba_btn__icon-wrapper">
//                   <svg
//                     viewBox="0 0 14 15"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="zorba_btn__icon-svg"
//                     width="10"
//                   >
//                     <path
//                       d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
//                       fill="currentColor"
//                     ></path>
//                   </svg>

//                   <svg
//                     viewBox="0 0 14 15"
//                     fill="none"
//                     width="10"
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="zorba_btn__icon-svg zorba_btn__icon-svg--copy"
//                   >
//                     <path
//                       d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
//                       fill="currentColor"
//                     ></path>
//                   </svg>
//                 </span>
//               </button> */}

//             <div className="mt-8 space-y-4 ">
//               {gridImg_fullWidth ? (
//                 <div
//                   className="relative w-full h-80 bg-cover bg-center "
//                   style={{ backgroundImage: `url(${gridImg_fullWidth})` }}
//                 >
//                   <label className="absolute bottom-2 left-2 text-sm bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
//                     <div className="flex gap-1 items-center ">
//                       Replace <FcAddImage size={20} />
//                     </div>
//                     <input
//                       type="file"
//                       accept="image/*"
//                       className="hidden"
//                       onChange={(e) =>
//                         handleMediaUpload_gridImages(e, setGridImg_fullWidth)
//                       }
//                     />
//                   </label>
//                 </div>
//               ) : (
//                 <label className="flex flex-col items-center justify-center w-full h-80 border-2 border-dashed border-gray-400 cursor-pointer">
//                   <FcAddImage size={50} />
//                   <span className="text-sm mt-2">
//                     Click to upload full image
//                   </span>
//                   {/* goes to table "propertyImages" as  "imagegrid1" */}
//                   <input
//                     type="file"
//                     accept="image/*"
//                     className="hidden"
//                     onChange={(e) =>
//                       handleMediaUpload_gridImages(e, setGridImg_fullWidth)
//                     }
//                   />
//                 </label>
//               )}

//               <div className="grid grid-cols-2 gap-3">
//                 {[
//                   { img: gridImg1, setter: setGridImg1 },
//                   { img: gridImg2, setter: setGridImg2 },
//                 ].map((item, i) =>
//                   item.img ? (
//                     <div
//                       key={i}
//                       className="relative w-full h-48 md:h-72 bg-cover bg-center"
//                       style={{ backgroundImage: `url(${item.img})` }}
//                     >
//                       <label className="absolute bottom-2 left-2 text-xs bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                         <div className="flex gap-1 items-center">
//                           Replace <FcAddImage size={16} />
//                         </div>
//                         <input
//                           type="file"
//                           accept="image/*"
//                           className="hidden"
//                           onChange={(e) =>
//                             handleMediaUpload_gridImages(e, item.setter)
//                           }
//                         />
//                       </label>
//                     </div>
//                   ) : (
//                     <label
//                       key={i}
//                       className="flex flex-col items-center justify-center w-full h-48 md:h-72 border-2 border-dashed border-gray-400 cursor-pointer"
//                     >
//                       <FcAddImage size={40} />
//                       <span className="text-xs mt-2">
//                         Click to upload image
//                       </span>
//                       {/* goes to table "propertyImages" as  "imagegrid2,imagegrid3" */}
//                       <input
//                         type="file"
//                         accept="image/*"
//                         className="hidden"
//                         onChange={(e) =>
//                           handleMediaUpload_gridImages(e, item.setter)
//                         }
//                       />
//                     </label>
//                   ),
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 md:my-12 justify-center">
//             <div className="h-[1px] w-full bg-gray-300" />
//             <img
//               src="../assets/zorba_logo.webp"
//               alt="Img"
//               className="h-4 w-auto"
//             />
//             <div className="h-[1px] w-full bg-gray-300" />
//           </div>

//           {/* Tailored Experience */}
//           <div className="">
//             <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
//               <div>
//                 {/* goes to table "experiences" as "expnamemain" */}
//                 <input
//                   type="text"
//                   placeholder="Experience"
//                   maxLength={50}
//                   value={tailoredExperience}
//                   onChange={(e) => setTailoredExperience(e.target.value)}
//                   className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                   style={{
//                     letterSpacing: "1px",
//                     wordSpacing: "2px",
//                     lineHeight: 1.3,
//                   }}
//                 />
//                 <p className="text-xs block mt-1">
//                   {tailoredExperience.length.toString().padStart(2, "0")}/50
//                 </p>

//                 {/* goes to table "experiences" as "expcontentmain" */}
//                 <textarea
//                   type="text"
//                   rows={2}
//                   placeholder="Content..."
//                   value={tailoredExperienceContent}
//                   onChange={(e) => setTailoredExperienceContent(e.target.value)}
//                   maxLength={150}
//                   className="mt-3 w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                 />
//                 <p className="text-xs block">
//                   {tailoredExperienceContent.length.toString().padStart(2, "0")}
//                   /150
//                 </p>
//               </div>

//               <div className="flex lg:justify-end">
//                 <button
//                   className="zorba_btn text-sm uppercase"
//                   style={{ "--clr": "#1B2826" }}
//                 >
//                   Plan your next trip
//                   <span className="zorba_btn__icon-wrapper">
//                     <svg
//                       viewBox="0 0 14 15"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="zorba_btn__icon-svg"
//                       width="10"
//                     >
//                       <path
//                         d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
//                         fill="currentColor"
//                       ></path>
//                     </svg>

//                     <svg
//                       viewBox="0 0 14 15"
//                       fill="none"
//                       width="10"
//                       xmlns="http://www.w3.org/2000/svg"
//                       className="zorba_btn__icon-svg zorba_btn__icon-svg--copy"
//                     >
//                       <path
//                         d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
//                         fill="currentColor"
//                       ></path>
//                     </svg>
//                   </span>
//                 </button>
//               </div>
//             </div>

//             {/* Carousel of Tailored Experience */}
//             <div className="mt-5 -mx-3">
//               {/* goes to table "experiences" as "miniexpimg1	and miniexpimg2" */}
//               <Carousel
//                 ref={carouselRef}
//                 responsive={responsive_TailoredExpCarousel}
//                 autoPlay={false}
//                 autoPlaySpeed={3000}
//                 infinite
//                 keyBoardControl
//                 showDots={showDots}
//                 customLeftArrow={<CustomLeftArrowTailoredExpCarousel />}
//                 customRightArrow={<CustomRightArrowTailoredExpCarousel />}
//                 beforeChange={(nextSlide) => setActiveCardIndex(nextSlide)}
//               >
//                 {[...Array(MAX_CARDS_Exp)].map((_, index) => (
//                   <div key={index} className="mx-3">
//                     <div className="relative w-full h-[350px] border-2 border-dashed border-gray-400 overflow-hidden">
//                       {tailoredExpData[index]?.img ? (
//                         <>
//                           <img
//                             src={tailoredExpData[index].img}
//                             alt="Img"
//                             className="w-full h-full object-cover"
//                           />
//                           <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
//                             <div className="flex gap-1 items-center">
//                               Replace <FcAddImage size={20} />
//                             </div>
//                             <input
//                               type="file"
//                               accept="image/*"
//                               onChange={(e) => {
//                                 const file = e.target.files[0];
//                                 if (file) {
//                                   const newData = [...tailoredExpData];
//                                   newData[index].img =
//                                     URL.createObjectURL(file); // preview
//                                   newData[index].file = file; // actual File for backend
//                                   setTailoredExpData(newData);
//                                 }
//                               }}
//                               className="hidden"
//                             />
//                           </label>
//                         </>
//                       ) : (
//                         <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
//                           <FcAddImage size={50} />
//                           <input
//                             type="file"
//                             accept="image/*"
//                             onChange={(e) => {
//                               const file = e.target.files[0];
//                               if (file) {
//                                 const newData = [...tailoredExpData];
//                                 newData[index].img = URL.createObjectURL(file);
//                                 newData[index].file = file;
//                                 setTailoredExpData(newData);
//                               }
//                             }}
//                             className="hidden"
//                           />
//                         </label>
//                       )}
//                     </div>

//                     <input
//                       type="text"
//                       maxLength={50}
//                       placeholder="Experience Title"
//                       value={tailoredExpData[index]?.title || ""}
//                       onChange={(e) => {
//                         const newData = [...tailoredExpData];
//                         newData[index].title = e.target.value;
//                         setTailoredExpData(newData);
//                       }}
//                       className="w-full text-xl mt-5 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                     />
//                     <p className="text-xs block mt-1">
//                       {(tailoredExpData[index]?.title?.length || 0)
//                         .toString()
//                         .padStart(2, "0")}
//                       /50
//                     </p>
//                     <br />

//                     <div className="my-5">
//                       <textarea
//                         rows={2}
//                         placeholder="Experience Content..."
//                         maxLength={100}
//                         value={tailoredExpData[index]?.content || ""}
//                         onChange={(e) => {
//                           const newData = [...tailoredExpData];
//                           newData[index].content = e.target.value;
//                           setTailoredExpData(newData);
//                         }}
//                         className="w-full text-gray-500 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
//                       />
//                       <p className="text-xs block">
//                         {(tailoredExpData[index]?.content?.length || 0)
//                           .toString()
//                           .padStart(2, "0")}
//                         /100
//                       </p>
//                     </div>
//                   </div>
//                 ))}
//               </Carousel>

//               <div className="flex gap-5 items-center justify-center md:hidden text-sm text-gray-400 mt-3">
//                 <FaChevronLeft
//                   onClick={handlePrevSlide}
//                   className="cursor-pointer"
//                 />
//                 Showing {(activeCardIndex % TailoredExpCarousel.length) + 1} /
//                 {TailoredExpCarousel.length}
//                 <FaChevronRight
//                   onClick={handleNextSlide}
//                   className="cursor-pointer"
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 md:my-12 justify-center">
//             <div className="h-[1px] w-full bg-gray-300" />
//             <img
//               src="../assets/zorba_logo.webp"
//               alt="Img"
//               className="h-4 w-auto"
//             />
//             <div className="h-[1px] w-full bg-gray-300" />
//           </div>

//           {/* Data not to be shown in website */}
//           <div>
//             <p className="text-lg text-center mb-8">
//               Additional Required Data{" "}
//               <i>(not to be displayed on the website)</i>
//             </p>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-5">
//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as propertycode */}
//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Property Code <sub className="text-red-500 text-base">*</sub>
//                 </label>
//                 <input
//                   placeholder="Enter property code"
//                   name="input"
//                   required
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>
//               {/* Id for air bnb */}
//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as airid */}
//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Property id
//                 </label>
//                 <input
//                   placeholder="Airbnb id if available"
//                   name="airid"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>
//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as youtubelink */}
//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Property's Owner name
//                 </label>
//                 <input
//                   placeholder="Enter Owner's name"
//                   name="propertyowner"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>
//               <div className="flex flex-col w-full">
//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Property Brochure
//                 </label>
//                 <input
//                   placeholder="Enter Drive Link"
//                   name="propertyBrochure"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>
//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as currentprice */}
//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Current Price
//                 </label>
//                 <input
//                   placeholder="Enter current price"
//                   name="input"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>

//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as defaultprice */}
//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Default Price
//                 </label>
//                 <input
//                   placeholder="Enter default price"
//                   name="input"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>

//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as deposit */}

//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Security Deposit
//                 </label>
//                 <input
//                   placeholder="Enter security deposit"
//                   name="input"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>

//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as maxadult */}

//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Max Adults
//                 </label>
//                 <input
//                   placeholder="Enter max adults"
//                   name="input"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>

//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as maxchild */}

//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Max Children
//                 </label>
//                 <input
//                   placeholder="Enter max children"
//                   name="input"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>

//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as maxbed */}

//                 <label
//                   htmlFor="maxbedroom"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Max Bedroom
//                 </label>
//                 <input
//                   id="maxbedroom"
//                   name="maxbedroom"
//                   placeholder="Enter max bedroom"
//                   value={maxbedrooms}
//                   onChange={(e) => setmaxbedrooms(e.target.value)}
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>

//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as maxbath */}

//                 <label
//                   htmlFor="maxbathroom"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Max Bathroom
//                 </label>
//                 <input
//                   id="maxbathroom"
//                   name="maxbathroom"
//                   placeholder="Enter max bathroom"
//                   value={maxbathrooms}
//                   onChange={(e) => setmaxbathrooms(e.target.value)}
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>

//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as maplink */}
//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Map Location
//                 </label>
//                 <input
//                   placeholder="Enter map location"
//                   name="input"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>

//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as youtubelink */}
//                 <label
//                   for="input"
//                   className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
//                 >
//                   Youtube Link
//                 </label>
//                 <input
//                   placeholder="Enter youtube link"
//                   name="input"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 />
//               </div>

//               {/*
//               <div className="relative w-full" ref={dropdownRef_dropdownExp}>
//                 <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                   Experience
//                 </label>

//                 <div
//                   onClick={() => setIsOpen_dropdownExp((prev) => !prev)}
//                   className="border border-gray-400 p-3 rounded-lg w-full cursor-pointer text-sm bg-[#F8F9FA] focus:outline-none"
//                 >
//                   {selectedOptions_dropdownExp.length > 0
//                     ? selectedOptions_dropdownExp.join(", ")
//                     : "Select your experience(s)"}
//                 </div>

//                 {isOpen_dropdownExp && (
//                   <div className="absolute top-full left-0 w-full bg-[#F8F9FA] border border-gray-300 mt-1 rounded-md shadow-md z-10">
//                     {options_dropdownExp.map((option) => (
//                       <label
//                         key={option}
//                         className="flex items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
//                       >
//                         <input
//                           type="checkbox"
//                           checked={selectedOptions_dropdownExp.includes(option)}
//                           onChange={() => toggleOption_dropdownExp(option)}
//                           className="accent-black"
//                         />
//                         {option}
//                       </label>
//                     ))}
//                   </div>
//                 )}
//               </div> */}
//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as seasonType */}
//                 <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                   Season Type
//                 </label>

//                 <select
//                   name="seasonType"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 >
//                   <option value="">Select season type</option>
//                   <option value="Summer">Summer</option>
//                   <option value="Winter">Winter</option>
//                   <option value="Monsoon">Monsoon</option>
//                 </select>
//               </div>

//               <div className="flex flex-col w-full">
//                 {/* goes to table properties as propertytype */}
//                 <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                   Property Type<sub className="text-red-500 text-base">*</sub>
//                 </label>

//                 <select
//                   name="propertytype"
//                   required
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 >
//                   {/* <option value="">Select your property type</option> */}
//                   <option value="Villa">Villa</option>
//                   {/* <option value="Hotel">Hotel</option> */}
//                   {/* <option value="Resort">Resort</option>
//                   <option value="Apartment">Apartment</option> */}
//                 </select>
//               </div>

//               {/* <div className="flex flex-col w-full">
//                 <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                   Destination
//                 </label>

//                 <select className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
//                   <option value="">Select your destination</option>
//                   <option value="Goa">Goa</option>
//                   <option value="Himachal Pradesh">Himachal Pradesh</option>
//                   <option value="Uttarakhand">Uttarakhand</option>
//                   <option value="Leh Ladakh">Leh Ladakh</option>
//                   <option value="Rajasthan">Rajasthan</option>
//                   <option value="Gujarat">Gujarat</option>
//                   <option value="Jammu Kashmir">Jammu Kashmir</option>
//                 </select>
//               </div>

//               <div className="flex flex-col w-full">

//                 <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                   Select Location
//                 </label>

//                 <select className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
//                   <option value="">Select your location</option>
//                   <option value="Panaji">Panaji</option>
//                   <option value="Margao">Margao</option>
//                   <option value="Vasco da Gama">Vasco da Gama</option>
//                   <option value="Mapusa">Mapusa</option>
//                   <option value="Ponda">Ponda</option>

//                   <option value="Shimla">Shimla</option>
//                   <option value="Manali">Manali</option>
//                   <option value="Dharamshala">Dharamshala</option>
//                   <option value="Kullu">Kullu</option>
//                   <option value="Solan">Solan</option>
//                   <option value="Mandi">Mandi</option>
//                   <option value="Chamba">Chamba</option>
//                   <option value="Bilaspur">Bilaspur</option>

//                   <option value="Dehradun">Dehradun</option>
//                   <option value="Haridwar">Haridwar</option>
//                   <option value="Rishikesh">Rishikesh</option>
//                   <option value="Nainital">Nainital</option>
//                   <option value="Mussoorie">Mussoorie</option>
//                   <option value="Almora">Almora</option>
//                   <option value="Haldwani">Haldwani</option>
//                   <option value="Kedarnath">Kedarnath</option>
//                   <option value="Badrinath">Badrinath</option>

//                   <option value="Leh">Leh</option>
//                   <option value="Kargil">Kargil</option>
//                   <option value="Nubra Valley">Nubra Valley</option>
//                   <option value="Zanskar">Zanskar</option>
//                   <option value="Diskit">Diskit</option>
//                   <option value="Padum">Padum</option>
//                   <option value="Jaipur">Jaipur</option>
//                   <option value="Udaipur">Udaipur</option>
//                   <option value="Jodhpur">Jodhpur</option>
//                   <option value="Jaisalmer">Jaisalmer</option>
//                   <option value="Ajmer">Ajmer</option>
//                   <option value="Pushkar">Pushkar</option>
//                   <option value="Bikaner">Bikaner</option>
//                   <option value="Kota">Kota</option>
//                   <option value="Mount Abu">Mount Abu</option>
//                   <option value="Chittorgarh">Chittorgarh</option>
//                   <option value="Ahmedabad">Ahmedabad</option>
//                   <option value="Surat">Surat</option>
//                   <option value="Vadodara">Vadodara</option>
//                   <option value="Rajkot">Rajkot</option>
//                   <option value="Bhavnagar">Bhavnagar</option>
//                   <option value="Junagadh">Junagadh</option>
//                   <option value="Gandhinagar">Gandhinagar</option>
//                   <option value="Dwarka">Dwarka</option>
//                   <option value="Somnath">Somnath</option>
//                   <option value="Kutch">Kutch</option>
//                   <option value="Srinagar">Srinagar</option>
//                   <option value="Jammu">Jammu</option>
//                   <option value="Anantnag">Anantnag</option>
//                   <option value="Baramulla">Baramulla</option>
//                   <option value="Pulwama">Pulwama</option>
//                   <option value="Kupwara">Kupwara</option>
//                   <option value="Kathua">Kathua</option>
//                   <option value="Pahalgam">Pahalgam</option>
//                   <option value="Gulmarg">Gulmarg</option>
//                   <option value="Sonmarg">Sonmarg</option>
//                 </select>
//               </div> */}

//               {/* Destination (State) */}
//               <div className="flex flex-col w-full">
//                 <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                   Destination<sub className="text-red-500 text-base">*</sub>
//                 </label>
//                 <select
//                   name="destination"
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                   value={selectedState}
//                   onChange={handleStateChange}
//                   required
//                 >
//                   <option value="">Select your destination</option>
//                   {indiaStates.map((state) => (
//                     <option key={state.id} value={state.name}>
//                       {state.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Location (City) */}
//               <div className="flex flex-col w-full">
//                 <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
//                   Select Location{" "}
//                   <sub className="text-red-500 text-base">*</sub>
//                 </label>
//                 <select
//                   name="location"
//                   required
//                   value={selectedCity}
//                   onChange={(e) => setSelectedCity(e.target.value)}
//                   className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                 >
//                   <option value="">Select your location</option>
//                   {cities.map((city) => (
//                     <option key={city.id} value={city.name}>
//                       {city.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div className="grid grid-cols-2 gap-3 mt-10 w-72">
//               <button
//                 onClick={() => navigate("/Properties")}
//                 className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//               >
//                 Cancel
//               </button>

//               <button
//                 onClick={handleSave}
//                 disabled={loading}
//                 className={`px-6 z-30 py-2 rounded-lg text-center text-white relative transition-all duration-700 text-sm ${
//                   loading
//                     ? "bg-green-700 cursor-not-allowed"
//                     : "bg-green-900 hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700"
//                 }`}
//                 // className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//               >
//                 {/* Save */}
//                 {loading ? (
//                   <div className="flex items-center justify-center space-x-2">
//                     <svg
//                       className="animate-spin h-4 w-4 text-white"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                     >
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
//                       ></path>
//                     </svg>
//                     <span>Saving...</span>
//                   </div>
//                 ) : (
//                   "Save"
//                 )}
//               </button>
//             </div>
//             {showScrapeModal && (
//               <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
//                 <div className="bg-white rounded-xl border border-gray-200 p-6 w-full max-w-md shadow-lg">
//                   <div className="flex items-center justify-between mb-5">
//                     <h2 className="text-base font-medium text-gray-900">
//                       Scrape property data
//                     </h2>
//                     <button
//                       onClick={() => setShowScrapeModal(false)}
//                       className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg p-1"
//                     >
//                       ✕
//                     </button>
//                   </div>

//                   {/* Form fields */}
//                   <div className="grid grid-cols-2 gap-3 mb-3">
//                     <div className="col-span-2">
//                       <label className="block text-xs font-medium text-gray-500 mb-1">
//                         Property name <span className="text-red-500">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         value={propertyname}
//                         onChange={(e) => setpropertyname(e.target.value)}
//                         placeholder="e.g. Villa Serenity"
//                         className="w-full border border-gray-200 rounded-lg px-3 h-9 text-sm"
//                       />
//                     </div>
//                     <div>
//                       <label className="block text-xs font-medium text-gray-500 mb-1">
//                         Property type <span className="text-red-500">*</span>
//                       </label>
//                       <select
//                         name="propertytype"
//                         className="w-full border border-gray-200 rounded-lg px-3 h-9 text-sm"
//                       >
//                         <option value="">Select property type</option>
//                         <option value="Villa">Villa</option>
//                       </select>
//                     </div>
//                     <div>
//                       <label className="block text-xs font-medium text-gray-500 mb-1">
//                         Destination <span className="text-red-500">*</span>
//                       </label>
//                       <select
//                         value={scrapeDestination}
//                         onChange={(e) => {
//                           setScrapeDestination(e.target.value);
//                           setScrapeLocation(""); // reset when destination changes
//                         }}
//                         className="w-full border border-gray-200 rounded-lg px-3 h-9 text-sm"
//                       >
//                         <option value="">Select destination</option>
//                         {indiaStates.map((state) => (
//                           <option key={state.id} value={state.name}>
//                             {state.name}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="col-span-2">
//                       <label className="block text-xs font-medium text-gray-500 mb-1">
//                         Location <span className="text-red-500">*</span>
//                       </label>
//                       <select
//                         value={scrapeLocation}
//                         onChange={(e) => setScrapeLocation(e.target.value)}
//                         className="w-full border border-gray-200 rounded-lg px-3 h-9 text-sm"
//                       >
//                         <option value="">Select location</option>
//                         {scrapeFilteredCities.map((city) => (
//                           <option key={city.id} value={city.name}>
//                             {city.name}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>

//                   <hr className="border-gray-100 my-4" />

//                   <div className="mb-5">
//                     <label className="block text-xs font-medium text-gray-500 mb-1">
//                       Airbnb listing ID{" "}
//                       <span className="text-xs bg-gray-100 text-gray-400 rounded px-1 py-0.5 ml-1">
//                         optional
//                       </span>
//                     </label>
//                     <div className="flex gap-2">
//                       <input
//                         type="text"
//                         value={scrapeAirbnbId}
//                         onChange={(e) => setScrapeAirbnbId(e.target.value)}
//                         placeholder="e.g. 1038950877730350817"
//                         className="flex-1 border border-gray-200 rounded-lg px-3 h-9 text-sm"
//                       />
//                       {scrapeAirbnbId && (
//                         <a
//                           href={`https://www.airbnb.co.in/rooms/${scrapeAirbnbId}`}
//                           target="_blank"
//                           rel="noreferrer"
//                           className="text-xs text-blue-600 bg-blue-50 border border-blue-200 rounded-lg px-3 h-9 flex items-center gap-1 whitespace-nowrap"
//                         >
//                           ↗ Preview
//                         </a>
//                       )}
//                     </div>
//                     <p className="text-xs text-gray-400 mt-1">
//                       If provided, Airbnb details will be scraped and merged
//                       with Lohono data.
//                     </p>
//                   </div>

//                   <hr className="border-gray-100 mb-4" />

//                   <div className="flex justify-end gap-2">
//                     <button
//                       onClick={() => setShowScrapeModal(false)}
//                       className="border border-gray-200 text-gray-500 px-4 h-9 rounded-lg text-sm"
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       onClick={() => {
//                         setShowScrapeModal(false);
//                         handleScrapeData();
//                       }}
//                       className="bg-green-700 hover:bg-green-900 text-white px-5 h-9 rounded-lg text-sm font-medium"
//                     >
//                       Scrape data
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {unmatchedAmenities.length > 0 && (
//           <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg p-4">
//             <p className="text-sm font-medium text-amber-800 mb-2">
//               {unmatchedAmenities.length} scraped amenities didn't match your
//               list
//             </p>
//             <p className="text-xs text-amber-700 mb-3">
//               These were found on the source listing but don't correspond to an
//               amenity in your system. Add them manually below if relevant, or
//               extend your amenities table.
//             </p>
//             <div className="flex flex-wrap gap-2">
//               {unmatchedAmenities.map((name, i) => (
//                 <span
//                   key={i}
//                   className="text-xs bg-white border border-amber-300 text-amber-800 px-2 py-1 rounded-full"
//                 >
//                   {name}
//                 </span>
//               ))}
//             </div>
//             <button
//               type="button"
//               onClick={() => setUnmatchedAmenities([])}
//               className="text-xs text-amber-600 underline mt-3"
//             >
//               Dismiss
//             </button>
//           </div>
//         )}
//         {descriptionSource === "fallback" && fullScrapedDescription && (
//           <p className="text-xs text-amber-600 mt-1">
//             ⚠️ Auto-summarization unavailable — description was truncated at a
//             sentence boundary. Consider reviewing/rewriting.
//           </p>
//         )}
//       </main>
//     </div>
//   );
// };

// export default PropertyScraperElementor;

//old working code
import { useEffect, useRef, useState } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa6";
import { FcAddImage } from "react-icons/fc";
import { BsCloudSun, BsFillSunFill } from "react-icons/bs";
import { IoCalendarClearOutline, IoCalendarNumber } from "react-icons/io5";
import { GiPalmTree, GiAirplaneDeparture } from "react-icons/gi";
import { IoIosAirplane } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Check } from "lucide-react";

const PropertyScraperElementor = () => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });
  const [indiaStates, setIndiaStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [cities, setCities] = useState([]);
  const [bedrooms, setBedrooms] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [guests, setGuests] = useState("");
  const [price, setPrice] = useState("");
  const [amenities, setAmenities] = useState([]);
  const [checkin, setcheckin] = useState("");
  const [checkout, setcheckout] = useState("");
  const [houseRules, setHouseRules] = useState([]);
  const [location, setLocation] = useState("");
  const [sourceUrl, setSourceUrl] = useState("");
  const [rating, setRating] = useState("");
  const [reviewCount, setReviewCount] = useState("");
  const [hostName, setHostName] = useState("");
  const [cancellationPolicy, setCancellationPolicy] = useState("");
  const [maxbedrooms, setmaxbedrooms] = useState("");
  const [maxbathrooms, setmaxbathrooms] = useState("");
  // Add these two state vars near your other scrape state
  const [scrapeDestination, setScrapeDestination] = useState("");
  const [scrapeLocation, setScrapeLocation] = useState("");
  useEffect(() => {
    // Load world.json from public folder
    fetch("/world.json")
      .then((res) => res.json())
      .then((data) => {
        const india = data.find((country) => country.name === "India");
        if (india) {
          setIndiaStates(india.states);
        }
      })
      .catch((err) => console.error("Error loading world.json:", err));
  }, []);

  // const handleStateChange = (e) => {
  //   const stateName = e.target.value;
  //   setSelectedState(stateName);

  //   const stateObj = indiaStates.find((s) => s.name === stateName);
  //   if (stateObj) {
  //     setCities(stateObj.cities || []);
  //   } else {
  //     setCities([]);
  //   }
  // };

  const loadCitiesForState = (stateName) => {
    if (stateName.toLowerCase() === "goa") {
      const goaCities = [
        "Aldona",
        "Arambol",
        "Baga",
        "Bambolim",
        "Bandora",
        "Benaulim",
        "Calangute",
        "Candolim",
        "Carapur",
        "Cavelossim",
        "Chicalim",
        "Chinchinim",
        "Colovale",
        "Colva",
        "Cortalim",
        "Cuncolim",
        "Curchorem",
        "Curti",
        "Davorlim",
        "Dicholi",
        "Goa Velha",
        "Guirim",
        "Jua",
        "Kankon",
        "Madgaon",
        "Мариса",
        "Morjim",
        "Mormugao",
        "Navelim",
        "North Goa",
        "Palle",
        "Panaji",
        "Pernem",
        "Ponda",
        "Quepem",
        "Queula",
        "Raia",
        "Saligao",
        "Sancoale",
        "Sanguem",
        "Sanquelim",
        "Sanvordem",
        "Serula",
        "Solim",
        "South Goa",
        "Taleigao",
        "Vagator",
        "Valpoy",
        "Varca",
        "Vasco da Gama",
        // Extra villages
        "Anjuna",
        "Arpora",
        "Assagao",
        "Parra",
        "Siolim",
        "Reis Magos",
        "Nerul",
      ];

      // Convert to {id, name} objects since your city dropdown expects that
      setCities(goaCities.map((city, idx) => ({ id: idx + 1, name: city })));
    } else if (stateName.toLowerCase() === "karnataka") {
      const karnatakaCities = [
        // Extra villages

        // Added cities
        "Afzalpur",
        "Ajjampur",
        "Aland",
        "Alnavar",
        "lark",
        "Alur",
        "Anekal",
        "Ankola",
        "Annigeri",
        "Arkalgud",
        "Arsikere",
        "Athni",
        "Aurad",
        "Badami",
        "Bagalkot",
        "Bagepalli",
        "Bail-Hongal",
        "Ballari",
        "Banavar",
        "Bangarapet",
        "Bannur",
        "Bantval",
        "Basavakalyan",
        "Basavana Bagevadi",
        "Belagavi",
        "Belluru",
        "Beltangadi",
        "Belur",
        "Bengaluru",
        "Bengaluru Rural",
        "Bengaluru Urban",
        "Bhadravati",
        "Bhalki",
        "Bhatkal",
        "Bidar",
        "Bilgi",
        "Birur",
        "Byadgi",
        "Byndoor",
        "Canacona",
        "Challakere",
        "Chamrajnagar",
        "Channagiri",
        "Channapatna",
        "Channarayapatna",
        "Chik Ballapur",
        "Chikkaballapur",
        "Chikkamagaluru",
        "Chiknayakanhalli",
        "Chikodi",
        "Chincholi",
        "Chintamani",
        "Chitapur",
        "Chitradurga",
        "Closepet",
        "Coondapoor",
        "Coorg",
        "Dakshina Kannada",
        "Dandeli",
        "Davanagere",
        "Devanhalli",
        "Dharwad",
        "Dod Ballapur",
        "French Rocks",
        "Gadag",
        "Gadag-Betageri",
        "Gajendragarh",
        "Gangawati",
        "Gangolli",
        "Gokak",
        "Gokarna",
        "Goribidnur",
        "Gorur",
        "Gubbi",
        "Gudibanda",
        "Guledagudda",
        "Gundlupet",
        "Gurmatkal",
        "Hadagalli",
        "Haliyal",
        "Hampi",
        "Hangal",
        "Harihar",
        "Harpanahalli",
        "Hassan",
        "Haveri",
        "Heggadadevankote",
        "Hirekerur",
        "Hiriyur",
        "Holalkere",
        "Hole Narsipur",
        "Homnabad",
        "Honavar",
        "Honnali",
        "Hosanagara",
        "Hosangadi",
        "Hosdurga",
        "Hoskote",
        "Hospet",
        "Hubballi",
        "Hukeri",
        "Hungund",
        "Hunsur",
        "Ilkal",
        "Indi",
        "Jagalur",
        "Jamkhandi",
        "Jevargi",
        "Kabini",
        "Kadur",
        "Kalaburgi",
        "Kalghatgi",
        "Kampli",
        "Kankanhalli",
        "Karkala",
        "Karwar",
        "Kavalur",
        "Kerur",
        "Khanapur",
        "Kodagu",
        "Kodigenahalli",
        "Kodlipet",
        "Kolar",
        "Kollegal",
        "Konanur",
        "Konnur",
        "Koppa",
        "Koppal",
        "Koratagere",
        "Kotturu",
        "Krishnarajpet",
        "Kudachi",
        "Kudligi",
        "Kumsi",
        "Kumta",
        "Kundgol",
        "Kunigal",
        "Kurgunta",
        "Kushalnagar",
        "Kushtagi",
        "Lakshmeshwar",
        "Lingsugur",
        "Londa",
        "Machare",
        "Maddagiri",
        "Maddur",
        "Madikeri",
        "Magadi",
        "Mahalingpur",
        "Malavalli",
        "Malpe",
        "Malur",
        "Mandya",
        "Mangaluru",
        "Manipal",
        "Manvi",
        "Mayakonda",
        "Melukote",
        "Mudbidri",
        "Muddebihal",
        "Mudgal",
        "Mudgere",
        "Mudhol",
        "Mulbagal",
        "Mulgund",
        "Mulki",
        "Mundargi",
        "Mundgod",
        "Munirabad",
        "Murudeshwara",
        "Mysuru",
        "Nagamangala",
        "Nanjangud",
        "Narasimharajapura",
        "Naregal",
        "Nargund",
        "Navalgund",
        "Nelamangala",
        "Nyamti",
        "Pangala",
        "Pavugada",
        "Piriyapatna",
        "Ponnampet",
        "Puttur",
        "Rabkavi",
        "Raichur",
        "Ramanagara",
        "Ranibennur",
        "Raybag",
        "Robertsonpet",
        "Ron",
        "Sadalgi",
        "Sagar",
        "Sakleshpur",
        "Sandur",
        "Sanivarsante",
        "Sankeshwar",
        "Sargur",
        "Saundatti",
        "Savanur",
        "Seram",
        "Shahabad",
        "Shahpur",
        "Shiggaon",
        "Shikarpur",
        "Shimoga",
        "Shirhatti",
        "Shorapur",
        "Shrirangapattana",
        "Siddapur",
        "Sidlaghatta",
        "Sindgi",
        "Sindhnur",
        "Sira",
        "Sirsi",
        "Siruguppa",
        "Someshwar",
        "Somvarpet",
        "Sorab",
        "Sravana Belgola",
        "Sringeri",
        "Srinivaspur",
        "Sulya",
        "Suntikoppa",
        "Talikota",
        "Tarikere",
        "Tekkalakote",
        "Terdal",
        "Tiptur",
        "Tirthahalli",
        "Tirumakudal Narsipur",
        "Tumakuru",
        "Turuvekere",
        "Udupi",
        "Ullal",
        "Uttar Kannada",
        "Vadigenhalli",
        "Vijayapura",
        "Virarajendrapet",
        "Wadi",
        "Yadgir",
        "Yelahanka",
        "Yelandur",
        "Yelbarga",
        "Yellapur",
      ];

      // Convert to {id, name} objects since your city dropdown expects that
      setCities(
        karnatakaCities.map((city, idx) => ({ id: idx + 1, name: city })),
      );
    } else if (stateName.toLowerCase() === "kerala") {
      const keralaCities = [
        "Adoor",
        "Alappuzha",
        "Alleppey",
        "Aluva",
        "Alwaye",
        "Angamali",
        "Aroor",
        "Arukutti",
        "Attingal",
        "Avanoor",
        "Azhikkal",
        "Beypore",
        "Changanacheri",
        "Chelakara",
        "Chengannur",
        "Cherpulassery",
        "Cherthala",
        "Chetwayi",
        "Chittur",
        "Cochin",
        "Dharmadom",
        "Edakkulam",
        "Elur",
        "Erattupetta",
        "Ernakulam",
        "Ferokh",
        "Guruvayur",
        "Idukki",
        "Iringal",
        "Irinjalakuda",
        "Kadakkavoor",
        "Kalamassery",
        "Kalavoor",
        "Kalpetta",
        "Kanhangad",
        "Kannavam",
        "Kannur",
        "Kasaragod",
        "Kattanam",
        "Kayankulam",
        "Kizhake Chalakudi",
        "Kochi",
        "Kodungallur",
        "Kollam",
        "Kotamangalam",
        "Kottayam",
        "Kovalam",
        "Kozhikode",
        "Kumbalam",
        "Kunnamangalam",
        "Kunnamkulam",
        "Kunnumma",
        "Kutiatodu",
        "Kuttampuzha",
        "Lalam",
        "Mahe",
        "Malappuram",
        "Manjeri",
        "Manjeshwaram",
        "Mannarakkat",
        "Marayur",
        "Mattanur",
        "Mavelikara",
        "Mavoor",
        "Muluppilagadu",
        "Munnar",
        "Muvattupula",
        "Muvattupuzha",
        "Nadapuram",
        "Naduvannur",
        "Nedumangad",
        "Neyyattinkara",
        "Nileshwar",
        "Ottappalam",
        "Palackattumala",
        "Palakkad district",
        "Palghat",
        "Panamaram",
        "Pappinissheri",
        "Paravur Tekkumbhagam",
        "Pariyapuram",
        "Pathanamthitta",
        "Pattanamtitta",
        "Payyanur",
        "Perinthalmanna",
        "Perumbavoor",
        "Perumpavur",
        "Perya",
        "Piravam",
        "Ponnani",
        "Ponmana",
        "Punalur",
        "Punnayur",
        "Ramamangalam",
        "Shertallai",
        "Shoranur",
        "Taliparamba",
        "Thalassery",
        "Thalikulam",
        "Thanniyam",
        "Thekkady",
        "Thiruvananthapuram",
        "Thrissur",
        "Tirur",
        "Tiruvalla",
        "Vaikam",
        "Varkala",
        "Vatakara",
        "Vayalar",
        "Vettur",
        "Wayanad",
      ];

      // Convert to {id, name} objects since your city dropdown expects that
      setCities(keralaCities.map((city, idx) => ({ id: idx + 1, name: city })));
    } else if (stateName.toLowerCase() === "tamil nadu") {
      const tamilnaduCities = [
        // Tamil Nadu cities
        "Aambur",
        "Ariyalur",
        "Arakkonam",
        "Arani",
        "Attur",
        "Avadi",
        "Batlagundu",
        "Chengalpattu",
        "Chennai",
        "Chidambaram",
        "Coimbatore",
        "Courtallam",
        "Cuddalore",
        "Coonoor",
        "Dharapuram",
        "Dharmapuri",
        "Dindigul",
        "Erode",
        "Gobichettipalayam",
        "Gudalur",
        "Gudiyatham",
        "Hosur",
        "Jayankondam",
        "Kallakurichi",
        "Kanchipuram",
        "Kanyakumari",
        "Karaikudi",
        "Karur",
        "Kodaikanal",
        "Kovilpatti",
        "Krishnagiri",
        "Kumbakonam",
        "Madurai",
        "Manapparai",
        "Mahabalipuram",
        "Mayiladuthurai",
        "Mettupalayam",
        "Namakkal",
        "Nagapattinam",
        "Nagercoil",
        "Ooty",
        "Palani",
        "Pallavaram",
        "Pattukkottai",
        "Perambalur",
        "Pollachi",
        "Poonamallee",
        "Pudukkottai",
        "Rajapalayam",
        "Ramanathapuram",
        "Ranipet",
        "Salem",
        "Sankagiri",
        "Sivaganga",
        "Sivakasi",
        "Tambaram",
        "Tenkasi",
        "Thanjavur",
        "Theni",
        "Thiruvallur",
        "Thiruvarur",
        "Thoothukudi",
        "Tindivanam",
        "Tiruchendur",
        "Tiruchengode",
        "Tiruchirappalli",
        "Tirunelveli",
        "Tirupathur",
        "Tiruppur",
        "Tiruvannamalai",
        "Udagamandalam",
        "Udumalpet",
        "Usilampatti",
        "Vaniyambadi",
        "Vellore",
        "Villupuram",
        "Virudhunagar",
      ];

      // Convert to {id, name} objects since your city dropdown expects that
      setCities(
        tamilnaduCities.map((city, idx) => ({ id: idx + 1, name: city })),
      );
    } else {
      const stateObj = indiaStates.find((s) => s.name === stateName);
      setCities(stateObj ? stateObj.cities : []);
    }
  };

  const handleStateChange = (e) => {
    const stateName = e.target.value;
    setSelectedState(stateName);
    setSelectedCity(""); // reset city when destination changes
    loadCitiesForState(stateName);
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const CustomLeftArrowBannerCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute left-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="previous_btn"
      >
        <FaChevronLeft />
      </button>
    );
  };

  const CustomRightArrowBannerCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute right-3 top-1/2 transform -translate-y-1/2 bg-white border shadow-md bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="next_btn"
      >
        <FaChevronRight />
      </button>
    );
  };

  const MAX_CARDS = 5;

  const [selectedImages, setSelectedImages] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUpload = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const imageurl = URL.createObjectURL(file);
      const updatedImages = [...selectedImages];
      updatedImages[index] = imageurl;
      setSelectedImages(updatedImages);
    }
  };

  const [imageCarouselOne, setImageCarouselOne] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUploadCarouselOne = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const imageurl = URL.createObjectURL(file);
      const updatedImages = [...imageCarouselOne];
      updatedImages[index] = imageurl;
      setImageCarouselOne(updatedImages);
    }
  };

  const [imageCarouselTwo, setImageCarouselTwo] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUploadCarouselTwo = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const imageurl = URL.createObjectURL(file);
      const updatedImages = [...imageCarouselTwo];
      updatedImages[index] = imageurl;
      setImageCarouselTwo(updatedImages);
    }
  };

  const [imageCarouselThree, setImageCarouselThree] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUploadCarouselThree = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const imageurl = URL.createObjectURL(file);
      const updatedImages = [...imageCarouselThree];
      updatedImages[index] = imageurl;
      setImageCarouselThree(updatedImages);
    }
  };

  const [imageCarouselFour, setImageCarouselFour] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUploadCarouselFour = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const imageurl = URL.createObjectURL(file);
      const updatedImages = [...imageCarouselFour];
      updatedImages[index] = imageurl;
      setImageCarouselFour(updatedImages);
    }
  };

  const [imageCarouselFive, setImageCarouselFive] = useState(
    Array(MAX_CARDS).fill(null),
  );

  const handleImageUploadCarouselFive = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const imageurl = URL.createObjectURL(file);
      const updatedImages = [...imageCarouselFive];
      updatedImages[index] = imageurl;
      setImageCarouselFive(updatedImages);
    }
  };

  // const [uploadedMap, setUploadedMap] = useState(null);

  // const handleMapUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const mapUrl = URL.createObjectURL(file);
  //     setUploadedMap(mapUrl);
  //   }
  // };

  // const [experienceData, setExperienceData] = useState([
  //   { icon: "", title: "", content: "" },
  //   { icon: "", title: "", content: "" },
  //   { icon: "", title: "", content: "" },
  //   { icon: "", title: "", content: "" },
  // ]);
  const [experienceData, setExperienceData] = useState(
    Array.from({ length: 8 }, () => ({ file: null, title: "", content: "" })),
  );

  const iconOptions = [
    { label: "Sun", value: "BsCloudSun", icon: <BsCloudSun /> },
    { label: "Full Sun", value: "BsFillSunFill", icon: <BsFillSunFill /> },
    {
      label: "Calendar",
      value: "IoCalendarClearOutline",
      icon: <IoCalendarClearOutline />,
    },
    {
      label: "Numbered Calendar",
      value: "IoCalendarNumber",
      icon: <IoCalendarNumber />,
    },
    { label: "Palm Tree", value: "GiPalmTree", icon: <GiPalmTree /> },
    { label: "Plane", value: "IoIosAirplane", icon: <IoIosAirplane /> },
    {
      label: "Airplane Departure",
      value: "GiAirplaneDeparture",
      icon: <GiAirplaneDeparture />,
    },
  ];

  const [gridImg_fullWidth, setGridImg_fullWidth] = useState(null);
  const [gridImg1, setGridImg1] = useState(null);
  const [gridImg2, setGridImg2] = useState(null);

  const handleMediaUpload_gridImages = (e, setter) => {
    const file = e.target.files[0];
    if (file) {
      const imageurl = URL.createObjectURL(file);
      setter(imageurl);
    }
  };

  const TailoredExpCarousel = [
    {
      img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/77613/villa-barbados-caribbean-luxury-the-great-house-boat_FullL.jpg?v=302558110212",
      title: "For Adventure Seekers",
      content:
        "Experience the thrill of Goa with our adventure package! Enjoy cozy stays, a hearty breakfast, and activities like water sports, trekking, and more.",
    },
    {
      img: "https://mpvstorage.blob.core.windows.net/villapics-new/1592/66699/villa-barbados-caribbean-luxury-the-great-house-ext-9_FullL.jpg?v=302558110212",
      title: "For Leisure Lovers",
      content:
        "Unwind with our leisure package in Goa. Relax in serene stays, savor a delicious breakfast, and enjoy peaceful beaches, spa sessions, and local attractions.",
    },
  ];

  const responsive_TailoredExpCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  // const MAX_CARDS_Exp = TailoredExpCarousel.length;

  // const [tailoredexpimages, setTailoredexpimages] = useState(
  //   TailoredExpCarousel.map((item) => item.img)
  // );

  // const handleImageUploadTailoredExp = (event, index) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const imageurl = URL.createObjectURL(file);
  //     const updatedImages = [...tailoredexpimages];
  //     updatedImages[index] = imageurl;
  //     setTailoredexpimages(updatedImages);
  //   }
  // };
  // const handleImageUploadTailoredExp = (e, index) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const newImages = [...tailoredexpimages];
  //     newImages[index] = file; // ✅ store actual File instead of URL
  //     setTailoredexpimages(newImages);
  //   }
  // };

  const responsive_BannerCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 2,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1.5,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1.5,
      partialVisibilityGutter: 10,
    },
  };

  const [showDots, setShowDots] = useState(false);

  useEffect(() => {
    const updateDotsVisibility = () => {
      setShowDots(window.innerWidth < 768);
    };

    updateDotsVisibility();
    window.addEventListener("resize", updateDotsVisibility);
    return () => window.removeEventListener("resize", updateDotsVisibility);
  }, []);

  const responsive_ImageCarouselOne = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_ImageCarouselTwo = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_ImageCarouselThree = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_ImageCarouselFour = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_ImageCarouselFive = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 1,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
  };

  const responsive_ExperienceCarousel = {
    xl: {
      breakpoint: { max: 4000, min: 1280 },
      items: 4,
      partialVisibilityGutter: 20,
    },
    lg: {
      breakpoint: { max: 1280, min: 1024 },
      items: 3,
      partialVisibilityGutter: 20,
    },
    md: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
      partialVisibilityGutter: 15,
    },
    sm: {
      breakpoint: { max: 768, min: 640 },
      items: 2,
      partialVisibilityGutter: 15,
    },
    xs: {
      breakpoint: { max: 640, min: 0 },
      items: 1.5,
      partialVisibilityGutter: 10,
    },
  };

  const CustomLeftArrowTailoredExpCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute left-3 top-44 transform -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="previous_btn"
      >
        <FaChevronLeft />
      </button>
    );
  };

  const CustomRightArrowTailoredExpCarousel = ({ onClick }) => {
    return (
      <button
        onClick={onClick}
        className="hidden md:block absolute right-3 top-44 transform -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-sm rounded-full p-3 z-0 scale-75"
        name="next_btn"
      >
        <FaChevronRight />
      </button>
    );
  };

  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const carouselRef = useRef(null);

  const handlePrevSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.previous();
    }
  };

  const handleNextSlide = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const [, setIsOpen_dropdownExp] = useState(false);
  // const [, setSelectedOptions_dropdownExp] =
  //   useState([]);
  const dropdownRef_dropdownExp = useRef(null);

  // const options_dropdownExp = ["Option1", "Option2", "Option3"];

  // const toggleOption_dropdownExp = (option) => {
  //   setSelectedOptions_dropdownExp((prev) =>
  //     prev.includes(option)
  //       ? prev.filter((item) => item !== option)
  //       : [...prev, option]
  //   );
  // };

  useEffect(() => {
    const handleClickOutside_dropdownExp = (event) => {
      if (
        dropdownRef_dropdownExp.current &&
        !dropdownRef_dropdownExp.current.contains(event.target)
      ) {
        setIsOpen_dropdownExp(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside_dropdownExp);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside_dropdownExp);
  }, []);
  const [tailoredExpData, setTailoredExpData] = useState([
    { img: null, title: "", content: "" },
    { img: null, title: "", content: "" },
    { img: null, title: "", content: "" },
    { img: null, title: "", content: "" },
  ]);
  const MAX_CARDS_Exp = tailoredExpData.length;

  const [propertyThumbnail, setPropertyThumbnail] = useState(null);

  const [thumbnailFile, setThumbnailFile] = useState(null);

  const handlepropertyThumbnail = (event) => {
    const file = event.target.files[0];
    if (file) {
      setThumbnailFile(file); // <-- important
      const previewUrl = URL.createObjectURL(file);
      setPropertyThumbnail(previewUrl);
    }
  };
  const handleSave = async () => {
    try {
      setLoading(true); // show loader

      //check if required data was sent or not
      const propertycode = document
        .querySelector('input[placeholder="Enter property code"]')
        .value.trim();
      const propertytype = document
        .querySelector('select[name="propertytype"]')
        .value.trim();
      const destination = document
        .querySelector('select[name="destination"]')
        .value.trim();
      const location = document
        .querySelector('select[name="location"]')
        .value.trim();

      // check required fields
      if (!propertycode || !propertytype || !destination || !location) {
        toast.error(
          "Property Code,Type,Destination and Location cannot be null!",
        );
        setLoading(false);
        return; // ⛔ stop execution
      }

      //proper function of saving data
      const formData = new FormData();

      // Properties table data
      formData.append(
        "propertyname",
        document.querySelector('input[name="propertyname"]').value,
      );
      formData.append(
        "description",
        document.querySelector('textarea[name="description"]').value,
      );
      formData.append(
        "heading",
        document.querySelector('input[placeholder="Heading"]').value,
      );
      formData.append(
        "content",
        document.querySelector('textarea[placeholder="Content..."]').value,
      );
      formData.append(
        "catchquote",
        document.querySelector('input[placeholder="Catchy Quote"]').value,
      );
      formData.append(
        "aboutloc",
        document.querySelector('input[placeholder="About the location"]').value,
      );
      formData.append(
        "loctagline",
        document.querySelector('input[placeholder="Location Tagline"]').value,
      );
      formData.append(
        "loccontent",
        document.querySelector('input[placeholder="Content..."]').value,
      );

      // Additional properties data
      formData.append(
        "propertycode",
        document.querySelector('input[placeholder="Enter property code"]')
          .value,
      );
      formData.append(
        "propertyowner",
        document.querySelector('input[name="propertyowner"]').value,
      );
      formData.append(
        "propertybrochure",
        document.querySelector('input[name="propertybrochure"]').value,
      );

      formData.append(
        "currentprice",
        document.querySelector('input[placeholder="Enter current price"]')
          .value,
      );
      formData.append(
        "defaultprice",
        document.querySelector('input[placeholder="Enter default price"]')
          .value,
      );
      formData.append(
        "deposit",
        document.querySelector('input[placeholder="Enter security deposit"]')
          .value,
      );
      formData.append(
        "maxadult",
        document.querySelector('input[placeholder="Enter max adults"]').value,
      );
      formData.append(
        "maxchild",
        document.querySelector('input[placeholder="Enter max children"]').value,
      );
      formData.append(
        "maxbed",
        document.querySelector('input[placeholder="Enter max bedroom"]').value,
      );
      formData.append(
        "maxbath",
        document.querySelector('input[placeholder="Enter max bathroom"]').value,
      );
      formData.append(
        "maplink",
        document.querySelector('input[placeholder="Enter map location"]').value,
      );
      formData.append(
        "youtubelink",
        document.querySelector('input[placeholder="Enter youtube link"]').value,
      );
      formData.append("conserlink", conciergeService);
      // Foreign key selects
      // formData.append(
      //   "location",
      //   document.querySelector('select[name="location"]').value
      // );
      // formData.append(
      //   "propertytype",
      //   document.querySelectorAll("select")[1].value
      // );
      // formData.append(
      //   "destination",
      //   document.querySelectorAll('select[name="destination"]')[2].value
      // );
      // formData.append(
      //   "seasonType",
      //   document.querySelectorAll('select[name="seasonType"]')[3].value
      // );
      formData.append(
        "destination",
        document.querySelector('select[name="destination"]')?.value || "",
      );
      formData.append(
        "location",
        document.querySelector('select[name="location"]')?.value || "",
      );
      formData.append(
        "propertytype",
        document.querySelector('select[name="propertytype"]')?.value || "",
      );
      formData.append(
        "seasonType",
        document.querySelector('select[name="seasonType"]')?.value || "",
      );

      // Banner images
      for (let i = 0; i < selectedImages.length; i++) {
        if (selectedImages[i]) {
          formData.append(
            `banner${i + 1}`,
            await urlToFile(selectedImages[i], `banner${i + 1}.jpg`),
          );
        }
      }

      // Carousel images
      const carousels = [
        imageCarouselOne,
        imageCarouselTwo,
        imageCarouselThree,
        imageCarouselFour,
        imageCarouselFive,
      ];
      for (let c = 0; c < carousels.length; c++) {
        for (let i = 0; i < carousels[c].length; i++) {
          if (carousels[c][i]) {
            formData.append(
              `img${i + 1}_C${c + 1}`,
              await urlToFile(carousels[c][i], `img${i + 1}_C${c + 1}.jpg`),
            );
          }
        }
      }

      // Text content for propertyImages
      // formData.append(
      //   "title1",
      //   document.querySelector(
      //     'input[placeholder="Title 1 (highlight property speciality)"]'
      //   ).value
      // );
      // formData.append(
      //   "rc1",
      //   document.querySelector('textarea[placeholder="Relevant Content 1..."]')
      //     .value
      // );
      // formData.append(
      //   "title2",
      //   document.querySelector(
      //     'input[placeholder="Title 2 (highlight property speciality)"]'
      //   ).value
      // );
      // formData.append(
      //   "rc2",
      //   document.querySelector('textarea[placeholder="Relevant Content 2..."]')
      //     .value
      // );

      formData.append(
        "title1",
        document.querySelector('input[name="title1"]').value,
      );
      formData.append(
        "rc1",
        document.querySelector('textarea[name="rc1"]').value,
      );
      formData.append(
        "title2",
        document.querySelector('input[name="title2"]').value,
      );
      formData.append(
        "rc2",
        document.querySelector('textarea[name="rc2"]').value,
      );
      formData.append(
        "title3",
        document.querySelector(
          'input[placeholder="Title 3 (highlight property speciality)"]',
        ).value,
      );
      formData.append(
        "rc3",
        document.querySelector('textarea[placeholder="Relevant Content 3..."]')
          .value,
      );

      // Map data
      formData.append(
        "maplang",
        document.querySelector('input[name="maplang"]').value,
      );
      formData.append(
        "maplong",
        document.querySelector('input[name="maplong"]').value,
      );

      formData.append(
        "maptitle",
        document.querySelector('textarea[placeholder="Map Title"]').value,
      );
      formData.append(
        "mapcontent",
        document.querySelector('textarea[placeholder="Map Content..."]').value,
      );
      // if (uploadedMap) {
      //   formData.append(
      //     "mapimage",
      //     await urlToFile(uploadedMap, "mapimage.jpg")
      //   );
      // }

      // Grid images
      if (gridImg_fullWidth) {
        formData.append(
          "imagegrid1",
          await urlToFile(gridImg_fullWidth, "imagegrid1.jpg"),
        );
      }
      if (gridImg1) {
        formData.append(
          "imagegrid2",
          await urlToFile(gridImg1, "imagegrid2.jpg"),
        );
      }
      if (gridImg2) {
        formData.append(
          "imagegrid3",
          await urlToFile(gridImg2, "imagegrid3.jpg"),
        );
      }

      // Experiences main fields
      formData.append(
        "expnamemain",
        document.querySelector('input[placeholder="Experience"]').value,
      );
      formData.append(
        "expcontentmain",
        document.querySelector('textarea[placeholder="Content..."]').value,
      );

      // Experience items (expimage + title + content)
      for (let i = 0; i < experienceData.length; i++) {
        formData.append(
          `exptitle${i === 0 ? "" : i + 1}`,
          experienceData[i].title,
        );
        formData.append(
          `expcon${i === 0 ? "" : i + 1}`,
          experienceData[i].content,
        );

        if (experienceData[i].file) {
          formData.append(
            `expimage${i === 0 ? "" : i + 1}`,
            experienceData[i].file,
          );
        }
      }

      // // ✅ Tailored experiences (images + title + content)
      // for (let i = 0; i < tailoredExpData.length; i++) {
      //   if (tailoredExpData[i].file) {
      //     formData.append(`miniexpimg${i + 1}`, tailoredExpData[i].file);
      //   }
      //   formData.append(`miniexptitle${i + 1}`, tailoredExpData[i].title || "");
      //   formData.append(`miniexpcon${i + 1}`, tailoredExpData[i].content || "");
      // }
      // Tailored experiences (miniexpimg + title + content)
      for (let i = 0; i < tailoredExpData.length; i++) {
        if (tailoredExpData[i]?.file) {
          formData.append(`miniexpimg${i + 1}`, tailoredExpData[i].file);
        }
        if (tailoredExpData[i]?.title) {
          formData.append(`miniexptitle${i + 1}`, tailoredExpData[i].title);
        }
        if (tailoredExpData[i]?.content) {
          formData.append(`miniexpcon${i + 1}`, tailoredExpData[i].content);
        }
      }
      if (thumbnailFile) {
        formData.append("thumbnailimg", thumbnailFile);
      }
      formData.append("addons", selectedAmenities.join(","));
      formData.append(
        "airid",
        document.querySelector('input[name="airid"]')?.value || "",
      );
      // Send request
      const response = await fetch(
        "https://demo.zorbastays.com/web-backend/createProperty",
        {
          method: "POST",
          body: formData,
        },
      );

      if (response.ok) {
        // alert("Property saved successfully!");
        toast.success("Property added successfully 🎉");

        // navigate after short delay so toast is visible
        setTimeout(() => {
          navigate("/Properties");
        }, 800);
      } else {
        // alert("Error saving property");
        toast.error("Please enter required feilds");
      }
    } catch (error) {
      console.error("Error:", error);
      // alert("Error saving property");
      toast.error("Please enter required feilds");
    } finally {
      setLoading(false); // hide loader
    }
  };

  const urlToFile = async (url, filename) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type });
  };

  const [propertyname, setpropertyname] = useState("");
  const [description, setDescription] = useState("");
  const [heading, setHeading] = useState("");
  const [content, setContent] = useState("");
  const [catchyQuote, setCatchyQuote] = useState("");
  const [title1, setTitle1] = useState("");
  const [relevantContent1, setRelevantContent1] = useState("");
  const [title2, setTitle2] = useState("");
  const [content2, setContent2] = useState("");
  const [title3, setTitle3] = useState("");
  const [relevantContent3, setRelevantContent3] = useState("");
  const [maptitle, setmaptitle] = useState("");
  const [mapcontent, setmapcontent] = useState("");
  const [aboutlocation, setaboutlocation] = useState("");
  const [conciergeService, setConciergeService] = useState("");
  const [locationTagline, setLocationTagline] = useState("");
  const [locationContent, setLocationContent] = useState("");
  const [tailoredExperience, setTailoredExperience] = useState("");
  const [villaUrl, setVillaUrl] = useState("");
  const [showScrapeModal, setShowScrapeModal] = useState(false);
  const [scrapeAirbnbId, setScrapeAirbnbId] = useState("");
  const [tailoredExperienceContent, setTailoredExperienceContent] =
    useState("");

  const [amenitiesList, setAmenitiesList] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]); // stores ids: [1, 4, 5]

  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen_amenities, setIsOpen_amenities] = useState(false);

  // const toggleAmenity = (amenityName) => {
  //   if (selectedAmenities.includes(amenityName)) {
  //     setSelectedAmenities(selectedAmenities.filter((a) => a !== amenityName));
  //   } else {
  //     setSelectedAmenities([...selectedAmenities, amenityName]);
  //   }
  // };
  useEffect(() => {
    fetch("https://demo.zorbastays.com/web-backend/getAmenities")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setAmenitiesList(data.data);
      })
      .catch((err) => console.error("Failed to load amenities", err));
  }, []);

  // Toggle stores/removes the numeric id
  const toggleAmenity = (id) => {
    setSelectedAmenities((prev) =>
      prev.includes(id) ? prev.filter((a) => a !== id) : [...prev, id],
    );
  };

  const filteredAmenities = amenitiesList.filter((amenity) =>
    amenity.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const containerRef_amenities = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef_amenities.current &&
        !containerRef_amenities.current.contains(event.target)
      ) {
        setIsOpen_amenities(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Scraper function
  // const handleScrapeData = async () => {
  //   // Read select values
  //   const propertytype = document
  //     .querySelector('select[name="propertytype"]')
  //     ?.value.trim();
  //   const destination = document
  //     .querySelector('select[name="destination"]')
  //     ?.value.trim();
  //   const location = document
  //     .querySelector('select[name="location"]')
  //     ?.value.trim();

  //   // Validate — stop if any field is missing
  //   if (!propertyname) {
  //     toast.error("Property Name cannot be null while Scraping!");
  //     return;
  //   }
  //   if (!propertytype) {
  //     toast.error("Property Type cannot be null while Scraping!");
  //     return;
  //   }
  //   if (!destination) {
  //     toast.error("Destination cannot be null while Scraping!");
  //     return;
  //   }
  //   if (!location) {
  //     toast.error("Location cannot be null while Scraping!");
  //     return;
  //   }

  //   try {
  //     toast.info("Scraping in progress… this may take 30–60 seconds.");

  //     const response = await fetch(
  //       "https://demo.zorbastays.com/web-backend/scrape",
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           propertyname,
  //           propertytype,
  //           destination,
  //           location,
  //         }),
  //       },
  //     );

  //     const result = await response.json();

  //     if (!result.success) {
  //       toast.error(
  //         "Scraping failed: " + (result.errors?.join(", ") || result.error),
  //       );
  //       return;
  //     }

  //     const { lohono, airbnb } = result.data;

  //     // ── Log to console (replace with autofill later) ──────────────────────
  //     console.group("🔎 Scrape Results");

  //     console.group("🏡 LOHONO");
  //     console.log("Name        :", lohono.propertyname);
  //     console.log("Location    :", lohono.location);
  //     console.log("Description :", lohono.description);
  //     console.log("Price       :", lohono.price);
  //     console.log("Bedrooms    :", lohono.bedrooms);
  //     console.log("Bathrooms   :", lohono.bathrooms);
  //     console.log("Guests      :", lohono.guests);
  //     console.log("Amenities   :", lohono.amenities);
  //     console.log("Check-in    :", lohono.checkin);
  //     console.log("Check-out   :", lohono.checkout);
  //     console.log("House Rules :", lohono.houseRules);
  //     console.log("URL         :", lohono.url);
  //     console.groupEnd();

  //     console.group("✈️ AIRBNB");
  //     console.log("Name        :", airbnb.propertyname);
  //     console.log("Location    :", airbnb.location);
  //     console.log("Description :", airbnb.description);
  //     console.log("Price       :", airbnb.price);
  //     console.log("Bedrooms    :", airbnb.bedrooms);
  //     console.log("Bathrooms   :", airbnb.bathrooms);
  //     console.log("Guests      :", airbnb.guests);
  //     console.log("Rating      :", airbnb.rating);
  //     console.log("Reviews     :", airbnb.reviewCount);
  //     console.log("Host        :", airbnb.hostName);
  //     console.log("Amenities   :", airbnb.amenities);
  //     console.log("Check-in    :", airbnb.checkin);
  //     console.log("Check-out   :", airbnb.checkout);
  //     console.log("Cancellation:", airbnb.cancellationPolicy);
  //     console.log("House Rules :", airbnb.houseRules);
  //     console.log("URL         :", airbnb.url);
  //     console.groupEnd();

  //     console.groupEnd();

  //     toast.success("Scraping complete! Check the console for data.");

  //     // ── TODO: swap console.logs above with autofill ───────────────────────
  //     // Example:
  //     // setVillaName(lohono.propertyname || airbnb.propertyname);
  //     // setDescription(lohono.description || airbnb.description);
  //     // setBedrooms(lohono.bedrooms || airbnb.bedrooms);
  //   } catch (err) {
  //     console.error("Scrape request failed:", err);
  //     toast.error("Network error during scraping.");
  //   }
  // };
  // Scraper function
  const handleScrapeData = async () => {
    // Read select values
    const propertytype = document
      .querySelector('select[name="propertytype"]')
      ?.value.trim();
    const destination = scrapeDestination;
    const location = scrapeLocation;

    // Validate — stop if any field is missing
    if (!propertyname) {
      toast.error("Property Name cannot be null while Scraping!");
      return;
    }
    if (!propertytype) {
      toast.error("Property Type cannot be null while Scraping!");
      return;
    }
    if (!destination) {
      toast.error("Destination cannot be null while Scraping!");
      return;
    }
    if (!location) {
      toast.error("Location cannot be null while Scraping!");
      return;
    }

    try {
      toast.info("Scraping in progress… this may take 30–60 seconds.");

      const response = await fetch(
        "https://demo.zorbastays.com/web-backend/scrape",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            propertyname,
            propertytype,
            destination,
            location,
            airbnbId: scrapeAirbnbId || null,
          }),
        },
      );

      const result = await response.json();

      if (!result.success) {
        toast.error(
          "Scraping failed: " + (result.errors?.join(", ") || result.error),
        );
        return;
      }

      const { lohono, airbnb } = result.data;

      // ── Autofill destination, location, and Airbnb ID from scrape modal ──
      if (scrapeDestination) {
        setSelectedState(scrapeDestination);
        loadCitiesForState(scrapeDestination);
      }
      if (scrapeLocation) {
        // cities state updates asynchronously, so defer the city selection
        // slightly to ensure the cities list is populated first
        setTimeout(() => setSelectedCity(scrapeLocation), 50);
      }
      if (scrapeAirbnbId) {
        // airbnbId is already in scrapeAirbnbId state — nothing to set,
        // but you can also store it somewhere permanent here if needed
      }

      // ── Autofill form fields with scraped data ──────────────────────
      // Prioritize Lohono data, fallback to Airbnb
      setpropertyname(
        lohono.propertyname || airbnb.propertyname || propertyname,
      );
      setDescription(lohono.description || airbnb.description || "");

      // Set numeric fields
      if (lohono.bedrooms || airbnb.bedrooms) {
        setBedrooms(lohono.bedrooms || airbnb.bedrooms);
        setmaxbedrooms(lohono.bedrooms || airbnb.bedrooms);
      }
      if (lohono.bathrooms || airbnb.bathrooms) {
        setBathrooms(lohono.bathrooms || airbnb.bathrooms);
        setmaxbathrooms(lohono.bathrooms || airbnb.bathrooms);
      }
      if (lohono.guests || airbnb.guests) {
        setGuests(lohono.guests || airbnb.guests);
      }

      // Set price
      if (lohono.price || airbnb.price) {
        setPrice(lohono.price || airbnb.price);
      }

      // Set amenities (assuming you have a multi-select or array state)
      // Set amenities with keyword matching for your specific amenity list
      if (lohono.amenities?.length > 0 || airbnb.amenities?.length > 0) {
        const scrapedAmenities =
          lohono.amenities?.length > 0 ? lohono.amenities : airbnb.amenities;

        // ✅ FIX: use amenitiesList directly — filteredAmenities is a stale
        // closure filtered by searchTerm and may be empty when this async
        // function runs. amenitiesList always holds the full loaded list.
        if (amenitiesList.length === 0) {
          toast.warn(
            "Amenities list not loaded yet — please try scraping again in a moment.",
          );
          console.warn("⚠️ amenitiesList is empty, skipping amenity matching");
          return;
        }
        const allAmenities = amenitiesList;
        console.log(
          "📋 allAmenities loaded:",
          allAmenities.map((a) => `${a.id}:${a.name}`),
        );

        // Your exact amenity names for matching
        const yourAmenities = [
          "Entertainment Area",
          "Catering Services",
          "Bar",
          "Bathtub",
          "Bedroom",
          "Chef",
          "Evening Turndown Services",
          "GYM",
          "Game",
          "Gazebo",
          "Jacuzzi",
          "Garden",
          "Kitchen",
          "Power Backup",
          "Property Manager",
          "Loungers",
          "Private Pool",
          "Paddy Field View",
          "Toiletries",
          "Scenic View",
          "Wifi",
          "Shared Pool",
        ];

        // Normalize text for comparison
        const normalizeText = (text) => {
          return text
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, "")
            .replace(/\s+/g, " ")
            .trim();
        };

        // Direct mapping for common scraped amenities to your amenities
        const directMappings = {
          pool: ["Private Pool", "Shared Pool"],
          "private pool": ["Private Pool"],
          "shared pool": ["Shared Pool"],
          "swimming pool": ["Private Pool", "Shared Pool"],
          wifi: ["Wifi"],
          "wi-fi": ["Wifi"],
          "wireless internet": ["Wifi"],
          internet: ["Wifi"],
          gym: ["GYM"],
          fitness: ["GYM"],
          "fitness center": ["GYM"],
          workout: ["GYM"],
          garden: ["Garden"],
          kitchen: ["Kitchen"],
          kitchenette: ["Kitchen"],
          bar: ["Bar"],
          bathtub: ["Bathtub"],
          "bath tub": ["Bathtub"],
          jacuzzi: ["Jacuzzi"],
          "hot tub": ["Jacuzzi"],
          spa: ["Jacuzzi"],
          sauna: ["Jacuzzi"],
          wellness: ["Jacuzzi"],
          chef: ["Chef"],
          cook: ["Chef"],
          catering: ["Catering Services"],
          "catering service": ["Catering Services"],
          game: ["Game"],
          games: ["Game"],
          "game room": ["Game"],
          gazebo: ["Gazebo"],
          "power backup": ["Power Backup"],
          generator: ["Power Backup"],
          backup: ["Power Backup"],
          "property manager": ["Property Manager"],
          manager: ["Property Manager"],
          butler: ["Property Manager"],
          "butler service": ["Property Manager"],
          concierge: ["Property Manager"],
          loungers: ["Loungers"],
          lounger: ["Loungers"],
          "sun loungers": ["Loungers"],
          "beach loungers": ["Loungers"],
          "paddy field": ["Paddy Field View"],
          "paddy field view": ["Paddy Field View"],
          "rice field": ["Paddy Field View"],
          toiletries: ["Toiletries"],
          toiletry: ["Toiletries"],
          "bathroom amenities": ["Toiletries"],
          "scenic view": ["Scenic View"],
          view: ["Scenic View"],
          "beach facing": ["Scenic View"],
          "beach view": ["Scenic View"],
          "sea view": ["Scenic View"],
          "ocean view": ["Scenic View"],
          entertainment: ["Entertainment Area"],
          "entertainment area": ["Entertainment Area"],
          dj: ["Entertainment Area"],
          music: ["Entertainment Area"],
          karaoke: ["Entertainment Area"],
          "live singer": ["Entertainment Area"],
          "live music": ["Entertainment Area"],
          "live counters": ["Entertainment Area"],
          cocktail: ["Entertainment Area"],
          "cocktail workshop": ["Entertainment Area"],
          screening: ["Entertainment Area"],
          "in-villa screening": ["Entertainment Area"],
          movie: ["Entertainment Area"],
          "kids activities": ["Entertainment Area"],
          "kid's activities": ["Entertainment Area"],
          children: ["Entertainment Area"],
          bedroom: ["Bedroom"],
          "king size bed": ["Bedroom"],
          "king bed": ["Bedroom"],
          ensuite: ["Bedroom"],
          "ensuite bathroom": ["Bedroom"],
          "evening turndown": ["Evening Turndown Services"],
          turndown: ["Evening Turndown Services"],
          "turndown service": ["Evening Turndown Services"],
          housekeeping: ["Evening Turndown Services"],
          "ground floor": ["Garden"], // Fallback match
          "senior citizen": ["Property Manager"], // Fallback match
          // barbecue: ["Bar"], // Fallback match
          //  bbq: ["Bar"], // Fallback match
        };

        const findMatchingAmenityIds = (scrapedAmenity) => {
          const normalizedScraped = normalizeText(scrapedAmenity);
          const matchedIds = [];

          // Check direct mappings first
          // for (const [key, mappedAmenities] of Object.entries(directMappings)) {
          //   if (
          //     normalizedScraped.includes(key) ||
          //     key.includes(normalizedScraped)
          //   ) {
          //     mappedAmenities.forEach((mappedName) => {
          //       // Find the ID from your filteredAmenities array
          //       const amenity = filteredAmenities.find(
          //         (a) => a.name === mappedName,
          //       );
          //       if (amenity && !matchedIds.includes(amenity.id)) {
          //         matchedIds.push(amenity.id);
          //       }
          //     });
          //     if (matchedIds.length > 0) return matchedIds;
          //   }
          // }
          for (const [key, mappedAmenities] of Object.entries(directMappings)) {
            if (
              normalizedScraped.includes(key) ||
              key.includes(normalizedScraped)
            ) {
              mappedAmenities.forEach((mappedName) => {
                const amenity = filteredAmenities.find(
                  (a) => a.name === mappedName,
                );
                if (amenity && !matchedIds.includes(amenity.id)) {
                  matchedIds.push(amenity.id);
                }
              });
              if (matchedIds.length > 0) return matchedIds;
            }
          }

          // Try exact match with your amenities
          const exactMatch = filteredAmenities.find(
            (a) => normalizeText(a.name) === normalizedScraped,
          );
          if (exactMatch) return [exactMatch.id];

          // Try partial match
          const partialMatches = filteredAmenities.filter((a) => {
            const normalizedAvailable = normalizeText(a.name);
            return (
              normalizedScraped.includes(normalizedAvailable) ||
              normalizedAvailable.includes(normalizedScraped)
            );
          });

          if (partialMatches.length > 0) {
            return partialMatches.map((a) => a.id);
          }

          // Word-by-word matching
          const scrapedWords = normalizedScraped
            .split(" ")
            .filter((w) => w.length > 2);
          const wordMatches = filteredAmenities.filter((a) => {
            const availableWords = normalizeText(a.name).split(" ");
            return scrapedWords.some((scrapedWord) =>
              availableWords.some(
                (availableWord) =>
                  availableWord.includes(scrapedWord) ||
                  scrapedWord.includes(availableWord),
              ),
            );
          });

          return wordMatches.map((a) => a.id);
        };

        const allMatchedIds = [];
        const unmatchedAmenities = [];

        scrapedAmenities.forEach((scrapedAmenity) => {
          const matchedIds = findMatchingAmenityIds(scrapedAmenity);
          if (matchedIds.length > 0) {
            matchedIds.forEach((id) => {
              if (!allMatchedIds.includes(id)) {
                allMatchedIds.push(id);
              }
            });
          } else {
            unmatchedAmenities.push(scrapedAmenity);
          }
        });

        // Select all matched amenities
        setSelectedAmenities(allMatchedIds);

        // Log results
        console.log("✅ Matched Amenities:", allMatchedIds.length);
        console.log("🎯 Selected IDs:", allMatchedIds);
        if (unmatchedAmenities.length > 0) {
          console.log("⚠️ Unmatched amenities:", unmatchedAmenities);
        }

        toast.success(`${allMatchedIds.length} amenities auto-selected`);
      }

      // Set check-in/check-out times
      if (lohono.checkin || airbnb.checkin) {
        setcheckin(lohono.checkin || airbnb.checkin);
      }
      if (lohono.checkout || airbnb.checkout) {
        setcheckout(lohono.checkout || airbnb.checkout);
      }

      // Set house rules
      if (lohono.houseRules?.length > 0 || airbnb.houseRules?.length > 0) {
        const houseRules =
          lohono.houseRules?.length > 0 ? lohono.houseRules : airbnb.houseRules;
        setHouseRules(houseRules);
      }

      // Set location-specific fields
      if (lohono.location || airbnb.location) {
        setLocation(lohono.location || airbnb.location);
      }

      // Optional: Set URL for reference
      if (lohono.url || airbnb.url) {
        const url = lohono.url || airbnb.url;
        setVillaUrl(url);
        setSourceUrl(url);
      }

      // Optional: Set Airbnb-specific fields
      if (airbnb.rating) {
        setRating(airbnb.rating);
      }
      if (airbnb.reviewCount) {
        setReviewCount(airbnb.reviewCount);
      }
      if (airbnb.hostName) {
        setHostName(airbnb.hostName);
      }
      if (airbnb.cancellationPolicy) {
        setCancellationPolicy(airbnb.cancellationPolicy);
      }

      // ── Console log for debugging ──────────────────────────────────────
      console.group("🔎 Scrape Results - Data Autofilled");

      console.group("🏡 LOHONO");
      console.log("Name        :", lohono.propertyname);
      console.log("Location    :", lohono.location);
      console.log("Description :", lohono.description);
      console.log("Price       :", lohono.price);
      console.log("Bedrooms    :", lohono.bedrooms);
      console.log("Bathrooms   :", lohono.bathrooms);
      console.log("Guests      :", lohono.guests);
      console.log("Amenities   :", lohono.amenities);
      console.log("Check-in    :", lohono.checkin);
      console.log("Check-out   :", lohono.checkout);
      console.log("House Rules :", lohono.houseRules);
      console.log("URL         :", lohono.url);
      console.groupEnd();

      console.group("✈️ AIRBNB");
      console.log("Name        :", airbnb.propertyname);
      console.log("Location    :", airbnb.location);
      console.log("Description :", airbnb.description);
      console.log("Price       :", airbnb.price);
      console.log("Bedrooms    :", airbnb.bedrooms);
      console.log("Bathrooms   :", airbnb.bathrooms);
      console.log("Guests      :", airbnb.guests);
      console.log("Rating      :", airbnb.rating);
      console.log("Reviews     :", airbnb.reviewCount);
      console.log("Host        :", airbnb.hostName);
      console.log("Amenities   :", airbnb.amenities);
      console.log("Check-in    :", airbnb.checkin);
      console.log("Check-out   :", airbnb.checkout);
      console.log("Cancellation:", airbnb.cancellationPolicy);
      console.log("House Rules :", airbnb.houseRules);
      console.log("URL         :", airbnb.url);
      console.groupEnd();

      console.groupEnd();

      toast.success("Data autofilled successfully from scraped results!");
    } catch (err) {
      console.error("Scrape request failed:", err);
      toast.error("Network error during scraping.");
    }
  };

  const scrapeFilteredCities = (() => {
    const name = scrapeDestination.toLowerCase();
    if (!name) return [];

    // Reuse the same logic from handleStateChange
    if (name === "goa") {
      return [
        "Aldona",
        "Arambol",
        "Baga",
        "Bambolim",
        "Bandora",
        "Benaulim",
        "Calangute",
        "Candolim",
        "Carapur",
        "Cavelossim",
        "Chicalim",
        "Chinchinim",
        "Colovale",
        "Colva",
        "Cortalim",
        "Cuncolim",
        "Curchorem",
        "Curti",
        "Davorlim",
        "Dicholi",
        "Goa Velha",
        "Guirim",
        "Jua",
        "Kankon",
        "Madgaon",
        "Morjim",
        "Mormugao",
        "Navelim",
        "North Goa",
        "Palle",
        "Panaji",
        "Pernem",
        "Ponda",
        "Quepem",
        "Queula",
        "Raia",
        "Saligao",
        "Sancoale",
        "Sanguem",
        "Sanquelim",
        "Sanvordem",
        "Serula",
        "Solim",
        "South Goa",
        "Taleigao",
        "Vagator",
        "Valpoy",
        "Varca",
        "Vasco da Gama",
        "Anjuna",
        "Arpora",
        "Assagao",
        "Parra",
        "Siolim",
        "Reis Magos",
        "Nerul",
      ].map((city, idx) => ({ id: idx + 1, name: city }));
    }

    // For all other states, look up from indiaStates
    const stateObj = indiaStates.find((s) => s.name === scrapeDestination);
    return (
      stateObj?.cities?.map?.((c, idx) =>
        typeof c === "string" ? { id: idx + 1, name: c } : c,
      ) ?? []
    );
  })();

  return (
    <div
      className={`flex bg-[#F8F9FA] transition-all duration-500 ${
        isMobile ? "ml-0" : isSidebarOpen ? "w-[82vw]" : "w-[95vw]"
      }`}
    >
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Add New Property
            </p>
          </div>
          <div className="flex gap-4 items-center">
            <div className="mt-2">
              {villaUrl && (
                <a
                  href={villaUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 text-sm uppercase font-medium inline-flex items-center gap-1"
                >
                  Open Villa Url
                  <svg
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    className="inline-block"
                  >
                    <path
                      d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
              )}
            </div>

            <div>
              <button
                onClick={() => setShowScrapeModal(true)}
                className="border border-gray-300 bg-green-700 hover:bg-green-900 text-white py-2 px-4 rounded-lg"
              >
                Scrape Data
              </button>
            </div>
          </div>
        </div>

        <div className="my-10">
          <div className="">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center justify-between">
              <div>
                {/* goes to table "properties" as "propertyname" */}
                <input
                  type="text"
                  name="propertyname"
                  required
                  maxLength={50}
                  value={propertyname}
                  onChange={(e) => setpropertyname(e.target.value)}
                  className="text-2xl sm:text-3xl font-bold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Enter Property Name"
                />{" "}
                <p className="text-xs mt-1">
                  {propertyname.length.toString().padStart(2, "0")}/50
                </p>
                {/* goes to table "properties" as "description" */}
                <div className="my-4">
                  <textarea
                    rows="2"
                    name="description"
                    maxLength={250}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="w-full text-gray-700 text-lg  lg:w-[100%] border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    placeholder="Enter Property Description..."
                  />
                  <p className="text-xs">
                    {description.length.toString().padStart(2, "0")}/250
                  </p>
                </div>
              </div>

              <div>
                {/* Don't remove div - this is to replicate the layout and sizing of website */}
              </div>

              <div>
                <div className="mt-8 space-y-4 ">
                  {propertyThumbnail ? (
                    <>
                      <img
                        src={propertyThumbnail}
                        alt="Uploaded Map"
                        className="h-full max-h-[85vh] aspect-[5/4] w-full object-cover"
                      />

                      <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                        <div className="flex gap-1 items-center">
                          Replace Img <FcAddImage size={20} />{" "}
                        </div>
                        {/* goes to table "hotelInfo" as portraitimg */}
                        <input
                          type="file"
                          accept="image/*"
                          name="thumbnailimg"
                          onChange={handlepropertyThumbnail}
                          className="hidden aspect-[5/4] w-full"
                        />
                      </label>
                    </>
                  ) : (
                    <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
                      <FcAddImage size={50} />
                      <span className="text-sm mt-2">
                        Click to upload Thumbnail image
                      </span>
                      {/* goes to table "hotelInfo" as portraitimg */}
                      <input
                        type="file"
                        name="thumbnailimg"
                        accept="image/*"
                        onChange={handlepropertyThumbnail}
                        className="hidden aspect-[5/4] w-full"
                      />
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* Banner carousel */}
            <div className="mt-5 -mx-3">
              {/* goes to table "propertyImages" as "banner1"....till ..."banner5" */}

              <Carousel
                responsive={responsive_BannerCarousel}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={false}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[350px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {selectedImages[index] ? (
                        <>
                          <img
                            src={selectedImages[index]}
                            alt="Img"
                            className="w-full h-full object-cover"
                          />

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => handleImageUpload(e, index)}
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageUpload(e, index)}
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>

          <div className="grid grid-cols-1">
            <div className="order-1 lg:order-2 mt-5 lg:mt-10 lg:text-center">
              {/* goes to table "properties" as "heading" */}
              <input
                type="text"
                maxLength={100}
                value={heading}
                onChange={(e) => setHeading(e.target.value)}
                className="fontPD flex mx-auto text-center text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                style={{
                  letterSpacing: "1px",
                  wordSpacing: "2px",
                  lineHeight: 1.3,
                }}
                placeholder="Heading"
              />
              <p className="text-xs text-center block mt-1">
                {heading.length.toString().padStart(2, "0")}/100
              </p>

              {/* goes to table "properties" as "content" */}
              <div className="my-5 lg:my-10">
                <textarea
                  type="text"
                  rows="3"
                  maxLength={400}
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  className="flex mx-auto w-full xl:w-[950px] text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Content..."
                />
                <span className="text-xs block mt-1">
                  {content.length.toString().padStart(2, "0")}/400
                </span>
              </div>
            </div>
            {/* goes to table "properties" as "catchquote" */}

            <div className="mt-5 lg:mt-0 order-3">
              <input
                type="text"
                maxLength={100}
                value={catchyQuote}
                onChange={(e) => setCatchyQuote(e.target.value)}
                className="flex mx-auto w-full md:text-xl text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Catchy Quote"
              />
              <p className="text-xs text-center block mt-1">
                {catchyQuote.length.toString().padStart(2, "0")}/100
              </p>

              <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-5 justify-center">
                <div className="h-[1px] w-full bg-gray-300" />
                <img
                  src="../assets/zorba_logo.webp"
                  alt="Img"
                  className="h-4 w-auto"
                />
                <div className="h-[1px] w-full bg-gray-300" />
              </div>
            </div>
          </div>

          {/* Carousel of Experience */}
          <div className="mt-5 mb-10" ref={containerRef_amenities}>
            <div className="text-center mb-4">
              <h2 className="text-2xl font-semibold">Amenities</h2>
              <p className="text-gray-500 mt-1">
                {selectedAmenities.length} selected
              </p>
            </div>

            <input
              type="text"
              placeholder="Search amenities..."
              className="w-full mb-4 px-4 py-3 border rounded-lg focus:outline-none focus:ring-0 focus:border-[1.5px] focus:border-black"
              value={searchTerm}
              onFocus={() => setIsOpen_amenities(true)}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {isOpen_amenities && (
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 overflow-y-auto max-h-96">
                {filteredAmenities.map((amenity, index) => {
                  const isSelected = selectedAmenities.includes(amenity.id);

                  return (
                    <div
                      key={index}
                      onClick={() => toggleAmenity(amenity.id)}
                      className={`relative cursor-pointer rounded-xl border px-3 py-5 transition-all duration-200
                        ${
                          isSelected
                            ? "border-black shadow-md"
                            : "border-gray-200 hover:border-gray-400"
                        }`}
                    >
                      {/* Tick */}
                      {isSelected && (
                        <div className="absolute top-3 right-3 bg-green-800 text-white rounded-full p-1">
                          <Check size={16} />
                        </div>
                      )}

                      {/* Icon */}
                      <img
                        src={amenity.url}
                        alt={amenity.name}
                        className="w-auto h-20 mb-3 object-contain"
                      />

                      {/* Text */}
                      <p className="text-base font-medium">{amenity.name}</p>
                    </div>
                  );
                })}
              </div>
            )}

            <Carousel
              responsive={responsive_ExperienceCarousel}
              autoPlay={false}
              infinite
              keyBoardControl
              showDots={showDots}
              customLeftArrow={<CustomLeftArrowBannerCarousel />}
              customRightArrow={<CustomRightArrowBannerCarousel />}
            >
              {experienceData.map((item, index) => (
                <div
                  key={index}
                  className="mx-3 my-1 bg-white border rounded-xl shadow-md px-5 py-10"
                >
                  <div>
                    <div className="text-3xl text-[#99ABA0] mb-4">
                      {
                        iconOptions.find((icon) => icon.value === item.icon)
                          ?.icon
                      }
                    </div>

                    {/* goes to table "experiences" as "expimage,expimage2	,	expimage3	,	expimage4	,	expimage5"		 */}

                    <div className="grid grid-cols-1 justify-between w-full">
                      <div className="text-3xl text-[#99ABA0] mb-4">
                        {item.file ? (
                          <img
                            src={URL.createObjectURL(item.file)}
                            alt="preview"
                            className="w-12 h-12 object-contain"
                          />
                        ) : (
                          <span className="text-gray-400">No image</span>
                        )}
                      </div>

                      <div>
                        {/* goes to table "experiences" as expimage…expimage5 */}
                        <label className="block text-left text-xs font-semibold mb-1">
                          Upload Experience Icon
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const newData = [...experienceData];
                            newData[index].file = e.target.files[0];
                            setExperienceData(newData);
                          }}
                          className="w-full border p-1 mb-4 text-sm focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                        />
                      </div>
                    </div>
                  </div>
                  {/* goes to table "experiences" as "exptitle,exptitle2	,	exptitle3	,	exptitle4	,	exptitle5"		 */}
                  <input
                    type="text"
                    maxLength={25}
                    placeholder="Enter title"
                    className="w-full mb-1 text-lg font-semibold border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    value={item.title}
                    onChange={(e) => {
                      const newData = [...experienceData];
                      newData[index].title = e.target.value;
                      setExperienceData(newData);
                    }}
                  />
                  <p className="text-xs text-left block mb-3">
                    {item.title.length.toString().padStart(2, "0")}/25
                  </p>
                  {/* goes to table "experiences" as "expcon	,expcon2	,expcon3,	expcon4	,expcon5"		 */}
                  {/* <textarea
                      rows="3"
                      placeholder="Enter content..."
                      maxLength={100}
                      className="w-full text-gray-500 border p-2 resize-none border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                      value={item.content}
                      onChange={(e) => {
                        const newData = [...experienceData];
                        newData[index].content = e.target.value;
                        setExperienceData(newData);
                      }}
                    ></textarea> */}
                </div>
              ))}
            </Carousel>
          </div>

          {/* Images carousel 1 & 2 */}
          <div className="grid grid-cols-1 md:grid-cols-[40%_60%] items-center mt-5">
            <div className="md:hidden flex flex-col mb-5">
              {/* goes to table "propertyImages" as "title1" */}
              <div className="my-5">
                <input
                  type="text"
                  maxLength={30}
                  value={title1}
                  onChange={(e) => setTitle1(e.target.value)}
                  className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Title 1 (highlight property speciality)"
                />
                <p className="text-xs block mt-1">
                  {title1.length.toString().padStart(2, "0")}/30
                </p>
              </div>

              {/* goes to table "propertyImages" as "rc1" */}
              <textarea
                type="text"
                rows="2"
                maxLength={150}
                value={relevantContent1}
                onChange={(e) => setRelevantContent1(e.target.value)}
                className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Relevant Content 1..."
              />
              <p className="text-xs block mt-1">
                {relevantContent1.length.toString().padStart(2, "0")}/150
              </p>
            </div>
            {/* goes to table "propertyImages" as "img1_c1	img2_c1	img3_c1	img4_c1	img5_c1	" */}
            <div className="-mx-3 md:mx-0">
              <Carousel
                responsive={responsive_ImageCarouselOne}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[400px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {imageCarouselOne[index] ? (
                        <>
                          <img
                            src={imageCarouselOne[index]}
                            alt={`Uploaded ${index}`}
                            className="w-full h-full object-cover"
                          />

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselOne(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUploadCarouselOne(e, index)
                            }
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>

            {/* goes to table "propertyImages" as "img1_c2	img2_c2	img3_c2	img4_c2	img5_c2	" */}

            <div className="hidden md:block">
              <Carousel
                responsive={responsive_ImageCarouselTwo}
                autoPlay={false}
                autoPlaySpeed={5000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[400px] md:h-[600px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {imageCarouselTwo[index] ? (
                        <>
                          <img
                            src={imageCarouselTwo[index]}
                            alt={`Uploaded ${index}`}
                            className="w-full h-full object-cover"
                          />

                          {/* Replace Image Label */}
                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselTwo(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUploadCarouselTwo(e, index)
                            }
                            className="hidden"
                          />
                        </label>
                      )}

                      {/* Card Number */}
                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>

              <div className="flex flex-col mx-3">
                {/* goes to table "propertyImages" as "title1" */}
                <div className="my-5">
                  <input
                    type="text"
                    name="title1"
                    value={title1}
                    onChange={(e) => setTitle1(e.target.value)}
                    maxLength={30}
                    className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    placeholder="Title 1 (highlight property speciality)"
                  />
                  <p className="text-xs block mt-1">
                    {title1.length.toString().padStart(2, "0")}/30
                  </p>
                </div>

                {/* goes to table "propertyImages" as "rc1" */}
                <textarea
                  type="text"
                  rows="2"
                  name="rc1"
                  maxLength={150}
                  value={relevantContent1}
                  onChange={(e) => setRelevantContent1(e.target.value)}
                  className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Relevant Content 1..."
                />
                <p className="text-xs block mt-1">
                  {relevantContent1.length.toString().padStart(2, "0")}/150
                </p>
              </div>
            </div>
          </div>

          {/* Images carousel 3 & 4 */}
          <div className="grid grid-cols-1 md:grid-cols-[60%_40%] items-center mt-8">
            {/* for small screen */}
            <div className="md:hidden flex flex-col mb-5">
              {/* goes to table "propertyImages" as "title2" */}
              <div className="my-5">
                <input
                  type="text"
                  maxLength={30}
                  value={title2}
                  onChange={(e) => setTitle2(e.target.value)}
                  className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Title 2 (highlight property speciality)"
                />
                <p className="text-xs block mt-1">
                  {title2.length.toString().padStart(2, "0")}/30
                </p>
              </div>
              {/* goes to table "propertyImages" as "rc2" */}
              <textarea
                type="text"
                rows="2"
                maxLength={150}
                value={content2}
                onChange={(e) => setContent2(e.target.value)}
                className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Relevant Content 2..."
              />
              <p className="text-xs block mt-1">
                {content2.length.toString().padStart(3, "0")}/150
              </p>
            </div>

            {/* goes to table "propertyImages" as "img1_c3	img2_c3	img3_c3	img4_c3	img5_c3	" */}
            <div className="hidden md:block">
              <Carousel
                responsive={responsive_ImageCarouselThree}
                autoPlay={false}
                autoPlaySpeed={5000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[600px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {imageCarouselThree[index] ? (
                        <>
                          <img
                            src={imageCarouselThree[index]}
                            alt={`Uploaded ${index}`}
                            className="w-full h-full object-cover"
                          />

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselThree(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUploadCarouselThree(e, index)
                            }
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>

              <div className="flex flex-col mx-3">
                {/* goes to table "propertyImages" as "title2" */}
                <div className="my-5">
                  <input
                    type="text"
                    name="title2"
                    maxLength={30}
                    value={title2}
                    onChange={(e) => setTitle2(e.target.value)}
                    className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    placeholder="Title 2 (highlight property speciality)"
                  />
                  <p className="text-xs block mt-1">
                    {title2.length.toString().padStart(2, "0")}/30
                  </p>
                </div>

                {/* goes to table "propertyImages" as "rc2" */}
                <textarea
                  type="text"
                  rows="2"
                  name="rc2"
                  maxLength={150}
                  value={content2}
                  onChange={(e) => setContent2(e.target.value)}
                  className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Relevant Content 2..."
                />
                <p className="text-xs block mt-1">
                  {content2.length.toString().padStart(3, "0")}/150
                </p>
              </div>
            </div>

            {/* goes to table "propertyImages" as "img1_c4	img2_c4	img3_c4	img4_c4	img5_c4	" */}
            <div className="-mx-3 md:mx-0">
              <Carousel
                responsive={responsive_ImageCarouselFour}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[400px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {imageCarouselFour[index] ? (
                        <>
                          <img
                            src={imageCarouselFour[index]}
                            alt={`Uploaded ${index}`}
                            className="w-full h-full object-cover"
                          />

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselFour(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUploadCarouselFour(e, index)
                            }
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>

          {/* Images carousel 5 */}
          <div className="grid grid-cols-1 mt-8">
            <div className="-mx-3 md:mx-0 order-2 md:order-1">
              {/* goes to table "propertyImages" as "mg1_C5	img2_c5	img3_c5	img4_c5	img5_c5	" */}
              <Carousel
                responsive={responsive_ImageCarouselFive}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowBannerCarousel />}
                customRightArrow={<CustomRightArrowBannerCarousel />}
              >
                {[...Array(MAX_CARDS)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="flex flex-col items-center justify-between w-full h-[250px] md:h-[520px] bg-white border-dashed border-2 border-gray-400 relative overflow-hidden">
                      {imageCarouselFive[index] ? (
                        <>
                          <img
                            src={imageCarouselFive[index]}
                            alt={`Uploaded ${index}`}
                            className="w-full h-full object-cover"
                          />

                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleImageUploadCarouselFive(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUploadCarouselFive(e, index)
                            }
                            className="hidden"
                          />
                        </label>
                      )}

                      <div className="absolute bottom-1 right-2 text-sm font-semibold text-black/60 bg-white/70 rounded px-2 py-0.5">
                        {index + 1}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>

            {/* goes to table "propertyImages" as "title3" */}
            <div className="flex flex-col mb-5 md:mb-0 md:mx-3 order-1 md:order-2 md:w-[55%]">
              <div className="my-5">
                <input
                  type="text"
                  maxLength={30}
                  value={title3}
                  onChange={(e) => setTitle3(e.target.value)}
                  className="w-full text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Title 3 (highlight property speciality)"
                />
                <p className="text-xs block mt-1">
                  {title3.length.toString().padStart(2, "0")}/30
                </p>
              </div>

              {/* goes to table "propertyImages" as "rc3" */}
              <textarea
                type="text"
                rows="2"
                maxLength={150}
                value={relevantContent3}
                onChange={(e) => setRelevantContent3(e.target.value)}
                className="border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                placeholder="Relevant Content 3..."
              />
              <p className="text-xs block mt-1">
                {relevantContent3.length.toString().padStart(2, "0")}/150
              </p>
            </div>
          </div>

          <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 justify-center">
            <div className="h-[1px] w-full bg-gray-300" />
            <img
              src="../assets/zorba_logo.webp"
              alt="Img"
              className="h-4 w-auto"
            />
            <div className="h-[1px] w-full bg-gray-300" />
          </div>

          {/* Map */}
          <div className="">
            <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
              <div>
                {/* goes to table "propertyImages" as maptitle */}
                <textarea
                  type="text"
                  maxLength={50}
                  value={maptitle}
                  onChange={(e) => setmaptitle(e.target.value)}
                  rows={2}
                  className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  style={{
                    letterSpacing: "1px",
                    wordSpacing: "2px",
                    lineHeight: 1.3,
                  }}
                  placeholder="Map Title"
                />
                <p className="text-xs block">
                  {maptitle.length.toString().padStart(2, "0")}/50
                </p>
              </div>

              <div>
                {/* goes to table "propertyImages" as mapcontent */}
                <textarea
                  type="text"
                  maxLength={150}
                  value={mapcontent}
                  onChange={(e) => setmapcontent(e.target.value)}
                  rows={4}
                  className="w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  placeholder="Map Content..."
                />
                <p className="text-xs block">
                  {mapcontent.length.toString().padStart(2, "0")}/150
                </p>
              </div>
            </div>
            {/* here i want two input feilds mapLan and maplong */}
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Map Latitude (maplang)
                </label>
                <input
                  type="number"
                  step="0.00000001"
                  name="maplang"
                  placeholder="Enter Latitude"
                  className="w-full text-2xl md:text-3xl lg:text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Map Longitude (maplong)
                </label>
                <input
                  type="number"
                  step="0.00000001"
                  name="maplong"
                  placeholder="Enter Longitude"
                  className="w-full text-2xl md:text-3xl lg:text-xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                />
              </div>
            </div>
            {/* <div className="mt-5">
              {uploadedMap ? (
                <>
                  <img
                    src={uploadedMap}
                    alt="Uploaded Map"
                    className="w-full object-contain"
                  />

                  <label className="mt-2 inline-block text-sm text-gray-600 bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                    <div className="flex gap-1 items-center">
                      Replace Map <FcAddImage size={20} />{" "}
                    </div>

                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleMapUpload}
                      className="hidden"
                    />
                  </label>
                </>
              ) : (
                <label className="flex flex-col items-center justify-center w-full h-[250px] border-2 border-dashed border-gray-400 cursor-pointer">
                  <FcAddImage size={50} />
                  <span className="text-sm mt-2">
                    Click to upload map image
                  </span>

                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleMapUpload}
                    className="hidden"
                  />
                </label>
              )}

            </div> */}
          </div>

          <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 md:my-12 justify-center">
            <div className="h-[1px] w-full bg-gray-300" />
            <img
              src="../assets/zorba_logo.webp"
              alt="Img"
              className="h-4 w-auto"
            />
            <div className="h-[1px] w-full bg-gray-300" />
          </div>

          {/* Experience */}
          <div className="text-center">
            {/* goes to table "properties" as "aboutloc" */}
            <input
              type="text"
              maxLength={20}
              value={aboutlocation}
              onChange={(e) => setaboutlocation(e.target.value)}
              placeholder="About the location"
              className="text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
            />
            <p className="text-xs block mt-1">
              {aboutlocation.length.toString().padStart(2, "0")}/20
            </p>
            <br />

            {/* goes to table "properties" as "loctagline" */}
            <input
              type="text"
              placeholder="Location Tagline"
              maxLength={30}
              value={locationTagline}
              onChange={(e) => setLocationTagline(e.target.value)}
              className="mt-3 text-2xl md:text-3xl lg:text-4xl text-center border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
              style={{
                letterSpacing: "1px",
                wordSpacing: "2px",
                lineHeight: 1.3,
              }}
            />
            <p className="text-xs block mt-1">
              {locationTagline.length.toString().padStart(2, "0")}/30
            </p>
            <br />

            {/* goes to table "properties" as "loccontent" */}
            <div className="my-5">
              <input
                type="text"
                placeholder="Content..."
                maxLength={100}
                value={locationContent}
                onChange={(e) => setLocationContent(e.target.value)}
                className="flex mx-auto w-full lg:w-[800px] font-thin text-center text-gray-500 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                style={{ lineHeight: 2 }}
              />
              <p className="text-xs block mt-1 text-center">
                {locationContent.length.toString().padStart(2, "0")}/100
              </p>
            </div>
            {/* Concierge Service */}
            <div className="my-5">
              <input
                type="text"
                // maxLength={20}
                value={conciergeService}
                onChange={(e) => setConciergeService(e.target.value)}
                placeholder=" Concierge Services PDF"
                className="text-center border-b lg:w-[400px] border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
              />

              <p className="text-xs block mt-1">*paste PDF drive link here*</p>
            </div>
            {/* <button
                className="zorba_btn text-sm uppercase"
                style={{ "--clr": "#1B2826" }}
              >
                Concierge Services
                <span className="zorba_btn__icon-wrapper">
                  <svg
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="zorba_btn__icon-svg"
                    width="10"
                  >
                    <path
                      d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      fill="currentColor"
                    ></path>
                  </svg>

                  <svg
                    viewBox="0 0 14 15"
                    fill="none"
                    width="10"
                    xmlns="http://www.w3.org/2000/svg"
                    className="zorba_btn__icon-svg zorba_btn__icon-svg--copy"
                  >
                    <path
                      d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
              </button> */}

            <div className="mt-8 space-y-4 ">
              {gridImg_fullWidth ? (
                <div
                  className="relative w-full h-80 bg-cover bg-center "
                  style={{ backgroundImage: `url(${gridImg_fullWidth})` }}
                >
                  <label className="absolute bottom-2 left-2 text-sm bg-white/70 px-3 py-1 rounded cursor-pointer hover:underline">
                    <div className="flex gap-1 items-center ">
                      Replace <FcAddImage size={20} />
                    </div>
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) =>
                        handleMediaUpload_gridImages(e, setGridImg_fullWidth)
                      }
                    />
                  </label>
                </div>
              ) : (
                <label className="flex flex-col items-center justify-center w-full h-80 border-2 border-dashed border-gray-400 cursor-pointer">
                  <FcAddImage size={50} />
                  <span className="text-sm mt-2">
                    Click to upload full image
                  </span>
                  {/* goes to table "propertyImages" as  "imagegrid1" */}
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) =>
                      handleMediaUpload_gridImages(e, setGridImg_fullWidth)
                    }
                  />
                </label>
              )}

              <div className="grid grid-cols-2 gap-3">
                {[
                  { img: gridImg1, setter: setGridImg1 },
                  { img: gridImg2, setter: setGridImg2 },
                ].map((item, i) =>
                  item.img ? (
                    <div
                      key={i}
                      className="relative w-full h-48 md:h-72 bg-cover bg-center"
                      style={{ backgroundImage: `url(${item.img})` }}
                    >
                      <label className="absolute bottom-2 left-2 text-xs bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                        <div className="flex gap-1 items-center">
                          Replace <FcAddImage size={16} />
                        </div>
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={(e) =>
                            handleMediaUpload_gridImages(e, item.setter)
                          }
                        />
                      </label>
                    </div>
                  ) : (
                    <label
                      key={i}
                      className="flex flex-col items-center justify-center w-full h-48 md:h-72 border-2 border-dashed border-gray-400 cursor-pointer"
                    >
                      <FcAddImage size={40} />
                      <span className="text-xs mt-2">
                        Click to upload image
                      </span>
                      {/* goes to table "propertyImages" as  "imagegrid2,imagegrid3" */}
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) =>
                          handleMediaUpload_gridImages(e, item.setter)
                        }
                      />
                    </label>
                  ),
                )}
              </div>
            </div>
          </div>

          <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 md:my-12 justify-center">
            <div className="h-[1px] w-full bg-gray-300" />
            <img
              src="../assets/zorba_logo.webp"
              alt="Img"
              className="h-4 w-auto"
            />
            <div className="h-[1px] w-full bg-gray-300" />
          </div>

          {/* Tailored Experience */}
          <div className="">
            <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-5">
              <div>
                {/* goes to table "experiences" as "expnamemain" */}
                <input
                  type="text"
                  placeholder="Experience"
                  maxLength={50}
                  value={tailoredExperience}
                  onChange={(e) => setTailoredExperience(e.target.value)}
                  className="w-full text-2xl md:text-3xl lg:text-4xl border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                  style={{
                    letterSpacing: "1px",
                    wordSpacing: "2px",
                    lineHeight: 1.3,
                  }}
                />
                <p className="text-xs block mt-1">
                  {tailoredExperience.length.toString().padStart(2, "0")}/50
                </p>

                {/* goes to table "experiences" as "expcontentmain" */}
                <textarea
                  type="text"
                  rows={2}
                  placeholder="Content..."
                  value={tailoredExperienceContent}
                  onChange={(e) => setTailoredExperienceContent(e.target.value)}
                  maxLength={150}
                  className="mt-3 w-full border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                />
                <p className="text-xs block">
                  {tailoredExperienceContent.length.toString().padStart(2, "0")}
                  /150
                </p>
              </div>

              <div className="flex lg:justify-end">
                <button
                  className="zorba_btn text-sm uppercase"
                  style={{ "--clr": "#1B2826" }}
                >
                  Plan your next trip
                  <span className="zorba_btn__icon-wrapper">
                    <svg
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="zorba_btn__icon-svg"
                      width="10"
                    >
                      <path
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                        fill="currentColor"
                      ></path>
                    </svg>

                    <svg
                      viewBox="0 0 14 15"
                      fill="none"
                      width="10"
                      xmlns="http://www.w3.org/2000/svg"
                      className="zorba_btn__icon-svg zorba_btn__icon-svg--copy"
                    >
                      <path
                        d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span>
                </button>
              </div>
            </div>

            {/* Carousel of Tailored Experience */}
            <div className="mt-5 -mx-3">
              {/* goes to table "experiences" as "miniexpimg1	and miniexpimg2" */}
              <Carousel
                ref={carouselRef}
                responsive={responsive_TailoredExpCarousel}
                autoPlay={false}
                autoPlaySpeed={3000}
                infinite
                keyBoardControl
                showDots={showDots}
                customLeftArrow={<CustomLeftArrowTailoredExpCarousel />}
                customRightArrow={<CustomRightArrowTailoredExpCarousel />}
                beforeChange={(nextSlide) => setActiveCardIndex(nextSlide)}
              >
                {[...Array(MAX_CARDS_Exp)].map((_, index) => (
                  <div key={index} className="mx-3">
                    <div className="relative w-full h-[350px] border-2 border-dashed border-gray-400 overflow-hidden">
                      {tailoredExpData[index]?.img ? (
                        <>
                          <img
                            src={tailoredExpData[index].img}
                            alt="Img"
                            className="w-full h-full object-cover"
                          />
                          <label className="absolute bottom-1 left-2 text-xs font-medium text-gray-600 bg-white/70 px-2 py-0.5 rounded cursor-pointer hover:underline">
                            <div className="flex gap-1 items-center">
                              Replace <FcAddImage size={20} />
                            </div>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const newData = [...tailoredExpData];
                                  newData[index].img =
                                    URL.createObjectURL(file); // preview
                                  newData[index].file = file; // actual File for backend
                                  setTailoredExpData(newData);
                                }
                              }}
                              className="hidden"
                            />
                          </label>
                        </>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-full h-full cursor-pointer">
                          <FcAddImage size={50} />
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const newData = [...tailoredExpData];
                                newData[index].img = URL.createObjectURL(file);
                                newData[index].file = file;
                                setTailoredExpData(newData);
                              }
                            }}
                            className="hidden"
                          />
                        </label>
                      )}
                    </div>

                    <input
                      type="text"
                      maxLength={50}
                      placeholder="Experience Title"
                      value={tailoredExpData[index]?.title || ""}
                      onChange={(e) => {
                        const newData = [...tailoredExpData];
                        newData[index].title = e.target.value;
                        setTailoredExpData(newData);
                      }}
                      className="w-full text-xl mt-5 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                    />
                    <p className="text-xs block mt-1">
                      {(tailoredExpData[index]?.title?.length || 0)
                        .toString()
                        .padStart(2, "0")}
                      /50
                    </p>
                    <br />

                    <div className="my-5">
                      <textarea
                        rows={2}
                        placeholder="Experience Content..."
                        maxLength={100}
                        value={tailoredExpData[index]?.content || ""}
                        onChange={(e) => {
                          const newData = [...tailoredExpData];
                          newData[index].content = e.target.value;
                          setTailoredExpData(newData);
                        }}
                        className="w-full text-gray-500 border-b border-l-0 border-r-0 border-t-0 focus:ring-0 focus:border-b-2 focus:border-black placeholder:text-gray-400"
                      />
                      <p className="text-xs block">
                        {(tailoredExpData[index]?.content?.length || 0)
                          .toString()
                          .padStart(2, "0")}
                        /100
                      </p>
                    </div>
                  </div>
                ))}
              </Carousel>

              <div className="flex gap-5 items-center justify-center md:hidden text-sm text-gray-400 mt-3">
                <FaChevronLeft
                  onClick={handlePrevSlide}
                  className="cursor-pointer"
                />
                Showing {(activeCardIndex % TailoredExpCarousel.length) + 1} /
                {TailoredExpCarousel.length}
                <FaChevronRight
                  onClick={handleNextSlide}
                  className="cursor-pointer"
                />
              </div>
            </div>
          </div>

          <div className="flex gap-3 items-center mx-[10%] md:mx-[25%] my-8 md:my-12 justify-center">
            <div className="h-[1px] w-full bg-gray-300" />
            <img
              src="../assets/zorba_logo.webp"
              alt="Img"
              className="h-4 w-auto"
            />
            <div className="h-[1px] w-full bg-gray-300" />
          </div>

          {/* Data not to be shown in website */}
          <div>
            <p className="text-lg text-center mb-8">
              Additional Required Data{" "}
              <i>(not to be displayed on the website)</i>
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-5">
              <div className="flex flex-col w-full">
                {/* goes to table properties as propertycode */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property Code <sub className="text-red-500 text-base">*</sub>
                </label>
                <input
                  placeholder="Enter property code"
                  name="input"
                  required
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>
              {/* Id for air bnb */}
              <div className="flex flex-col w-full">
                {/* goes to table properties as airid */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property id
                </label>
                <input
                  placeholder="Airbnb id if available"
                  name="airid"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>
              <div className="flex flex-col w-full">
                {/* goes to table properties as youtubelink */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property's Owner name
                </label>
                <input
                  placeholder="Enter Owner's name"
                  name="propertyowner"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>
              <div className="flex flex-col w-full">
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Property Brochure
                </label>
                <input
                  placeholder="Enter Drive Link"
                  name="propertybrochure"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>
              <div className="flex flex-col w-full">
                {/* goes to table properties as currentprice */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Current Price
                </label>
                <input
                  placeholder="Enter current price"
                  name="input"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as defaultprice */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Default Price
                </label>
                <input
                  placeholder="Enter default price"
                  name="input"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as deposit */}

                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Security Deposit
                </label>
                <input
                  placeholder="Enter security deposit"
                  name="input"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as maxadult */}

                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Adults
                </label>
                <input
                  placeholder="Enter max adults"
                  name="input"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as maxchild */}

                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Children
                </label>
                <input
                  placeholder="Enter max children"
                  name="input"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as maxbed */}

                <label
                  htmlFor="maxbedroom"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Bedroom
                </label>
                <input
                  id="maxbedroom"
                  name="maxbedroom"
                  placeholder="Enter max bedroom"
                  value={maxbedrooms}
                  onChange={(e) => setmaxbedrooms(e.target.value)}
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as maxbath */}

                <label
                  htmlFor="maxbathroom"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Max Bathroom
                </label>
                <input
                  id="maxbathroom"
                  name="maxbathroom"
                  placeholder="Enter max bathroom"
                  value={maxbathrooms}
                  onChange={(e) => setmaxbathrooms(e.target.value)}
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as maplink */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Map Location
                </label>
                <input
                  placeholder="Enter map location"
                  name="input"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as youtubelink */}
                <label
                  for="input"
                  className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit"
                >
                  Youtube Link
                </label>
                <input
                  placeholder="Enter youtube link"
                  name="input"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                />
              </div>

              {/*
              <div className="relative w-full" ref={dropdownRef_dropdownExp}>
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Experience
                </label>

                <div
                  onClick={() => setIsOpen_dropdownExp((prev) => !prev)}
                  className="border border-gray-400 p-3 rounded-lg w-full cursor-pointer text-sm bg-[#F8F9FA] focus:outline-none"
                >
                  {selectedOptions_dropdownExp.length > 0
                    ? selectedOptions_dropdownExp.join(", ")
                    : "Select your experience(s)"}
                </div>

                {isOpen_dropdownExp && (
                  <div className="absolute top-full left-0 w-full bg-[#F8F9FA] border border-gray-300 mt-1 rounded-md shadow-md z-10">
                    {options_dropdownExp.map((option) => (
                      <label
                        key={option}
                        className="flex items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          checked={selectedOptions_dropdownExp.includes(option)}
                          onChange={() => toggleOption_dropdownExp(option)}
                          className="accent-black"
                        />
                        {option}
                      </label>
                    ))}
                  </div>
                )}
              </div> */}
              <div className="flex flex-col w-full">
                {/* goes to table properties as seasonType */}
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Season Type
                </label>

                <select
                  name="seasonType"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="">Select season type</option>
                  <option value="Summer">Summer</option>
                  <option value="Winter">Winter</option>
                  <option value="Monsoon">Monsoon</option>
                </select>
              </div>

              <div className="flex flex-col w-full">
                {/* goes to table properties as propertytype */}
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Property Type<sub className="text-red-500 text-base">*</sub>
                </label>

                <select
                  name="propertytype"
                  required
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  {/* <option value="">Select your property type</option> */}
                  <option value="Villa">Villa</option>
                  {/* <option value="Hotel">Hotel</option> */}
                  {/* <option value="Resort">Resort</option>
                  <option value="Apartment">Apartment</option> */}
                </select>
              </div>

              {/* <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Destination
                </label>

                <select className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                  <option value="">Select your destination</option>
                  <option value="Goa">Goa</option>
                  <option value="Himachal Pradesh">Himachal Pradesh</option>
                  <option value="Uttarakhand">Uttarakhand</option>
                  <option value="Leh Ladakh">Leh Ladakh</option>
                  <option value="Rajasthan">Rajasthan</option>
                  <option value="Gujarat">Gujarat</option>
                  <option value="Jammu Kashmir">Jammu Kashmir</option>
                </select>
              </div>

              <div className="flex flex-col w-full">

                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Select Location
                </label>

                <select className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
                  <option value="">Select your location</option>
                  <option value="Panaji">Panaji</option>
                  <option value="Margao">Margao</option>
                  <option value="Vasco da Gama">Vasco da Gama</option>
                  <option value="Mapusa">Mapusa</option>
                  <option value="Ponda">Ponda</option>

                  <option value="Shimla">Shimla</option>
                  <option value="Manali">Manali</option>
                  <option value="Dharamshala">Dharamshala</option>
                  <option value="Kullu">Kullu</option>
                  <option value="Solan">Solan</option>
                  <option value="Mandi">Mandi</option>
                  <option value="Chamba">Chamba</option>
                  <option value="Bilaspur">Bilaspur</option>

                  <option value="Dehradun">Dehradun</option>
                  <option value="Haridwar">Haridwar</option>
                  <option value="Rishikesh">Rishikesh</option>
                  <option value="Nainital">Nainital</option>
                  <option value="Mussoorie">Mussoorie</option>
                  <option value="Almora">Almora</option>
                  <option value="Haldwani">Haldwani</option>
                  <option value="Kedarnath">Kedarnath</option>
                  <option value="Badrinath">Badrinath</option>

                  <option value="Leh">Leh</option>
                  <option value="Kargil">Kargil</option>
                  <option value="Nubra Valley">Nubra Valley</option>
                  <option value="Zanskar">Zanskar</option>
                  <option value="Diskit">Diskit</option>
                  <option value="Padum">Padum</option>
                  <option value="Jaipur">Jaipur</option>
                  <option value="Udaipur">Udaipur</option>
                  <option value="Jodhpur">Jodhpur</option>
                  <option value="Jaisalmer">Jaisalmer</option>
                  <option value="Ajmer">Ajmer</option>
                  <option value="Pushkar">Pushkar</option>
                  <option value="Bikaner">Bikaner</option>
                  <option value="Kota">Kota</option>
                  <option value="Mount Abu">Mount Abu</option>
                  <option value="Chittorgarh">Chittorgarh</option>
                  <option value="Ahmedabad">Ahmedabad</option>
                  <option value="Surat">Surat</option>
                  <option value="Vadodara">Vadodara</option>
                  <option value="Rajkot">Rajkot</option>
                  <option value="Bhavnagar">Bhavnagar</option>
                  <option value="Junagadh">Junagadh</option>
                  <option value="Gandhinagar">Gandhinagar</option>
                  <option value="Dwarka">Dwarka</option>
                  <option value="Somnath">Somnath</option>
                  <option value="Kutch">Kutch</option>
                  <option value="Srinagar">Srinagar</option>
                  <option value="Jammu">Jammu</option>
                  <option value="Anantnag">Anantnag</option>
                  <option value="Baramulla">Baramulla</option>
                  <option value="Pulwama">Pulwama</option>
                  <option value="Kupwara">Kupwara</option>
                  <option value="Kathua">Kathua</option>
                  <option value="Pahalgam">Pahalgam</option>
                  <option value="Gulmarg">Gulmarg</option>
                  <option value="Sonmarg">Sonmarg</option>
                </select>
              </div> */}

              {/* Destination (State) */}
              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Destination<sub className="text-red-500 text-base">*</sub>
                </label>
                <select
                  name="destination"
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                  value={selectedState}
                  onChange={handleStateChange}
                  required
                >
                  <option value="">Select your destination</option>
                  {indiaStates.map((state) => (
                    <option key={state.id} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Location (City) */}
              <div className="flex flex-col w-full">
                <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-[#F8F9FA] w-fit">
                  Select Location{" "}
                  <sub className="text-red-500 text-base">*</sub>
                </label>
                <select
                  name="location"
                  required
                  value={selectedCity}
                  onChange={(e) => setSelectedCity(e.target.value)}
                  className="bg-[#F8F9FA] border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
                >
                  <option value="">Select your location</option>
                  {cities.map((city) => (
                    <option key={city.id} value={city.name}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 mt-10 w-72">
              <button
                onClick={() => navigate("/Properties")}
                className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
              >
                Cancel
              </button>

              <button
                onClick={handleSave}
                disabled={loading}
                className={`px-6 z-30 py-2 rounded-lg text-center text-white relative transition-all duration-700 text-sm ${
                  loading
                    ? "bg-green-700 cursor-not-allowed"
                    : "bg-green-900 hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700"
                }`}
                // className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
              >
                {/* Save */}
                {loading ? (
                  <div className="flex items-center justify-center space-x-2">
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      ></path>
                    </svg>
                    <span>Saving...</span>
                  </div>
                ) : (
                  "Save"
                )}
              </button>
            </div>
            {showScrapeModal && (
              <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                <div className="bg-white rounded-xl border border-gray-200 p-6 w-full max-w-md shadow-lg">
                  <div className="flex items-center justify-between mb-5">
                    <h2 className="text-base font-medium text-gray-900">
                      Scrape property data
                    </h2>
                    <button
                      onClick={() => setShowScrapeModal(false)}
                      className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg p-1"
                    >
                      ✕
                    </button>
                  </div>

                  {/* Form fields */}
                  <div className="grid grid-cols-2 gap-3 mb-3">
                    <div className="col-span-2">
                      <label className="block text-xs font-medium text-gray-500 mb-1">
                        Property name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={propertyname}
                        onChange={(e) => setpropertyname(e.target.value)}
                        placeholder="e.g. Villa Serenity"
                        className="w-full border border-gray-200 rounded-lg px-3 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-500 mb-1">
                        Property type <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="propertytype"
                        className="w-full border border-gray-200 rounded-lg px-3 h-9 text-sm"
                      >
                        <option value="">Select property type</option>
                        <option value="Villa">Villa</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-500 mb-1">
                        Destination <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={scrapeDestination}
                        onChange={(e) => {
                          setScrapeDestination(e.target.value);
                          setScrapeLocation(""); // reset when destination changes
                        }}
                        className="w-full border border-gray-200 rounded-lg px-3 h-9 text-sm"
                      >
                        <option value="">Select destination</option>
                        {indiaStates.map((state) => (
                          <option key={state.id} value={state.name}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-span-2">
                      <label className="block text-xs font-medium text-gray-500 mb-1">
                        Location <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={scrapeLocation}
                        onChange={(e) => setScrapeLocation(e.target.value)}
                        className="w-full border border-gray-200 rounded-lg px-3 h-9 text-sm"
                      >
                        <option value="">Select location</option>
                        {scrapeFilteredCities.map((city) => (
                          <option key={city.id} value={city.name}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <hr className="border-gray-100 my-4" />

                  <div className="mb-5">
                    <label className="block text-xs font-medium text-gray-500 mb-1">
                      Airbnb listing ID{" "}
                      <span className="text-xs bg-gray-100 text-gray-400 rounded px-1 py-0.5 ml-1">
                        optional
                      </span>
                    </label>
                    <div className="flex gap-2">
                      <input
                        type="text"
                        value={scrapeAirbnbId}
                        onChange={(e) => setScrapeAirbnbId(e.target.value)}
                        placeholder="e.g. 1038950877730350817"
                        className="flex-1 border border-gray-200 rounded-lg px-3 h-9 text-sm"
                      />
                      {scrapeAirbnbId && (
                        <a
                          href={`https://www.airbnb.co.in/rooms/${scrapeAirbnbId}`}
                          target="_blank"
                          rel="noreferrer"
                          className="text-xs text-blue-600 bg-blue-50 border border-blue-200 rounded-lg px-3 h-9 flex items-center gap-1 whitespace-nowrap"
                        >
                          ↗ Preview
                        </a>
                      )}
                    </div>
                    <p className="text-xs text-gray-400 mt-1">
                      If provided, Airbnb details will be scraped and merged
                      with Lohono data.
                    </p>
                  </div>

                  <hr className="border-gray-100 mb-4" />

                  <div className="flex justify-end gap-2">
                    <button
                      onClick={() => setShowScrapeModal(false)}
                      className="border border-gray-200 text-gray-500 px-4 h-9 rounded-lg text-sm"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        setShowScrapeModal(false);
                        handleScrapeData();
                      }}
                      className="bg-green-700 hover:bg-green-900 text-white px-5 h-9 rounded-lg text-sm font-medium"
                    >
                      Scrape data
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default PropertyScraperElementor;
